webpackJsonp([118785002076118],{

/***/ 695:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var PropTypes = _interopDefault(__webpack_require__(3));
	
	var CountryRegionData = [["Afghanistan","AF","Badakhshan~BDS|Badghis~BDG|Baghlan~BGL|Balkh~BAL|Bamyan~BAM|Daykundi~DAY|Farah~FRA|Faryab~FYB|Ghazni~GHA|Ghor~GHO|Helmand~HEL|Herat~HER|Jowzjan~JOW|Kabul~KAB|Kandahar~KAN|Kapisa~KAP|Khost~KHO|Kunar~KNR|Kunduz~KDZ|Laghman~LAG|Logar~LOW|Maidan Wardak~WAR|Nangarhar~NAN|Nimruz~NIM|Nuristan~NUR|Paktia~PIA|Paktika~PKA|Panjshir~PAN|Parwan~PAR|Samangan~SAM|Sar-e Pol~SAR|Takhar~TAK|Urozgan~ORU|Zabul~ZAB"],["Åland Islands","AX","Brändö~BR|Eckerö~EC|Finström~FN|Föglö~FG|Geta~GT|Hammarland~HM|Jomala~JM|Kumlinge~KM|Kökar~KK|Lemland~LE|Lumparland~LU|Mariehamn~MH|Saltvik~SV|Sottunga~ST|Sund~SD|Vårdö~VR"],["Albania","AL","Berat~01|Dibër~09|Durrës~02|Elbasan~03|Fier~04|Gjirokastër~05|Korçë~06|Kukës~07|Lezhë~08|Shkodër~10|Tirana~11|Vlorë~12"],["Algeria","DZ","Adrar~01|Aïn Defla~44|Aïn Témouchent~46|Algiers~16|Annaba~23|Batna~05|Béchar~08|Béjaïa~06|Biskra~07|Blida~09|Bordj Bou Arréridj~34|Bouïra~10|Boumerdès~35|Chlef~02|Constantine~25|Djelfa~17|El Bayadh~32|El Oued~39|El Tarf~36|Ghardaïa~47|Guelma~24|Illizi~33|Jijel~18|Khenchela~40|Laghouat~03|Mascara~29|Médéa~26|Mila~43|Mostaganem~27|Msila~28|Naâma~45|Oran~31|Ouargla~30|Oum el Bouaghi~04|Relizane~48|Saïda~20|Sétif~19|Sidi Bel Abbès~22|Skikda~21|Souk Ahras~41|Tamanghasset~11|Tébessa~12|Tiaret~14|Tindouf~37|Tipaza~42|Tissemsilt~38|Tizi Ouzou~15|Tlemcen~13"],["American Samoa","AS","Tutuila~01|Aunu'u~02|Ta'ū~03|Ofu‑Olosega~04|Rose Atoll~21|Swains Island~22"],["Andorra","AD","Andorra la Vella~07|Canillo~02|Encamp~03|Escaldes-Engordany~08|La Massana~04|Ordino~05|Sant Julià de Lòria~06"],["Angola","AO","Bengo~BGO|Benguela~BGU|Bié~BIE|Cabinda~CAB|Cuando Cubango~CCU|Cuanza Norte~CNO|Cuanza Sul~CUS|Cunene~CNN|Huambo~HUA|Huíla~HUI|Luanda~LUA|Lunda Norte~LNO|Lunda Sul~LSU|Malanje~MAL|Moxico~MOX|Namibe~NAM|Uíge~UIG|Zaire~ZAI"],["Anguilla","AI","Anguilla~01|Anguillita Island~02|Blowing Rock~03|Cove Cay~04|Crocus Cay~05|Deadman's Cay~06|Dog Island~07|East Cay~08|Little Island~09|Little Scrub Island~10|Mid Cay~11|North Cay~12|Prickly Pear Cays~13|Rabbit Island~14|Sandy Island/Sand Island~15|Scilly Cay~16|Scrub Island~17|Seal Island~18|Sombrero/Hat Island~19|South Cay~20|South Wager Island~21|West Cay~22"],["Antarctica","AQ","Antarctica~AQ"],["Antigua and Barbuda","AG","Antigua Island~01|Barbuda Island~02|Bird Island~04|Bishop Island~05|Blake Island~06|Crump Island~09|Dulcina Island~10|Exchange Island~11|Five Islands~12|Great Bird Island~13|Green Island~14|Guiana Island~15|Hawes Island~17|Hells Gate Island~16|Henry Island~18|Johnson Island~19|Kid Island~20|Lobster Island~22|Maiden Island~24|Moor Island~25|Nanny Island~26|Pelican Island~27|Prickly Pear Island~28|Rabbit Island~29|Red Head Island~31|Redonda Island~03|Sandy Island~32|Smith Island~33|The Sisters~34|Vernon Island~35|Wicked Will Island~36|York Island~37"],["Argentina","AR","Buenos Aires~B|Capital Federal~C|Catamarca~K|Chaco~H|Chubut~U|Córdoba~X|Corrientes~W|Entre Ríos~E|Formosa~P|Jujuy~Y|La Pampa~L|La Rioja~F|Mendoza~M|Misiones~N|Neuquén~Q|Río Negro~R|Salta~A|San Juan~J|San Luis~D|Santa Cruz~Z|Santa Fe~S|Santiago del Estero~G|Tierra del Fuego~V|Tucumán~T"],["Armenia","AM","Aragatsotn~AG|Ararat~AR|Armavir~AV|Gegharkunik~GR|Kotayk~KT|Lori~LO|Shirak~SH|Syunik~SU|Tavush~TV|Vayots Dzor~VD|Yerevan~ER"],["Aruba","AW","Aruba~AW"],["Australia","AU","Australian Capital Territory~ACT|New South Wales~NSW|Northern Territory~NT|Queensland~QLD|South Australia~SA|Tasmania~TAS|Victoria~VIC|Western Australia~WA"],["Austria","AT","Burgenland~1|Kärnten~2|Niederösterreich~3|Oberösterreich~4|Salzburg~5|Steiermark~6|Tirol~7|Vorarlberg~8|Wien~9"],["Azerbaijan","AZ","Abşeron~ABS|Ağcabədi~AGC|Ağdam~AGM|Ağdaş~AGS|Ağstafa~AGA|Ağsu~AGU|Astara~AST|Bakı~BAK|Babək~BAB|Balakən~BAL|Bərdə~BAR|Beyləqan~BEY|Biləsuvar~BIL|Cəbrayıl~CAB|Cəlilabad~CAL|Culfa~CUL|Daşkəsən~DAS|Füzuli~FUZ|Gədəbəy~GAD|Goranboy~GOR|Göyçay~GOY|Göygöl~GYG|Hacıqabul~HAC|İmişli~IMI|İsmayıllı~ISM|Kəlbəcər~KAL|Kǝngǝrli~KAN|Kürdəmir~KUR|Laçın~LAC|Lənkəran~LAN|Lerik~LER|Masallı~MAS|Neftçala~NEF|Oğuz~OGU|Ordubad~ORD|Qəbələ~QAB|Qax~QAX|Qazax~QAZ|Qobustan~QOB|Quba~QBA|Qubadli~QBI|Qusar~QUS|Saatlı~SAT|Sabirabad~SAB|Şabran~SBN|Sədərək~SAD|Şahbuz~SAH|Şəki~SAK|Salyan~SAL|Şamaxı~SMI|Şəmkir~SKR|Samux~SMX|Şərur~SAR|Siyəzən~SIY|Şuşa~SUS|Tərtər~TAR|Tovuz~TOV|Ucar~UCA|Xaçmaz~XAC|Xızı~XIZ|Xocalı~XCI|Xocavənd~XVD|Yardımlı~YAR|Yevlax~YEV|Zəngilan~ZAN|Zaqatala~ZAQ|Zərdab~ZAR"],["Bahamas","BS","Acklins Island~01|Berry Islands~22|Bimini~02|Black Point~23|Cat Island~03|Central Abaco~24|Crooked Island and Long Cay~28|East Grand Bahama~29|Exuma~04|Freeport~05|Fresh Creek~06|Governor's Harbour~07|Green Turtle Cay~08|Harbour Island~09|High Rock~10|Inagua~11|Kemps Bay~12|Long Island~13|Marsh Harbour~14|Mayaguana~15|Moore’s Island~40|New Providence~16|Nichollstown and Berry Islands~17|North Abaco~42|North Andros~41|North Eleuthera~33|Ragged Island~18|Rock Sound~19|San Salvador and Rum Cay~20|Sandy Point~21|South Abaco~35|South Andros~36|South Eleuthera~37|West Grand Bahama~39"],["Bahrain","BH","Al Janūbīyah~14|Al Manāmah~13|Al Muḩarraq~15|Al Wusţá~16|Ash Shamālīyah~17"],["Bangladesh","BD","Barisal~A|Chittagong~B|Dhaka~C|Khulna~D|Mymensingh~M|Rajshahi~E|Rangpur~F|Sylhet~G"],["Barbados","BB","Christ Church~01|Saint Andrew~02|Saint George~03|Saint James~04|Saint John~05|Saint Joseph~06|Saint Lucy~07|Saint Michael~08|Saint Peter~09|Saint Philip~10|Saint Thomas~11"],["Belarus","BY","Brest voblast~BR|Gorod Minsk~HM|Homiel voblast~HO|Hrodna voblast~HR|Mahilyow voblast~MA|Minsk voblast~MI|Vitsebsk voblast~VI"],["Belgium","BE","Brussels~BRU|Flanders~VLG|Wallonia~WAL"],["Belize","BZ","Belize District~BZ|Cayo District~CY|Corozal District~CZL|Orange Walk District~OW|Stann Creek District~SC|Toledo District~TOL"],["Benin","BJ","Alibori~AL|Atakora~AK|Atlantique~AQ|Borgou~BO|Collines Department~CO|Donga~DO|Kouffo~KO|Littoral Department~LI|Mono Department~MO|Ouémé~OU|Plateau~PL|Zou~ZO"],["Bermuda","BM","City of Hamilton~03|Devonshire Parish~01|Hamilton Parish~02|Paget Parish~04|Pembroke Parish~05|Sandys Parish~08|Smith's Parish~09|Southampton Parish~10|St. George's Parish~07|Town of St. George~06|Warwick Parish~11"],["Bhutan","BT","Bumthang~33|Chhukha~12|Dagana~22|Gasa~GA|Haa~13|Lhuntse~44|Mongar~42|Paro~11|Pemagatshel~43|Punakha~23|Samdrup Jongkhar~45|Samtse~14|Sarpang~31|Thimphu~15|Trashigang~41|Trashiyangtse~TY|Trongsa~32|Tsirang~21|Wangdue Phodrang~24|Zhemgang~34"],["Bolivia","BO","Beni~B|Chuquisaca~H|Cochabamba~C|La Paz~L|Oruro~O|Pando~N|Potosí~P|Santa Cruz~S|Tarija~T"],["Bonaire, Sint Eustatius and Saba","BQ","Bonaire~BO|Saba Isand~SA|Sint Eustatius~SE"],["Bosnia and Herzegovina","BA","Brčko Distrikt~BRC|Federacija Bosne i Hercegovine~BIH|Republika Srpska~SRP"],["Botswana","BW","Central~CE|Ghanzi~GH|Kgalagadi~KG|Kgatleng~KL|Kweneng~KW|North West~NW|North-East~NE|South East~SE|Southern~SO"],["Bouvet Island","BV","Bouvet Island~BV"],["Brazil","BR","Acre~AC|Alagoas~AL|Amapá~AP|Amazonas~AM|Bahia~BA|Ceará~CE|Distrito Federal~DF|Espírito Santo~ES|Goiás~GO|Maranhão~MA|Mato Grosso~MT|Mato Grosso do Sul~MS|Minas Gerais~MG|Pará~PA|Paraíba~PB|Paraná~PR|Pernambuco~PE|Piauí~PI|Rio de Janeiro~RJ|Rio Grande do Norte~RN|Rio Grande do Sul~RS|Rondônia~RO|Roraima~RR|Santa Catarina~SC|São Paulo~SP|Sergipe~SE|Tocantins~TO"],["British Indian Ocean Territory","IO","British Indian Ocean Territory~IO"],["Brunei Darussalam","BN","Belait~BE|Brunei Muara~BM|Temburong~TE|Tutong~TU"],["Bulgaria","BG","Blagoevgrad~01|Burgas~02|Dobrich~08|Gabrovo~07|Jambol~28|Khaskovo~26|Kjustendil~10|Kurdzhali~09|Lovech~11|Montana~12|Pazardzhik~13|Pernik~14|Pleven~15|Plovdiv~16|Razgrad~17|Ruse~18|Shumen~27|Silistra~19|Sliven~20|Smoljan~21|Sofija~23|Sofija-Grad~22|Stara Zagora~24|Turgovishhe~25|Varna~03|Veliko Turnovo~04|Vidin~05|Vraca~06"],["Burkina Faso","BF","Balé~BAL|Bam/Lake Bam~BAM|Banwa Province~BAN|Bazèga~BAZ|Bougouriba~BGR|Boulgou Province~BLG|Boulkiemdé~BLK|Comoé/Komoe~COM|Ganzourgou Province~GAN|Gnagna~GNA|Gourma Province~GOU|Houet~HOU|Ioba~IOB|Kadiogo~KAD|Kénédougou~KEN|Komondjari~KMD|Kompienga~KMP|Kossi Province~KOS|Koulpélogo~KOP|Kouritenga~KOT|Kourwéogo~KOW|Léraba~LER|Loroum~LOR|Mouhoun~MOU|Namentenga~NAM|Naouri/Nahouri~NAO|Nayala~NAY|Noumbiel~NOU|Oubritenga~OUB|Oudalan~OUD|Passoré~PAS|Poni~PON|Sanguié~SNG|Sanmatenga~SMT|Séno~SEN|Sissili~SIS|Soum~SOM|Sourou~SOR|Tapoa~TAP|Tui/Tuy~TUI|Yagha~YAG|Yatenga~YAT|Ziro~ZIR|Zondoma~ZON|Zoundwéogo~ZOU"],["Burundi","BI","Bubanza~BB|Bujumbura Mairie~BM|Bujumbura Rural~BL|Bururi~BR|Cankuzo~CA|Cibitoke~CI|Gitega~GI|Karuzi~KR|Kayanza~KY|Kirundo~KI|Makamba~MA|Muramvya~MU|Muyinga~MY|Mwaro~MW|Ngozi~NG|Rutana~RT|Ruyigi~RY"],["Cambodia","KH","Baat Dambang~2|Banteay Mean Chey~1|Kampong Chaam~3|Kampong Chhnang~4|Kampong Spueu~5|Kampong Thum~6|Kampot~7|Kandaal~8|Kaoh Kong~9|Kracheh~10|Krong Kaeb~23|Krong Pailin~24|Krong Preah Sihanouk~18|Mondol Kiri~11|Otdar Mean Chey~22|Phnom Penh~12|Pousaat~15|Preah Vihear~13|Prey Veaeng~14|Rotanah Kiri~16|Siem Reab~17|Stueng Treng~19|Svaay Rieng~20|Taakaev~21|Tbong Khmum~25"],["Cameroon","CM","Adamaoua~AD|Centre~CE|Est~ES|Extrême-Nord~EN|Littoral~LT|Nord~NO|Nord-Ouest~NW|Ouest~OU|Sud~SU|Sud-Ouest~SW"],["Canada","CA","Alberta~AB|British Columbia~BC|Manitoba~MB|New Brunswick~NB|Newfoundland and Labrador~NL|Northwest Territories~NT|Nova Scotia~NS|Nunavut~NU|Ontario~ON|Prince Edward Island~PE|Quebec~QC|Saskatchewan~SK|Yukon~YT"],["Cape Verde","CV","Boa Vista~BV|Brava~BR|Calheta de São Miguel~CS|Maio~MA|Mosteiros~MO|Paúl~PA|Porto Novo~PN|Praia~PR|Ribeira Brava~RB|Ribeira Grande~RG|Sal~SL|Santa Catarina~CA|Santa Cruz~CR|São Domingos~SD|São Filipe~SF|São Nicolau~SN|São Vicente~SV|Tarrafal~TA|Tarrafal de São Nicolau~TS"],["Cayman Islands","KY","Creek~undefined|Eastern~undefined|Midland~undefined|South Town~undefined|Spot Bay~undefined|Stake Bay~undefined|West End~undefined|Western~undefined"],["Central African Republic","CF","Bamingui-Bangoran~BB|Bangui~BGF|Basse-Kotto~BK|Haute-Kotto~HK|Haut-Mbomou~HM|Kémo~KG|Lobaye~LB|Mambéré-Kadéï~HS|Mbomou~MB|Nana-Grebizi~10|Nana-Mambéré~NM|Ombella-M'Poko~MP|Ouaka~UK|Ouham~AC|Ouham Péndé~OP|Sangha-Mbaéré~SE|Vakaga~VK"],["Chad","TD","Bahr el Ghazal~BG|Batha~BA|Borkou~BO|Chari-Baguirmi~CB|Ennedi-Est~EE|Ennedi-Ouest~EO|Guéra~GR|Hadjer Lamis~HL|Kanem~KA|Lac~LC|Logone Occidental~LO|Logone Oriental~LR|Mondoul~MA|Mayo-Kébbi-Est~ME|Moyen-Chari~MC|Ouaddai~OD|Salamat~SA|Sila~SI|Tandjilé~TA|Tibesti~TI|Ville de Ndjamena~ND|Wadi Fira~WF"],["Chile","CL","Aisén del General Carlos Ibáñez del Campo~AI|Antofagasta~AN|Araucanía~AR|Arica y Parinacota~AP|Atacama~AT|Bío-Bío~BI|Coquimbo~CO|Libertador General Bernardo O'Higgins~LI|Los Lagos~LL|Los Ríos~LR|Magallanes y Antartica Chilena~MA|Marga-Marga~|Maule~ML|Ñuble~NB|Región Metropolitana de Santiago~RM|Tarapacá~TA|Valparaíso~VS"],["China","CN","Anhui~34|Beijing~11|Chongqing~50|Fujian~35|Gansu~62|Guangdong~44|Guangxi~45|Guizhou~52|Hainan~46|Hebei~13|Heilongjiang~23|Henan~41|Hong Kong~91|Hubei~42|Hunan~43|Inner Mongolia~15|Jiangsu~32|Jiangxi~36|Jilin~22|Liaoning~21|Macau~92|Ningxia~64|Qinghai~63|Shaanxi~61|Shandong~37|Shanghai~31|Shanxi~14|Sichuan~51|Tianjin~12|Tibet~54|Xinjiang~65|Yunnan~53|Zhejiang~33"],["Christmas Island","CX","Christmas Island~CX"],["Cocos (Keeling) Islands","CC","Direction Island~DI|Home Island~HM|Horsburgh Island~HR|North Keeling Island~NK|South Island~SI|West Island~WI"],["Colombia","CO","Amazonas~AMA|Antioquia~ANT|Arauca~ARA|Archipiélago de San Andrés~SAP|Atlántico~ATL|Bogotá D.C.~DC|Bolívar~BOL|Boyacá~BOY|Caldas~CAL|Caquetá~CAQ|Casanare~CAS|Cauca~CAU|Cesar~CES|Chocó~CHO|Córdoba~COR|Cundinamarca~CUN|Guainía~GUA|Guaviare~GUV|Huila~HUI|La Guajira~LAG|Magdalena~MAG|Meta~MET|Nariño~NAR|Norte de Santander~NSA|Putumayo~PUT|Quindío~QUI|Risaralda~RIS|Santander~SAN|Sucre~SUC|Tolima~TOL|Valle del Cauca~VAC|Vaupés~VAU|Vichada~VID"],["Comoros","KM","Andjazîdja~G|Andjouân~A|Moûhîlî~M"],["Congo, Republic of the (Brazzaville)","CG","Bouenza~11|Brazzaville~BZV|Cuvette~8|Cuvette-Ouest~15|Kouilou~5|Lékoumou~2|Likouala~7|Niari~9|Plateaux~14|Pointe-Noire~16|Pool~12|Sangha~13"],["Congo, the Democratic Republic of the (Kinshasa)","CD","Bandundu~BN|Bas-Congo~BC|Équateur~EQ|Kasaï-Occidental~KE|Kasaï-Oriental~KW|Katanga~KA|Kinshasa~KN|Maniema~MA|Nord-Kivu~NK|Orientale~OR|Sud-Kivu~SK"],["Cook Islands","CK","Aitutaki~undefined|Atiu~undefined|Avarua~undefined|Mangaia~undefined|Manihiki~undefined|Ma'uke~undefined|Mitiaro~undefined|Nassau~undefined|Palmerston~undefined|Penrhyn~undefined|Pukapuka~undefined|Rakahanga~undefined"],["Costa Rica","CR","Alajuela~2|Cartago~3|Guanacaste~5|Heredia~4|Limón~7|Puntarenas~6|San José~1"],["Côte d'Ivoire, Republic of","CI","Agnéby~16|Bafing~17|Bas-Sassandra~09|Denguélé~10|Dix-Huit Montagnes~06|Fromager~18|Haut-Sassandra~02|Lacs~07|Lagunes~01|Marahoué~12|Moyen-Cavally~19|Moyen-Comoé~05|N'zi-Comoé~11|Savanes~03|Sud-Bandama~15|Sud-Comoé~13|Vallée du Bandama~04|Worodougou~14|Zanzan~08"],["Croatia","HR","Bjelovarsko-Bilogorska Županija~07|Brodsko-Posavska Županija~12|Dubrovačko-Neretvanska Županija~19|Grad Zagreb~21|Istarska Županija~18|Karlovačka Županija~04|Koprivničko-Krizevačka Županija~06|Krapinsko-Zagorska Županija~02|Ličko-Senjska Županija~09|Međimurska Županija~20|Osječko-Baranjska Županija~14|Požeško-Slavonska Županija~11|Primorsko-Goranska Županija~08|Sisačko-Moslavačka Županija~03|Splitsko-Dalmatinska Županija~17|Sibensko-Kninska Županija~15|Varaždinska Županija~05|Virovitičko-Podravska Županija~10|Vukovarsko-Srijemska Županija~16|Zadarska Županija~13|Zagrebacka Zupanija~01"],["Cuba","CU","Artemisa~15|Camagüey~09|Ciego de Ávila~08|Cienfuegos~06|Granma~12|Guantánamo~14|Holguín~11|Isla de la Juventud~99|La Habana~03|Las Tunas~10|Matanzas~04|Mayabeque~16|Pinar del Río~01|Sancti Spíritus~07|Santiago de Cuba~13|Villa Clara~05"],["Curaçao","CW","Curaçao~CW"],["Cyprus","CY","Ammochostos~04|Keryneia~05|Larnaka~03|Lefkosia~01|Lemesos~02|Pafos~05"],["Czech Republic","CZ","Hlavní město Praha~PR|Jihočeský kraj~JC|Jihomoravský kraj~JM|Karlovarský kraj~KA|Královéhradecký kraj~KR|Liberecký kraj~LI|Moravskoslezský kraj~MO|Olomoucký kraj~OL|Pardubický kraj~PA|Plzeňský kraj~PL|Středočeský kraj~ST|Ústecký kraj~US|Vysočina~VY|Zlínský kraj~ZL"],["Denmark","DK","Hovedstaden~84|Kujalleq~GL-KU|Midtjylland~82|Norderøerne~FO-01|Nordjylland~81|Østerø~FO-06|Qaasuitsup~GL-QA|Qeqqata~GL-QE|Sandø~FO-02|Sermersooq~GL-SM|Sjælland~85|Strømø~FO-03|Suderø~FO-04|Syddanmark~83|Vågø~FO-05"],["Djibouti","DJ","Ali Sabieh~AS|Arta~AR|Dikhil~DI|Obock~OB|Tadjourah~TA"],["Dominica","DM","Saint Andrew Parish~02|Saint David Parish~03|Saint George Parish~04|Saint John Parish~05|Saint Joseph Parish~06|Saint Luke Parish~07|Saint Mark Parish~08|Saint Patrick Parish~09|Saint Paul Parish~10|Saint Peter Parish~11"],["Dominican Republic","DO","Cibao Central~02|Del Valle~37|Distrito Nacional~01|Enriquillo~38|Norcentral~04|Nordeste~34|Noroeste~34|Norte~35|Valdesia~42"],["Ecuador","EC","Azuay~A|Bolívar~B|Cañar~F|Carchi~C|Chimborazo~H|Cotopaxi~X|El Oro~O|Esmeraldas~E|Galápagos~W|Guayas~G|Imbabura~I|Loja~L|Los Ríos~R|Manabí~M|Morona-Santiago~S|Napo~N|Orellana~D|Pastaza~Y|Pichincha~P|Santa Elena~SE|Santo Domingo de los Tsáchilas~SD|Sucumbíos~U|Tungurahua~T|Zamora-Chinchipe~Z"],["Egypt","EG","Alexandria~ALX|Aswan~ASN|Asyout~AST|Bani Sueif~BNS|Beheira~BH|Cairo~C|Daqahlia~DK|Dumiat~DT|El Bahr El Ahmar~BA|El Ismailia~IS|El Suez~SUZ|El Wadi El Gedeed~WAD|Fayoum~FYM|Gharbia~GH|Giza~SUZ|Helwan~HU|Kafr El Sheikh~KFS|Luxor~LX|Matrouh~MT|Menia~MN|Menofia~MNF|North Sinai~SIN|Port Said~PTS|Qalubia~KB|Qena~KN|Sharqia~SHR|Sixth of October~SU|Sohag~SHG|South Sinai~JS"],["El Salvador","SV","Ahuachapán~AH|Cabañas~CA|Cuscatlán~CU|Chalatenango~CH|La Libertad~LI|La Paz~PA|La Unión~UN|Morazán~MO|San Miguel~SM|San Salvador~SS|Santa Ana~SA|San Vicente~SV|Sonsonate~SO|Usulután~US"],["Equatorial Guinea","GQ","Annobón~AN|Bioko Norte~BN|Bioko Sur~BS|Centro Sur~CS|Kié-Ntem~KN|Litoral~LI|Wele-Nzas~WN"],["Eritrea","ER","Anseba~AN|Debub~DU|Debub-Keih-Bahri~DK|Gash-Barka~GB|Maekel~MA|Semien-Keih-Bahri~SK"],["Estonia","EE","Harjumaa (Tallinn)~37|Hiiumaa (Kardla)~39|Ida-Virumaa (Johvi)~44|Järvamaa (Paide)~41|Jõgevamaa (Jogeva)~49|Läänemaa~57|Lääne-Virumaa (Rakvere)~59|Pärnumaa (Parnu)~67|Põlvamaa (Polva)~65|Raplamaa (Rapla)~70|Saaremaa (Kuessaare)~74|Tartumaa (Tartu)~78|Valgamaa (Valga)~82|Viljandimaa (Viljandi)~84|Võrumaa (Voru)~86"],["Ethiopia","ET","Addis Ababa~AA|Afar~AF|Amhara~AM|Benshangul-Gumaz~BE|Dire Dawa~DD|Gambela~GA|Harari~HA|Oromia~OR|Somali~SO|Southern Nations Nationalities and People's Region~SN|Tigray~TI"],["Falkland Islands (Islas Malvinas)","FK","Falkland Islands (Islas Malvinas)~undefined"],["Faroe Islands","FO","Bordoy~undefined|Eysturoy~undefined|Mykines~undefined|Sandoy~undefined|Skuvoy~undefined|Streymoy~undefined|Suduroy~undefined|Tvoroyri~undefined|Vagar~undefined"],["Fiji","FJ","Ba~01|Bua~01|Cakaudrove~03|Kadavu~04|Lau~05|Lomaiviti~06|Macuata~07|Nadroga and Navosa~08|Naitasiri~09|Namosi~10|Ra~011|Rewa~12|Rotuma~R|Serua~12|Tailevu~14"],["Finland","FI","Ahvenanmaan lääni~AL|Etelä-Suomen lääni~ES|Itä-Suomen lääni~IS|Länsi-Suomen lääni~LS|Lapin lääni~LL|Oulun lääni~OL"],["France","FR","Auvergne-Rhône-Alpes~ARA|Bourgogne-Franche-Comté~BFC|Bretagne~BRE|Centre-Val de Loire~CVL|Corse~COR|Grand Est~GES|Hauts-de-France~HDF|Île-de-France~IDF|Normandie~NOR|Nouvelle-Aquitaine~NAQ|Occitanie~OCC|Pays de la Loire~PDL|Provence-Alpes-Cote d'Azur~PAC|Clipperton~CP|Guadeloupe~GP|Guyane~GF|Martinique~MQ|Mayotte~YT|Novelle-Calédonie~NC|Polynésie~PF|Saint-Pierre-et-Miquelon~PM|Saint Barthélemy~BL|Saint Martin~MF|Réunion~RE|Terres Australes Françaises~TF|Wallis-et-Futuna~WF"],["French Guiana","GF","French Guiana~undefined"],["French Polynesia","PF","Archipel des Marquises~undefined|Archipel des Tuamotu~undefined|Archipel des Tubuai~undefined|Iles du Vent~undefined|Iles Sous-le-Vent~undefined"],["French Southern and Antarctic Lands","TF","Adelie Land~undefined|Ile Crozet~undefined|Iles Kerguelen~undefined|Iles Saint-Paul et Amsterdam~undefined"],["Gabon","GA","Estuaire~1|Haut-Ogooué~2|Moyen-Ogooué~3|Ngounié~4|Nyanga~5|Ogooué-Ivindo~6|Ogooué-Lolo~7|Ogooué-Maritime~8|Woleu-Ntem~9"],["Gambia, The","GM","Banjul~B|Central River~M|Lower River~L|North Bank~N|Upper River~U|Western~W"],["Georgia","GE","Abkhazia (Sokhumi)~AB|Ajaria (Bat'umi)~AJ|Guria~GU|Imereti~IM|K'akheti~KA|Kvemo Kartli~KK|Mtshkheta-Mtianeti~MM|Rach'a-Lexhkumi-KvemoSvaneti~RL|Samegrelo-Zemo Svaneti~SZ|Samtskhe-Javakheti~SJ|Shida Kartli~SK|Tbilisi~TB"],["Germany","DE","Baden-Württemberg~BW|Bayern~BY|Berlin~BE|Brandenburg~BB|Bremen~HB|Hamburg~HH|Hessen~HE|Mecklenburg-Vorpommern~MV|Niedersachsen~NI|Nordrhein-Westfalen~NW|Rheinland-Pfalz~RP|Saarland~SL|Sachsen~SN|Sachsen-Anhalt~ST|Schleswig-Holstein~SH|Thüringen~TH"],["Ghana","GH","Ahafo~undefined|Ashanti~AH|Bono~undefined|Bono East~undefined|Central~CP|Eastern~EP|Greater Accra~AA|Northern~NP|North East~undefined|Oti~undefined|Savannah~undefined|Upper East~UE|Upper West~UW|Volta~TV|Western~WP|Western North~undefined"],["Gibraltar","GI","Gibraltar~undefined"],["Greece","GR","Anatolikí Makedonía kai Thráki~A|Attikḯ~I|Dytikí Elláda~G|Dytikí Makedonía~C|Ionía Nísia~F|Kentrikí Makedonía~B|Krítí~M|Notío Aigaío~L|Peloponnísos~J|Stereá Elláda~H|Thessalía~E|Voreío Aigaío~K|Ípeiros~D|Ágion Óros~69"],["Greenland","GL","Kommune Kujalleq~KU|Kommuneqarfik Sermersooq~SM|Qaasuitsup Kommunia~QA|Qeqqata Kommunia~QE"],["Grenada","GD","Saint Andrew~01|Saint David~02|Saint George~03|Saint John~04|Saint Mark~05|Saint Patrick~06|Southern Grenadine Islands~10"],["Guadeloupe","GP","Guadeloupe~undefined"],["Guam","GU","Guam~undefined"],["Guatemala","GT","Alta Verapaz~AV|Baja Verapaz~BV|Chimaltenango~CM|Chiquimula~CQ|El Progreso~PR|Escuintla~ES|Guatemala~GU|Huehuetenango~HU|Izabal~IZ|Jalapa~JA|Jutiapa~JU|Petén~PE|Quetzaltenango~QZ|Quiché~QC|Retalhuleu~Re|Sacatepéquez~SA|San Marcos~SM|Santa Rosa~SR|Sololá~SO|Suchitepéquez~SU|Totonicapán~TO|Zacapa~ZA"],["Guernsey","GG","Castel~undefined|Forest~undefined|St. Andrew~undefined|St. Martin~undefined|St. Peter Port~undefined|St. Pierre du Bois~undefined|St. Sampson~undefined|St. Saviour~undefined|Torteval~undefined|Vale~undefined"],["Guinea","GN","Boké~B|Conakry~C|Faranah~F|Kankan~K|Kindia~D|Labé~L|Mamou~M|Nzérékoré~N"],["Guinea-Bissau","GW","Bafatá~BA|Biombo~BM|Bissau~BS|Bolama-Bijagos~BL|Cacheu~CA|Gabú~GA|Oio~OI|Quinara~QU|Tombali~TO"],["Guyana","GY","Barima-Waini~BA|Cuyuni-Mazaruni~CU|Demerara-Mahaica~DE|East Berbice-Corentyne~EB|Essequibo Islands-West Demerara~ES|Mahaica-Berbice~MA|Pomeroon-Supenaam~PM|Potaro-Siparuni~PT|Upper Demerara-Berbice~UD|Upper Takutu-Upper Essequibo~UT"],["Haiti","HT","Artibonite~AR|Centre~CE|Grand'Anse~GA|Nippes~NI|Nord~ND|Nord-Est~NE|Nord-Ouest~NO|Ouest~OU|Sud~SD|Sud-Est~SE"],["Heard Island and McDonald Islands","HM","Heard Island and McDonald Islands~undefined"],["Holy See (Vatican City)","VA","Holy See (Vatican City)~01"],["Honduras","HN","Atlántida~AT|Choluteca~CH|Colón~CL|Comayagua~CM|Copán~CP|Cortés~CR|El Paraíso~EP|Francisco Morazan~FM|Gracias a Dios~GD|Intibucá~IN|Islas de la Bahía~IB|La Paz~LP|Lempira~LE|Ocotepeque~OC|Olancho~OL|Santa Bárbara~SB|Valle~VA|Yoro~YO"],["Hong Kong","HK","Hong Kong~HK"],["Hungary","HU","Bács-Kiskun~BK|Baranya~BA|Békés~BE|Békéscsaba~BC|Borsod-Abauj-Zemplen~BZ|Budapest~BU|Csongrád~CS|Debrecen~DE|Dunaújváros~DU|Eger~EG|Érd~ER|Fejér~FE|Győr~GY|Győr-Moson-Sopron~GS|Hajdú-Bihar~HB|Heves~HE|Hódmezővásárhely~HV|Jász-Nagykun-Szolnok~N|Kaposvár~KV|Kecskemét~KM|Komárom-Esztergom~KE|Miskolc~MI|Nagykanizsa~NK|Nógrád~NO|Nyíregyháza~NY|Pécs~PS|Pest~PE|Salgótarján~ST|Somogy~SO|Sopron~SN|Szabolcs-á-Bereg~SZ|Szeged~SD|Székesfehérvár~SF|Szekszárd~SS|Szolnok~SK|Szombathely~SH|Tatabánya~TB|Tolna~TO|Vas~VA|Veszprém~VE|Veszprém (City)~VM|Zala~ZA|Zalaegerszeg~ZE"],["Iceland","IS","Austurland~7|Höfuðborgarsvæði utan Reykjavíkur~1|Norðurland eystra~6|Norðurland vestra~5|Suðurland~8|Suðurnes~2|Vestfirðir~4|Vesturland~3"],["India","IN","Andaman and Nicobar Islands~AN|Andhra Pradesh~AP|Arunachal Pradesh~AR|Assam~AS|Bihar~BR|Chandigarh~CH|Chhattisgarh~CT|Dadra and Nagar Haveli~DN|Daman and Diu~DD|Delhi~DL|Goa~GA|Gujarat~GJ|Haryana~HR|Himachal Pradesh~HP|Jammu and Kashmir~JK|Jharkhand~JH|Karnataka~KA|Kerala~KL|Lakshadweep~LD|Madhya Pradesh~MP|Maharashtra~MH|Manipur~MN|Meghalaya~ML|Mizoram~MZ|Nagaland~NL|Odisha~OR|Puducherry~PY|Punjab~PB|Rajasthan~RJ|Sikkim~WK|Tamil Nadu~TN|Telangana~TG|Tripura~TR|Uttarakhand~UT|Uttar Pradesh~UP|West Bengal~WB"],["Indonesia","ID","Aceh~AC|Bali~BA|Bangka Belitung~BB|Banten~BT|Bengkulu~BE|Gorontalo~GO|Jakarta Raya~JK|Jambi~JA|Jawa Barat~JB|Jawa Tengah~JT|Jawa Timur~JI|Kalimantan Barat~KB|Kalimantan Selatan~KS|Kalimantan Tengah~KT|Kalimantan Timur~KI|Kalimantan Utara~KU|Kepulauan Riau~KR|Lampung~LA|Maluku~MA|Maluku Utara~MU|Nusa Tenggara Barat~NB|Nusa Tenggara Timur~NT|Papua~PA|Papua Barat~PB|Riau~RI|Sulawesi Selatan~SR|Sulawesi Tengah~ST|Sulawesi Tenggara~SG|Sulawesi Utara~SA|Sumatera Barat~SB|Sumatera Selatan~SS|Sumatera Utara~SU|Yogyakarta~YO"],["Iran, Islamic Republic of","IR","Alborz~32|Ardabīl~03|Āz̄arbāyjān-e Gharbī~02|Āz̄arbāyjān-e Sharqī~01|Būshehr~06|Chahār Maḩāl va Bakhtīārī~08|Eşfahān~04|Fārs~14|Gīlān~19|Golestān~27|Hamadān~24|Hormozgān~23|Īlām~05|Kermān~15|Kermānshāh~17|Khorāsān-e Jonūbī~29|Khorāsān-e Raẕavī~30|Khorāsān-e Shomālī~61|Khūzestān~10|Kohgīlūyeh va Bowyer Aḩmad~18|Kordestān~16|Lorestān~20|Markazi~22|Māzandarān~21|Qazvīn~28|Qom~26|Semnān~12|Sīstān va Balūchestān~13|Tehrān~07|Yazd~25|Zanjān~11"],["Iraq","IQ","Al Anbār~AN|Al Başrah~BA|Al Muthanná~MU|Al Qādisīyah~QA|An Najaf~NA|Arbīl~AR|As Sulaymānīyah~SU|Bābil~BB|Baghdād~BG|Dohuk~DA|Dhī Qār~DQ|Diyālá~DI|Karbalā'~KA|Kirkuk~KI|Maysān~MA|Nīnawá~NI|Şalāḩ ad Dīn~SD|Wāsiţ~WA"],["Ireland","IE","Carlow~CW|Cavan~CN|Clare~CE|Cork~CO|Donegal~DL|Dublin~D|Galway~G|Kerry~KY|Kildare~KE|Kilkenny~KK|Laois~LS|Leitrim~LM|Limerick~LK|Longford~LD|Louth~LH|Mayo~MO|Meath~MH|Monaghan~MN|Offaly~OY|Roscommon~RN|Sligo~SO|Tipperary~TA|Waterford~WD|Westmeath~WH|Wexford~WX|Wicklow~WW"],["Isle of Man","IM","Isle of Man~undefined"],["Israel","IL","HaDarom~D|HaMerkaz~M|HaTsafon~Z|H̱efa~HA|Tel-Aviv~TA|Yerushalayim~JM"],["Italy","IT","Abruzzo~65|Basilicata~77|Calabria~78|Campania~72|Emilia-Romagna~45|Friuli-Venezia Giulia~36|Lazio~62|Liguria~42|Lombardia~25|Marche~57|Molise~67|Piemonte~21|Puglia~75|Sardegna~88|Sicilia~82|Toscana~52|Trentino-Alto Adige~32|Umbria~55|Valle d'Aosta~23|Veneto~34"],["Jamaica","JM","Clarendon~13|Hanover~09|Kingston~01|Manchester~12|Portland~04|Saint Andrew~02|Saint Ann~06|Saint Catherine~14|Saint Elizabeth~11|Saint James~08|Saint Mary~05|Saint Thomas~03|Trelawny~07|Westmoreland~10"],["Japan","JP","Aichi~23|Akita~05|Aomori~02|Chiba~12|Ehime~38|Fukui~18|Fukuoka~40|Fukushima~07|Gifu~21|Gunma~10|Hiroshima~34|Hokkaido~01|Hyogo~28|Ibaraki~08|Ishikawa~17|Iwate~03|Kagawa~37|Kagoshima~46|Kanagawa~14|Kochi~39|Kumamoto~43|Kyoto~26|Mie~24|Miyagi~04|Miyazaki~45|Nagano~20|Nagasaki~42|Nara~29|Niigata~15|Oita~44|Okayama~33|Okinawa~47|Osaka~27|Saga~41|Saitama~11|Shiga~25|Shimane~32|Shizuoka~22|Tochigi~09|Tokushima~36|Tokyo~13|Tottori~31|Toyama~16|Wakayama~30|Yamagata~06|Yamaguchi~35|Yamanashi~19"],["Jersey","JE","Jersey~undefined"],["Jordan","JO","‘Ajlūn~AJ|Al 'Aqabah~AQ|Al Balqā’~BA|Al Karak~KA|Al Mafraq~MA|Al ‘A̅şimah~AM|Aţ Ţafīlah~AT|Az Zarqā’~AZ|Irbid~IR|Jarash~JA|Ma‘ān~MN|Mādabā~MD"],["Kazakhstan","KZ","Almaty~ALA|Aqmola~AKM|Aqtobe~AKT|Astana~AST|Atyrau~ATY|Batys Qazaqstan~ZAP|Bayqongyr~undefined|Mangghystau~MAN|Ongtustik Qazaqstan~YUZ|Pavlodar~PAV|Qaraghandy~KAR|Qostanay~KUS|Qyzylorda~KZY|Shyghys Qazaqstan~VOS|Soltustik Qazaqstan~SEV|Zhambyl~ZHA"],["Kenya","KE","Baringo~01|Bomet~02|Bungoma~03|Busia~04|Eleyo/Marakwet~05|Embu~06|Garissa~07|Homa Bay~08|Isiolo~09|Kajiado~10|Kakamega~11|Kericho~12|Kiambu~13|Kilifi~14|Kirinyaga~15|Kisii~16|Kisumu~17|Kitui~18|Kwale~19|Laikipia~20|Lamu~21|Machakos~22|Makueni~23|Mandera~24|Marsabit~25|Meru~26|Migori~27|Mombasa~28|Murang'a~29|Nairobi City~30|Nakuru~31|Nandi~32|Narok~33|Nyamira~34|Nyandarua~35|Nyeri~36|Samburu~37|Siaya~38|Taita/Taveta~39|Tana River~40|Tharaka-Nithi~41|Trans Nzoia~42|Turkana~43|Uasin Gishu~44|Vihiga~45|Wajir~46|West Pokot~47"],["Kiribati","KI","Abaiang~undefined|Abemama~undefined|Aranuka~undefined|Arorae~undefined|Banaba~undefined|Beru~undefined|Butaritari~undefined|Central Gilberts~undefined|Gilbert Islands~G|Kanton~undefined|Kiritimati~undefined|Kuria~undefined|Line Islands~L|Maiana~undefined|Makin~undefined|Marakei~undefined|Nikunau~undefined|Nonouti~undefined|Northern Gilberts~undefined|Onotoa~undefined|Phoenix Islands~P|Southern Gilberts~undefined|Tabiteuea~undefined|Tabuaeran~undefined|Tamana~undefined|Tarawa~undefined|Teraina~undefined"],["Korea, Democratic People's Republic of","KP","Chagang-do (Chagang Province)~04|Hamgyong-bukto (North Hamgyong Province)~09|Hamgyong-namdo (South Hamgyong Province)~08|Hwanghae-bukto (North Hwanghae Province)~06|Hwanghae-namdo (South Hwanghae Province)~05|Kangwon-do (Kangwon Province)~07|Nasŏn (Najin-Sŏnbong)~13|P'yongan-bukto (North P'yongan Province)~03|P'yongan-namdo (South P'yongan Province)~02|P'yongyang-si (P'yongyang City)~01|Yanggang-do (Yanggang Province)~10"],["Korea, Republic of","KR","Ch'ungch'ongbuk-do~43|Ch'ungch'ongnam-do~44|Cheju-do~49|Chollabuk-do~45|Chollanam-do~46|Inch'on-Kwangyokhi~28|Kang-won-do~42|Kwangju-Kwangyokshi~28|Kyonggi-do~41|Kyongsangbuk-do~47|Kyongsangnam-do~48|Pusan-Kwangyokshi~26|Seoul-T'ukpyolshi~11|Sejong~50|Taegu-Kwangyokshi~27|Taejon-Kwangyokshi~30|Ulsan-Kwangyokshi~31"],["Kuwait","KW","Al Aḩmadi~AH|Al Farwānīyah~FA|Al Jahrā’~JA|Al ‘Āşimah~KU|Ḩawallī~HA|Mubārak al Kabir~MU"],["Kyrgyzstan","KG","Batken Oblasty~B|Bishkek Shaary~GB|Chuy Oblasty (Bishkek)~C|Jalal-Abad Oblasty~J|Naryn Oblasty~N|Osh Oblasty~O|Talas Oblasty~T|Ysyk-Kol Oblasty (Karakol)~Y"],["Laos","LA","Attapu~AT|Bokèo~BK|Bolikhamxai~BL|Champasak~CH|Houaphan~HO|Khammouan~KH|Louang Namtha~LM|Louangphabang~LP|Oudômxai~OU|Phôngsali~PH|Salavan~SL|Savannakhét~SV|Vientiane~VI|Xaignabouli~XA|Xékong~XE|Xaisomboun~XS|Xiangkhouang~XI"],["Latvia","LV","Aglona~001|Aizkraukle~002|Aizpute~003|Aknīste~004|Aloja~005|Alsunga~06|Alūksne~007|Amata~008|Ape~009|Auce~010|Ādaži~011|Babīte~012|Baldone~013|Baltinava~014|Balvi~015|Bauska~016|Beverīna~017|Brocēni~018|Burtnieki~019|Carnikava~020|Cesvaine~021|Cēsis~022|Cibla~023|Dagda~024|Daugavpils~025|Daugavpils (City)~DGV|Dobele~026|Dundaga~027|Durbe~028|Engure~029|Ērgļi~030|Garkalne~031|Grobiņa~032|Gulbene~033|Iecava~034|Ikšķile~035|Ilūkste~036|Inčukalns~037|Jaunjelgava~038|Jaunpiebalga~039|Jaunpils~040|Jelgava~041|Jelgava (City)~JEL|Jēkabpils~042|Jēkabpils (City)~JKB|Jūrmala (City)~JUR|Kandava~043|Kārsava~044|Kocēni~045|Koknese~046|Krāslava~047|Krimulda~048|Krustpils~049|Kuldīga~050|Ķegums~051|Ķekava~052|Lielvārde~053|Liepāja~LPX|Limbaži~054|Līgatne~055|Līvāni~056|Lubāna~057|Ludza~058|Madona~059|Mazsalaca~060|Mālpils~061|Mārupe~062|Mērsrags~063|Naukšēni~064|Nereta~065|Nīca~066|Ogre~067|Olaine~068|Ozolnieki~069|Pārgauja~070|Pāvilosta~071|Pļaviņas~072|Preiļi~073|Priekule~074|Priekuļi~075|Rauna~076|Rēzekne~077|Rēzekne (City)~REZ|Riebiņi~078|Rīga~RIX|Roja~079|Ropaži~080|Rucava~081|Rugāji~082|Rundāle~083|Rūjiena~084|Sala~085|Salacgrīva~086|Salaspils~087|Saldus~088|Saulkrasti~089|Sēja~090|Sigulda~091|Skrīveri~092|Skrunda~093|Smiltene~094|Stopiņi~095|Strenči~096|Talsi~097|Tērvete~098|Tukums~099|Vaiņode~100|Valka~101|Valmiera~VMR|Varakļāni~102|Vārkava~103|Vecpiebalga~104|Vecumnieki~105|Ventspils~106|Ventspils (City)~VEN|Viesīte~107|Viļaka~108|Viļāni~109|Zilupe~110"],["Lebanon","LB","Aakkâr~AK|Baalbelk-Hermel~BH|Béqaa~BI|Beyrouth~BA|Liban-Nord~AS|Liban-Sud~JA|Mont-Liban~JL|Nabatîyé~NA"],["Lesotho","LS","Berea~D|Butha-Buthe~B|Leribe~C|Mafeteng~E|Maseru~A|Mohales Hoek~F|Mokhotlong~J|Qacha's Nek~H|Quthing~G|Thaba-Tseka~K"],["Liberia","LR","Bomi~BM|Bong~BG|Gbarpolu~GP|Grand Bassa~GB|Grand Cape Mount~CM|Grand Gedeh~GG|Grand Kru~GK|Lofa~LO|Margibi~MG|Maryland~MY|Montserrado~MO|Nimba~NI|River Cess~RI|River Geee~RG|Sinoe~SI"],["Libya","LY","Al Buţnān~BU|Al Jabal al Akhḑar~JA|Al Jabal al Gharbī~JG|Al Jafārah~JA|Al Jufrah~JU|Al Kufrah~FK|Al Marj~MJ|Al Marquab~MB|Al Wāḩāt~WA|An Nuqaţ al Khams~NQ|Az Zāwiyah~ZA|Banghāzī~BA|Darnah~DR|Ghāt~GH|Mişrātah~MI|Murzuq~MQ|Nālūt~NL|Sabhā~SB|Surt~SR|Ţarābulus~TB|Yafran~WD|Wādī ash Shāţiʾ~WS"],["Liechtenstein","LI","Balzers~01|Eschen~02|Gamprin~03|Mauren~04|Planken~05|Ruggell~06|Schaan~07|Schellenberg~08|Triesen~09|Triesenberg~10|Vaduz~11"],["Lithuania","LT","Alytaus~AL|Kauno~KU|Klaipėdos~KL|Marijampolės~MR|Panevėžio~PN|Šiaulių~SA|Tauragės~TA|Telšių~TE|Utenos~UT|Vilniaus~VL"],["Luxembourg","LU","Capellen~CA|Clevaux~CL|Diekirch~DI|Echternach~EC|Esch-sur-Alzette~ES|Grevenmacher~GR|Luxembourg~LU|Mersch~ME|Redange~RD|Remich~RM|Vianden~VD|Wiltz~WI"],["Macao","MO","Macao~undefined"],["Macedonia, Republic of","MK","Aračinovo~02|Berovo~03|Bitola~04|Bogdanci~05|Bogovinje~06|Bosilovo~07|Brvenica~08|Centar Župa~78|Čaška~08|Češinovo-Obleševo~81|Čučer Sandevo~82|Debar~21|Debarca~22|Delčevo~23|Demir Hisar~25|Demir Kapija~24|Doran~26|Dolneni~27|Gevgelija~18|Gostivar~19|Gradsko~20|Ilinden~34|Jegunovce~35|Karbinci~37|Kavadarci~36|Kičevo~40|Kočani~42|Konče~41|Kratovo~43|Kriva Palanka~44|Krivogaštani~45|Kruševo~46|Kumanovo~47|Lipkovo~48|Lozovo~49|Makedonska Kamenica~51|Makedonski Brod~52|Mavrovo i Rostuša~50|Mogila~53|Negotino~54|Novaci~55|Novo Selo~56|Ohrid~58|Pehčevo~60|Petrovec~59|Plasnica~61|Prilep~62|Probištip~63|Radoviš~|Rankovce~65|Resen~66|Rosoman~67|Skopje~85|Sopište~70|Staro Nagoričane~71|Struga~72|Strumica~73|Studeničani~74|Sveti Nikole~69|Štip~83|Tearce~75|Tetovo~76|Valandovo~10|Vasilevo~11|Veles~13|Vevčani~12|Vinica~14|Vrapčište~16|Zelenikovo~32|Zrnovci~33|Želino~30"],["Madagascar","MG","Antananarivo~T|Antsiranana~D|Fianarantsoa~F|Mahajanga~M|Toamasina~A|Toliara~U"],["Malawi","MW","Balaka~BA|Blantyre~BL|Chikwawa~CK|Chiradzulu~CR|Chitipa~CT|Dedza~DE|Dowa~DO|Karonga~KR|Kasungu~KS|Likoma~LK|Lilongwe~LI|Machinga~MH|Mangochi~MG|Mchinji~MC|Mulanje~MU|Mwanza~MW|Mzimba~MZ|Nkhata Bay~NE|Nkhotakota~NB|Nsanje~NS|Ntcheu~NU|Ntchisi~NI|Phalombe~PH|Rumphi~RU|Salima~SA|Thyolo~TH|Zomba~ZO"],["Malaysia","MY","Johor~01|Kedah~02|Kelantan~03|Melaka~04|Negeri Sembilan~05|Pahang~06|Perak~08|Perlis~09|Pulau Pinang~07|Sabah~12|Sarawak~13|Selangor~10|Terengganu~11|Wilayah Persekutuan (Kuala Lumpur)~14|Wilayah Persekutuan (Labuan)~15|Wilayah Persekutuan (Putrajaya)~16"],["Maldives","MV","Alifu Alifu~02|Alifu Dhaalu~00|Baa~20|Dhaalu~17|Faafu~14|Gaafu Alifu~27|Gaafu Dhaalu~28|Gnaviyani~29|Haa Alifu~07|Haa Dhaalu~23|Kaafu~29|Laamu~05|Lhaviyani~03|Malé~MLE|Meemu~12|Noonu~25|Raa~13|Seenu~01|Shaviyani~24|Thaa~08|Vaavu~04"],["Mali","ML","Bamako~BKO|Gao~7|Kayes~1|Kidal~8|Koulikoro~2|Mopti~5|Segou~4|Sikasso~3|Tombouctou~6"],["Malta","MT","Attard~01|Balzan~02|Birgu~03|Birkirkara~04|Birżebbuġa~05|Bormla~06|Dingli~07|Fgura~08|Floriana~09|Fontana~10|Guda~11|Gżira~12|Għajnsielem~13|Għarb~14|Għargħur~15|Għasri~16|Għaxaq~17|Ħamrun~18|Iklin~19|Isla~20|Kalkara~21|Kerċem~22|Kirkop~23|Lija~24|Luqa~25|Marsa~26|Marsaskala~27|Marsaxlokk~28|Mdina~29|Mellieħa~30|Mġarr~31|Mosta~32|Mqabba~33|Msida~34|Mtarfa~35|Munxar~36|Nadur~37|Naxxar~38|Paola~39|Pembroke~40|Pietà~41|Qala~42|Qormi~43|Qrendi~44|Rabat Għawdex~45|Rabat Malta~46|Safi~47|San Ġiljan~48|San Ġwann~49|San Lawrenz~50|San Pawl il-Baħar~51|Sannat~52|Santa Luċija~53|Santa Venera~54|Siġġiewi~55|Sliema~56|Swieqi~57|Tai Xbiex~58|Tarzien~59|Valletta~60|Xagħra~61|Xewkija~62|Xgħajra~63|Żabbar~64|Żebbuġ Għawde~65|Żebbuġ Malta~66|Żejtun~67|Żurrieq~68"],["Marshall Islands","MH","Ailinglaplap~ALL|Ailuk~ALK|Arno~ARN|Aur~AUR|Bikini and Kili~KIL|Ebon~EBO|Jabat~JAB|Jaluit~JAL|Kwajalein~KWA|Lae~LAE|Lib~LIB|Likiep~LIK|Majuro~MAJ|Maloelap~MAL|Mejit~MEJ|Namdrik~NMK|Namu~NMU|Rongelap~RON|Ujae~UJA|Utrik~UTI|Wotho~WTH|Wotje~WTJ"],["Martinique","MQ","Martinique~undefined"],["Mauritania","MR","Adrar~07|Assaba~03|Brakna~05|Dakhlet Nouadhibou~08|Gorgol~04|Guidimaka~10|Hodh Ech Chargui~01|Hodh El Gharbi~02|Inchiri~12|Nouakchott Nord~14|Nouakchott Ouest~13|Nouakchott Sud~15|Tagant~09|Tiris Zemmour~11|Trarza~06"],["Mauritius","MU","Agalega Islands~AG|Beau Bassin-Rose Hill~BR|Black River~BL|Cargados Carajos Shoals~CC|Curepipe~CU|Flacq~FL|Grand Port~GP|Moka~MO|Pamplemousses~PA|Plaines Wilhems~PW|Port Louis (City)~PU|Port Louis~PL|Riviere du Rempart~RR|Rodrigues Island~RO|Savanne~SA|Vacoas-Phoenix~CP"],["Mayotte","YT","Dzaoudzi~01|Pamandzi~02|Mamoudzou~03|Dembeni~04|Bandrélé~05|Kani-Kéli~06|Bouéni~07|Chirongui~08|Sada~09|Ouangani~10|Chiconi~11|Tsingoni~12|M'Tsangamouji~13|Acoua~14|Mtsamboro~15|Bandraboua~16|Koungou~17"],["Mexico","MX","Aguascalientes~AGU|Baja California~BCN|Baja California Sur~BCS|Campeche~CAM|Ciudad de México~DIF|Chiapas~CHP|Chihuahua~CHH|Coahuila de Zaragoza~COA|Colima~COL|Durango~DUR|Estado de México~MEX|Guanajuato~GUA|Guerrero~GRO|Hidalgo~HID|Jalisco~JAL|Michoacán de Ocampo~MIC|Morelos~MOR|Nayarit~NAY|Nuevo León~NLE|Oaxaca~OAX|Puebla~PUE|Querétaro de Arteaga~QUE|Quintana Roo~ROO|San Luis Potosí~SLP|Sinaloa~SIN|Sonora~SON|Tabasco~TAB|Tamaulipas~TAM|Tlaxcala~TLA|Veracruz~VER|Yucatán~YUC|Zacatecas~ZAC"],["Micronesia, Federated States of","FM","Chuuk (Truk)~TRK|Kosrae~KSA|Pohnpei~PNI|Yap~YAP"],["Moldova","MD","Aenii Noi~AN|Basarabeasca~BS|Bălți~BA|Bender~BD|Briceni~BR|Cahul~CA|Cantemir~CT|Călărași~CL|Căușeni~CS|Chișinău~CU|Cimișlia~CM|Criuleni~CR|Dondușeni~DO|Drochia~DR|Dubăsari~DU|Edineț~ED|Fălești~FA|Florești~FL|Găgăuzia~GA|Glodeni~GL|Hîncești~HI|Ialoveni~IA|Leova~LE|Nisporeni~NI|Ocnița~OC|Orhei~OR|Rezina~RE|Rîșcani~RI|Sîngerei~SI|Soroca~SO|Stînga Nistrului~SN|Strășeni~ST|Șoldănești~SD|Ștefan Vodă~SV|Taraclia~TA|Telenești~TE|Ungheni~UN"],["Monaco","MC","Colle~CL|Condamine~CO|Fontvieille~FO|Gare~GA|Jardin Exotique~JE|Larvotto~LA|Malbousquet~MA|Monaco-Ville~MO|Moneghetti~MG|Monte-Carlo~MC|Moulins~MU|Port-Hercule~PH|Saint-Roman~SR|Sainte-Dévote~SD|Source~SO|Spélugues~SP|Vallon de la Rousse~VR"],["Mongolia","MN","Arhangay~073|Bayan-Olgiy~071|Bayanhongor~069|Bulgan~067|Darhan~037|Dornod~061|Dornogovi~063|Dundgovi~059|Dzavhan~065|Govi-Altay~065|Govi-Sumber~064|Hovd~043|Hovsgol~041|Omnogovi~053|Ovorhangay~055|Selenge~049|Suhbaatar~051|Tov~047|Ulaanbaatar~1|Uvs~046"],["Montenegro","ME","Andrijevica~01|Bar~02|Berane~03|Bijelo Polje~04|Budva~05|Cetinje~06|Danilovgrad~07|Gusinje~22|Herceg Novi~08|Kolašin~09|Kotor~10|Mojkovac~11|Nikšić~12|Petnica~23|Plav~13|Plužine~14|Pljevlja~15|Podgorica~16|Rožaje~17|Šavnik~18|Tivat~19|Ulcinj~20|Žabljak~21"],["Montserrat","MS","Saint Anthony~undefined|Saint Georges~undefined|Saint Peter's~undefined"],["Morocco","MA","Chaouia-Ouardigha~09|Doukhala-Abda~10|Fès-Boulemane~05|Gharb-Chrarda-Beni Hssen~02|Grand Casablanca~08|Guelmim-Es Semara~14|Laâyoune-Boujdour-Sakia el Hamra~15|Marrakech-Tensift-Al Haouz~11|Meknès-Tafilalet~06|Oriental~04|Oued ed Dahab-Lagouira~16|Souss-Massa-Drâa~13|Tadla-Azilal~12|Tanger-Tétouan~01|Taza-Al Hoceima-Taounate~03"],["Mozambique","MZ","Cabo Delgado~P|Gaza~G|Inhambane~I|Manica~B|Maputo~L|Maputo (City)~MPM|Nampula~N|Niassa~A|Sofala~S|Tete~T|Zambezia~Q"],["Myanmar","MM","Ayeyarwady~07|Bago~02|Chin~14|Kachin~11|Kayah~12|Kayin~13|Magway~03|Mandalay~04|Mon~15|Nay Pyi Taw~18|Rakhine~16|Sagaing~01|Shan~17|Tanintharyi~05|Yangon~06"],["Namibia","NA","Erongo~ER|Hardap~HA|Kavango East~KE|Kavango West~KW|Karas~KA|Khomas~KH|Kunene~KU|Ohangwena~OW|Omaheke~OH|Omusati~OS|Oshana~ON|Oshikoto~OT|Otjozondjupa~OD|Zambezi~CA"],["Nauru","NR","Aiwo~01|Anabar~02|Anetan~03|Anibare~04|Baiti~05|Boe~06|Buada~07|Denigomodu~08|Ewa~09|Ijuw~10|Meneng~11|Nibok~12|Uaboe~13|Yaren~14"],["Nepal","NP","Bagmati~BA|Bheri~BH|Dhawalagiri~DH|Gandaki~GA|Janakpur~JA|Karnali~KA|Kosi~KO|Lumbini~LU|Mahakali~MA|Mechi~ME|Narayani~NA|Rapti~RA|Sagarmatha~SA|Seti~SE"],["Netherlands","NL","Drenthe~DR|Flevoland~FL|Friesland~FR|Gelderland~GE|Groningen~GR|Limburg~LI|Noord-Brabant~NB|Noord-Holland~NH|Overijssel~OV|Utrecht~UT|Zeeland~ZE|Zuid-Holland~ZH"],["New Caledonia","NC","Iles Loyaute~undefined|Nord~undefined|Sud~undefined"],["New Zealand","NZ","Auckland~AUK|Bay of Plenty~BOP|Canterbury~CAN|Gisborne~GIS|Hawke's Bay~HKB|Marlborough~MBH|Manawatu-Wanganui~MWT|Northland~NTL|Nelson~NSN|Otago~OTA|Southland~STL|Taranaki~TKI|Tasman~TAS|Waikato~WKO|Wellington~WGN|West Coast~WTC|Chatham Islands Territory~CIT"],["Nicaragua","NI","Boaco~BO|Carazo~CA|Chinandega~CI|Chontales~CO|Estelí~ES|Granada~GR|Jinotega~JI|León~LE|Madriz~MD|Managua~MN|Masaya~MS|Matagalpa~MT|Nueva Segovia~NS|Río San Juan~SJ|Rivas~RI|Atlántico Norte~AN|Atlántico Sur~AS"],["Niger","NE","Agadez~1|Diffa~2|Dosso~3|Maradi~4|Niamey~8|Tahoua~5|Tillabéri~6|Zinder~7"],["Nigeria","NG","Abia~AB|Abuja Federal Capital Territory~FC|Adamawa~AD|Akwa Ibom~AK|Anambra~AN|Bauchi~BA|Bayelsa~BY|Benue~BE|Borno~BO|Cross River~CR|Delta~DE|Ebonyi~EB|Edo~ED|Ekiti~EK|Enugu~EN|Gombe~GO|Imo~IM|Jigawa~JI|Kaduna~KD|Kano~KN|Katsina~KT|Kebbi~KE|Kogi~KO|Kwara~KW|Lagos~LA|Nassarawa~NA|Niger~NI|Ogun~OG|Ondo~ON|Osun~OS|Oyo~OY|Plateau~PL|Rivers~RI|Sokoto~SO|Taraba~TA|Yobe~YO|Zamfara~ZA"],["Niue","NU","Niue~undefined"],["Norfolk Island","NF","Norfolk Island~undefined"],["Northern Mariana Islands","MP","Northern Islands~undefined|Rota~undefined|Saipan~undefined|Tinian~undefined"],["Norway","NO","Akershus~02|Aust-Agder~09|Buskerud~06|Finnmark~20|Hedmark~04|Hordaland~12|Møre og Romsdal~15|Nordland~18|Nord-Trøndelag~17|Oppland~05|Oslo~03|Rogaland~11|Sogn og Fjordane~14|Sør-Trøndelag~16|Telemark~08|Troms~19|Vest-Agder~10|Vestfold~07|Østfold~01|Jan Mayen~22|Svalbard~21"],["Oman","OM","Ad Dakhiliyah~DA|Al Buraymi~BU|Al Wusta~WU|Az Zahirah~ZA|Janub al Batinah~BS|Janub ash Sharqiyah~SS|Masqat~MA|Musandam~MU|Shamal al Batinah~BJ|Shamal ash Sharqiyah~SJ|Zufar~ZU"],["Pakistan","PK","Āzād Kashmīr~JK|Balōchistān~BA|Gilgit-Baltistān~GB|Islāmābād~IS|Khaībar Pakhtūnkhwās~KP|Punjāb~PB|Sindh~SD|Federally Administered Tribal Areas~TA"],["Palau","PW","Aimeliik~002|Airai~004|Angaur~010|Hatobohei~050|Kayangel~100|Koror~150|Melekeok~212|Ngaraard~214|Ngarchelong~218|Ngardmau~222|Ngatpang~224|Ngchesar~226|Ngeremlengui~227|Ngiwal~228|Peleliu~350|Sonsoral~350"],["Palestine, State of","PS","Ak Khalīl~HBN|Al Quds~JEM|Arīḩā wal Aghwār~JRH|Bayt Laḩm~BTH|Dayr al Balaḩ~DEB|Ghazzah~GZA|Janīn~JEN|Khān Yūnis~KYS|Nāblus~NBS|Qalqīyah~QQA|Rafaḩ~RFH|Rām Allāh wal Bīrah~RBH|Salfīt~SLT|Shamāl Ghazzah~NGZ|Ţūbās~TBS|Ţūlkarm~TKM"],["Panama","PA","Bocas del Toro~1|Chiriquí~4|Coclé~2|Colón~3|Darién~5|Emberá~EM|Herrera~6|Kuna Yala~KY|Los Santos~7|Ngäbe-Buglé~NB|Panamá~8|Panamá Oeste~10|Veraguas~9"],["Papua New Guinea","PG","Bougainville~NSB|Central~CPM|Chimbu~CPK|East New Britain~EBR|East Sepik~ESW|Eastern Highlands~EHG|Enga~EPW|Gulf~GPK|Hela~HLA|Jiwaka~JWK|Madang~MOM|Manus~MRL|Milne Bay~MBA|Morobe~MPL|Port Moresby~NCD|New Ireland~NIK|Northern~NPP|Southern Highlands~SHM|West New Britain~WBK|West Sepik~SAN|Western~WPD|Western Highlands~WHM"],["Paraguay","PY","Alto Paraguay~16|Alto Parana~10|Amambay~13|Asuncion~ASU|Caaguazu~5|Caazapa~6|Canindeyu~14|Central~11|Concepcion~1|Cordillera~3|Guaira~4|Itapua~7|Misiones~8|Neembucu~12|Paraguari~9|Presidente Hayes~15|San Pedro~2"],["Peru","PE","Amazonas~AMA|Ancash~ANC|Apurimac~APU|Arequipa~ARE|Ayacucho~AYA|Cajamarca~CAJ|Callao~CAL|Cusco~CUS|Huancavelica~HUV|Huanuco~HUC|Ica~ICA|Junin~JUN|La Libertad~LAL|Lambayeque~LAM|Lima~LIM|Loreto~LOR|Madre de Dios~MDD|Moquegua~MOQ|Municipalidad Metropolitana de Lima~LMA|Pasco~PAS|Piura~PIU|Puno~PUN|San Martin~SAM|Tacna~TAC|Tumbes~TUM|Ucayali~UCA"],["Philippines","PH","Abra~ABR|Agusan del Norte~AGN|Agusan del Sur~AGS|Aklan~AKL|Albay~ALB|Antique~ANT|Apayao~APA|Aurora~AUR|Basilan~BAS|Bataan~BAN|Batanes~BTN|Batangas~BTG|Benguet~BEN|Biliran~BIL|Bohol~BOH|Bukidnon~BUK|Bulacan~BUL|Cagayan~CAG|Camarines Norte~CAN|Camarines Sur~CAS|Camiguin~CAM|Capiz~CAP|Catanduanes~CAT|Cavite~CAV|Cebu~CEB|Compostela~COM|Cotabato~NCO|Davao del Norte~DAV|Davao del Sur~DAS|Davao Occidental~DVO|Davao Oriental~DAO|Dinagat Islands~DIN|Eastern Samar~EAS|Guimaras~GUI|Ifugao~IFU|Ilocos Norte~ILN|Ilocos Sur~ILS|Iloilo~ILI|Isabela~ISA|Kalinga~KAL|La Union~LUN|Laguna~LAG|Lanao del Norte~LAN|Lanao del Sur~LAS|Leyte~LEY|Maguindanao~MAG|Masbate~MAS|Metro Manila~00|Mindoro Occidental~MDC|Mindoro Oriental~MDR|Misamis Occidental~MSC|Misamis Oriental~MSR|Mountain Province~MOU|Negros Occidental~NEC|Negros Oriental~NER|Northern Samar~NSA|Nueva Ecija~NUE|Nueva Vizcaya~NUV|Palawan~PLW|Pampanga~PAM|Pangasinan~PAN|Quezon~QUE|Quirino~QUI|Rizal~RIZ|Romblon~ROM|Samar~WSA|Sarangani~SAR|Siquijor~SIG|Sorsogon~SOR|Southern Leyte~SLE|Sultan Kudarat~AUK|Sulu~SLU|Surigao del Norte~SUN|Surigao del Sur~SUR|Tarlac~TAR|Tawi-Tawi~TAW|Zambales~ZMB|Zamboanga del Norte~ZAN|Zamboanga del Sur~ZAS|Zamboanga Sibugay~ZSI"],["Pitcairn","PN","Pitcairn Islands~undefined"],["Poland","PL","Dolnośląskie~DS|Kujawsko-pomorskie~KP|Łódzkie~LD|Lubelskie~LU|Lubuskie~LB|Małopolskie~MA|Mazowieckie~MZ|Opolskie~OP|Podkarpackie~PK|Podlaskie~PD|Pomorskie~PM|Śląskie~SL|Świętokrzyskie~SK|Warmińsko-mazurskie~WN|Wielkopolskie~WP|Zachodniopomorskie~ZP"],["Portugal","PT","Açores~20|Aveiro~01|Beja~02|Braga~03|Bragança~04|Castelo Branco~05|Coimbra~06|Évora~07|Faro~08|Guarda~09|Leiria~10|Lisboa~11|Madeira~30|Portalegre~12|Porto~13|Santarém~14|Setúbal~15|Viana do Castelo~16|Vila Real~17|Viseu~18"],["Puerto Rico","PR","Adjuntas~undefined|Aguada~undefined|Aguadilla~undefined|Aguas Buenas~undefined|Aibonito~undefined|Anasco~undefined|Arecibo~undefined|Arroyo~undefined|Barceloneta~undefined|Barranquitas~undefined|Bayamon~undefined|Cabo Rojo~undefined|Caguas~undefined|Camuy~undefined|Canovanas~undefined|Carolina~undefined|Cat~undefined|Ceiba~undefined|Ciales~undefined|Cidra~undefined|Coamo~undefined|Comerio~undefined|Corozal~undefined|Culebra~undefined|Dorado~undefined|Fajardo~undefined|Florida~undefined|Guanica~undefined|Guayama~undefined|Guayanilla~undefined|Guaynabo~undefined|Gurabo~undefined|Hatillo~undefined|Hormigueros~undefined|Humacao~undefined|Isabe~undefined|Juana Diaz~undefined|Juncos~undefined|Lajas~undefined|Lares~undefined|Las Marias~undefined|Las oiza~undefined|Luquillo~undefined|Manati~undefined|Maricao~undefined|Maunabo~undefined|Mayaguez~undefined|Moca~undefined|Morovis~undefined|Naguabo~undefined|Naranjito~undefined|Orocovis~undefined|Patillas~undefined|Penuelas~undefined|Ponce~undefined|Quebradillas~undefined|Rincon~undefined|Rio Grande~undefined|Sabana linas~undefined|San German~undefined|San Juan~undefined|San Lorenzo~undefined|San Sebastian~undefined|Santa Isabel~undefined|Toa Alta~undefined|Toa Baja~undefined|Trujillo Alto~undefined|Utuado~undefined|Vega Alta~undefined|Vega ues~undefined|Villalba~undefined|Yabucoa~undefined|Yauco~undefined"],["Qatar","QA","Ad Dawḩah~DA|Al Khawr wa adh Dhakhīrah~KH|Al Wakrah~WA|Ar Rayyān~RA|Ash Shamāl~MS|Az̧ Za̧`āyin~ZA|Umm Şalāl~US"],["Réunion","RE","Réunion~undefined"],["Romania","RO","Alba~AB|Arad~AR|Arges~AG|Bacau~BC|Bihor~BH|Bistrita-Nasaud~BN|Botosani~BT|Braila~BR|Brasov~BV|Bucuresti~B|Buzau~BZ|Calarasi~CL|Caras-Severin~CS|Cluj~CJ|Constanta~CT|Covasna~CV|Dambovita~DB|Dolj~DJ|Galati~GL|Giurgiu~GR|Gorj~GJ|Harghita~HR|Hunedoara~HD|Ialomita~IL|Iasi~IS|Maramures~MM|Mehedinti~MH|Mures~MS|Neamt~NT|Olt~OT|Prahova~PH|Salaj~SJ|Satu Mare~SM|Sibiu~SB|Suceava~SV|Teleorman~TR|Timis~TM|Tulcea~TL|Valcea~VL|Vaslui~VS|Vrancea~VN"],["Russian Federation","RU","Republic of Adygea~AD|Republic of Altai (Gorno-Altaysk)~AL|Altai Krai~ALT|Amur Oblast~AMU|Arkhangelsk Oblast~ARK|Astrakhan Oblast~AST|Republic of Bashkortostan~BA|Belgorod Oblast~BEL|Bryansk Oblast~BRY|Republic of Buryatia~BU|Chechen Republic~CE|Chelyabinsk Oblast~CHE|Chukotka Autonomous Okrug~CHU|Chuvash Republic~CU|Republic of Dagestan~DA|Republic of Ingushetia~IN|Irkutsk Oblast~IRK|Ivanovo Oblast~IVA|Jewish Autonomous Oblast~JEW|Kabardino-Balkar Republic~KB|Kaliningrad Oblast~KLN|Republic of Kalmykia~KL|Kaluga Oblast~KLU|Kamchatka Krai~KAM|Karachay-Cherkess Republic~KC|Republic of Karelia~KR|Khabarovsk Krai~KHA|Republic of Khakassia~KK|Khanty-Mansi Autonomous Okrug - Yugra~KHM|Kemerovo Oblast~KEM|Kirov Oblast~KIR|Komi Republic~KO|Kostroma Oblast~KOS|Krasnodar Krai~KDA|Krasnoyarsk Krai~KYA|Kurgan Oblast~KGN|Kursk Oblast~KRS|Leningrad Oblast~LEN|Lipetsk Oblast~LIP|Magadan Oblast~MAG|Mari El Republic~ME|Republic of Mordovia~MO|Moscow Oblast~MOS|Moscow~MOW|Murmansk Oblast~MU|Nenets Autonomous Okrug~NEN|Nizhny Novgorod Oblast~NIZ|Novgorod Oblast~NGR|Novosibirsk Oblast~NVS|Omsk Oblast~OMS|Orenburg Oblast~ORE|Oryol Oblast~ORL|Penza Oblast~PNZ|Perm Krai~PER|Primorsky Krai~PRI|Pskov Oblast~PSK|Rostov Oblast~ROS|Ryazan Oblast~RYA|Saint Petersburg~SPE|Sakha (Yakutia) Republic~SA|Sakhalin Oblast~SAK|Samara Oblast~SAM|Saratov Oblast~SAR|Republic of North Ossetia-Alania~NOA|Smolensk Oblast~SMO|Stavropol Krai~STA|Sverdlovsk Oblast~SVE|Tambov Oblast~TAM|Republic of Tatarstan~TA|Tomsk Oblast~TOM|Tuva Republic~TU|Tula Oblast~TUL|Tver Oblast~TVE|Tyumen Oblast~TYU|Udmurt Republic~UD|Ulyanovsk Oblast~ULY|Vladimir Oblast~VLA|Volgograd Oblast~VGG|Vologda Oblast~VLG|Voronezh Oblast~VOR|Yamalo-Nenets Autonomous Okrug~YAN|Yaroslavl Oblast~YAR|Zabaykalsky Krai~ZAB"],["Rwanda","RW","Kigali~01|Eastern~02|Northern~03|Western~04|Southern~05"],["Saint Barthélemy","BL","Au Vent~02|Sous le Vent~01"],["Saint Helena, Ascension and Tristan da Cunha","SH","Ascension~AC|Saint Helena~HL|Tristan da Cunha~TA"],["Saint Kitts and Nevis","KN","Saint Kitts~K|Nevis~N"],["Saint Lucia","LC","Anse-la-Raye~01|Canaries~12|Castries~02|Choiseul~03|Dennery~05|Gros Islet~06|Laborie~07|Micoud~08|Soufriere~10|Vieux Fort~11"],["Saint Martin","MF","Saint Martin~undefined"],["Saint Pierre and Miquelon","PM","Miquelon~undefined|Saint Pierre~undefined"],["Saint Vincent and the Grenadines","VC","Charlotte~01|Grenadines~06|Saint Andrew~02|Saint David~03|Saint George~04|Saint Patrick~05"],["Samoa","WS","A'ana~AA|Aiga-i-le-Tai~AL|Atua~AT|Fa'asaleleaga~FA|Gaga'emauga~GE|Gagaifomauga~GI|Palauli~PA|Satupa'itea~SA|Tuamasaga~TU|Va'a-o-Fonoti~VF|Vaisigano~VS"],["San Marino","SM","Acquaviva~01|Borgo Maggiore~06|Chiesanuova~02|Domagnano~03|Faetano~04|Fiorentino~05|Montegiardino~08|San Marino~07|Serravalle~09"],["Sao Tome and Principe","ST","Principe~P|Sao Tome~S"],["Saudi Arabia","SA","'Asir~14|Al Bahah~11|Al Hudud ash Shamaliyah~08|Al Jawf~12|Al Madinah al Munawwarah~03|Al Qasim~05|Ar Riyad~01|Ash Sharqiyah~04|Ha'il~06|Jazan~09|Makkah al Mukarramah~02|Najran~10|Tabuk~07"],["Senegal","SN","Dakar~DK|Diourbel~DB|Fatick~FK|Kaffrine~KA|Kaolack~KL|Kedougou~KE|Kolda~KD|Louga~LG|Matam~MT|Saint-Louis~SL|Sedhiou~SE|Tambacounda~TC|Thies~TH|Ziguinchor~ZG"],["Serbia","RS","Beograd (Belgrade)~00|Borski~14|Braničevski~11|Jablanički~23|Južnobački~06|Južnobanatski~04|Kolubarski~09|Kosovski~25|Kosovsko-Mitrovački~28|Kosovsko-Pomoravski~29|Mačvanski~08|Moravički~17|Nišavski~20|Pčinjski~24|Pećki~26|Pirotski~22|Podunavski~10|Pomoravski~13|Prizrenski~27|Rasinski~19|Raški~18|Severnobački~01|Severnobanatski~03|Srednjebanatski~02|Sremski~07|Šumadijski~12|Toplički~21|Zaječarski~15|Zapadnobački~05|Zlatiborski~16"],["Seychelles","SC","Anse aux Pins~01|Anse Boileau~02|Anse Etoile~03|Anse Royale~05|Anu Cap~04|Baie Lazare~06|Baie Sainte Anne~07|Beau Vallon~08|Bel Air~09|Bel Ombre~10|Cascade~11|Glacis~12|Grand'Anse Mahe~13|Grand'Anse Praslin~14|La Digue~15|La Riviere Anglaise~16|Les Mamelles~24|Mont Buxton~17|Mont Fleuri~18|Plaisance~19|Pointe La Rue~20|Port Glaud~21|Roche Caiman~25|Saint Louis~22|Takamaka~23"],["Sierra Leone","SL","Eastern~E|Northern~N|Southern~S|Western~W"],["Singapore","SG","Central Singapore~01|North East~02|North West~03|South East~04|South West~05"],["Sint Maarten (Dutch part)","SX","Sint Maarten~undefined"],["Slovakia","SK","Banskobystricky~BC|Bratislavsky~BL|Kosicky~KI|Nitriansky~NI|Presovsky~PV|Trenciansky~TC|Trnavsky~TA|Zilinsky~ZI"],["Slovenia","SI","Ajdovscina~001|Apace~195|Beltinci~002|Benedikt~148|Bistrica ob Sotli~149|Bled~003|Bloke~150|Bohinj~004|Borovnica~005|Bovec~006|Braslovce~151|Brda~007|Brezice~009|Brezovica~008|Cankova~152|Celje~011|Cerklje na Gorenjskem~012|Cerknica~013|Cerkno~014|Cerkvenjak~153|Cirkulane~196|Crensovci~015|Crna na Koroskem~016|Crnomelj~017|Destrnik~018|Divaca~019|Dobje~154|Dobrepolje~020|Dobrna~155|Dobrova-Polhov Gradec~021|Dobrovnik~156|Dol pri Ljubljani~022|Dolenjske Toplice~157|Domzale~023|Dornava~024|Dravograd~025|Duplek~026|Gorenja Vas-Poljane~027|Gorisnica~028|Gorje~207|Gornja Radgona~029|Gornji Grad~030|Gornji Petrovci~031|Grad~158|Grosuplje~032|Hajdina~159|Hoce-Slivnica~160|Hodos~161|Horjul~162|Hrastnik~034|Hrpelje-Kozina~035|Idrija~036|Ig~037|Ilirska Bistrica~038|Ivancna Gorica~039|Izola~040s|Jesenice~041|Jursinci~042|Kamnik~043|Kanal~044|Kidricevo~045|Kobarid~046|Kobilje~047|Kocevje~048|Komen~049|Komenda~164|Koper~050|Kodanjevica na Krki~197|Kostel~165|Kozje~051|Kranj~052|Kranjska Gora~053|Krizevci~166|Krsko~054|Kungota~055|Kuzma~056|Lasko~057|Lenart~058|Lendava~059|Litija~068|Ljubljana~061|Ljubno~062|Ljutomer~063|Log-Dragomer~208|Logatec~064|Loska Dolina~065|Loski Potok~066|Lovrenc na Pohorju~167|Lukovica~068|Luce~067|Majsperk~069|Makole~198|Maribor~070|Markovci~168|Medvode~071|Menges~072|Metlika~073|Mezica~074|Miklavz na Dravskem Polju~169|Miren-Kostanjevica~075|Mirna~212|Mirna Pec~170|Mislinja~076|Mokronog-Trebelno~199|Moravce~077|Moravske Toplice~078|Mozirje~079|Murska Sobota~080|Naklo~082|Nazarje~083|Nova Gorica~084|Novo Mesto~085|Odranci~086|Ormoz~087|Osilnica~088|Pesnica~089|Piran~090|Pivka~091|Podcetrtek~092|Podlehnik~172|Podvelka~093|Poljcane~200|Postojna~094|Prebold~174|Preddvor~095|Prevalje~175|Ptuj~096|Race-Fram~098|Radece~099|Radenci~100|Radlje ob Dravi~101|Radovljica~102|Ravne na Koroskem~103|Razkrizje~176|Recica ob Savinji~209|Rence-Vogrsko~201|Ribnica~104|Ribnica na Poboriu~177|Rogaska Slatina~106|Rogasovci~105|Rogatec~107|Ruse~108|Salovci~033|Selnica ob Dravi~178|Semic~109|Sempeter-Vrtojba~183|Sencur~117|Sentilj~118|Sentjernej~119|Sentjur~120|Sentrupert~211|Sevnica~110|Sezana~111|Skocjan~121|Skofja Loka~122|Skofljica~123|Slovenj Gradec~112|Slovenska Bistrica~113|Slovenske Konjice~114|Smarje pri elsah~124|Smarjeske Toplice~206|Smartno ob Paki~125|Smartno pri Litiji~194|Sodrazica~179|Solcava~180|Sostanj~126|Sredisce ob Dravi~202|Starse~115|Store~127|Straza~203|Sveta Ana~181|Sveta Trojica v Slovenskih Goricah~204|Sveta Andraz v Slovenskih Goricah~182|Sveti Jurij~116|Sveti Jurij v Slovenskih Goricah~210|Sveti Tomaz~205|Tabor~184|Tisina~128|Tolmin~128|Trbovlje~129|Trebnje~130|Trnovska Vas~185|Trzin~186|Trzic~131|Turnisce~132|Velenje~133|Velika Polana~187|Velike Lasce~134|Verzej~188|Videm~135|Vipava~136|Vitanje~137|Vodice~138|Vojnik~139|Vransko~189|Vrhnika~140|Vuzenica~141|Zagorje ob Savi~142|Zavrc~143|Zrece~144|Zalec~190|Zelezniki~146|Zetale~191|Ziri~147|Zirovnica~192|Zuzemberk~193"],["Solomon Islands","SB","Central~CE|Choiseul~CH|Guadalcanal~GU|Honiara~CT|Isabel~IS|Makira-Ulawa~MK|Malaita~ML|Rennell and Bellona~RB|Temotu~TE|Western~WE"],["Somalia","SO","Awdal~AW|Bakool~BK|Banaadir~BN|Bari~BR|Bay~BY|Galguduud~GA|Gedo~GE|Hiiraan~HI|Jubbada Dhexe~JD|Jubbada Hoose~JH|Mudug~MU|Nugaal~NU|Sanaag~SA|Shabeellaha Dhexe~SD|Shabeellaha Hoose~SH|Sool~SO|Togdheer~TO|Woqooyi Galbeed~WO"],["South Africa","ZA","Eastern Cape~EC|Free State~FS|Gauteng~GT|KwaZulu-Natal~NL|Limpopo~LP|Mpumalanga~MP|Northern Cape~NC|North West~NW|Western Cape~WC"],["South Georgia and South Sandwich Islands","GS","Bird Island~undefined|Bristol Island~undefined|Clerke Rocks~undefined|Montagu Island~undefined|Saunders Island~undefined|South Georgia~undefined|Southern Thule~undefined|Traversay Islands~undefined"],["South Sudan","SS","Central Equatoria~CE|Eastern Equatoria~EE|Jonglei~JG|Lakes~LK|Northern Bahr el Ghazal~BN|Unity~UY|Upper Nile~NU|Warrap~WR|Western Bahr el Ghazal~BW|Western Equatoria~EW"],["Spain","ES","Albacete~CM|Alicante~VC|Almería~AN|Araba/Álava~VI|Asturias~O|Ávila~AV|Badajoz~BA|Barcelona~B|Bizkaia~BI|Burgos~BU|Cáceres~CC|Cádiz~CA|Cantabria~S|Castellón~CS|Cueta~CU|Ciudad Real~CR|Córdoba~CO|A Coruña~C|Cuenca~CU|Gipuzkoa~SS|Girona~GI|Granada~GR|Guadalajara~GU|Huelva~H|Huesca~HU|Illes Balears~PM|Jaén~J|León~LE|Lleida~L|Lugo~LU|Madrid~M|Málaga~MA|Melilla~ML|Murcia~MU|Navarre~NA|Ourense~OR|Palencia~P|Las Palmas~GC|Pontevedra~PO|La Rioja~LO|Salamanca~SA|Santa Cruz de Tenerife~TF|Segovia~SG|Sevilla~SE|Soria~SO|Tarragona~T|Teruel~TE|Toledo~TO|Valencia~V|Valladolid~VA|Zamora~ZA|Zaragoza~Z"],["Sri Lanka","LK","Basnahira~1|Dakunu~3|Madhyama~2|Naegenahira~5|Sabaragamuwa~9|Uturu~4|Uturumaeda~7|Vayamba~6|Uva~8"],["Sudan","SD","Al Bahr al Ahmar~RS|Al Jazirah~GZ|Al Khartum~KH|Al Qadarif~GD|An Nil al Abyad~NW|An Nil al Azraq~NB|Ash Shamaliyah~NO|Gharb Darfur~DW|Gharb Kurdufan~GK|Janub Darfur~DS|Janub Kurdufan~KS|Kassala~KA|Nahr an Nil~NR|Shamal Darfur~DN|Sharq Darfur~DE|Shiamal Kurdufan~KN|Sinnar~SI|Wasat Darfur Zalinjay~DC"],["Suriname","SR","Brokopondo~BR|Commewijne~CM|Coronie~CR|Marowijne~MA|Nickerie~NI|Para~PR|Paramaribo~PM|Saramacca~SA|Sipaliwini~SI|Wanica~WA"],["Swaziland","SZ","Hhohho~HH|Lubombo~LU|Manzini~MA|Shiselweni~SH"],["Sweden","SE","Blekinge~K|Dalarna~W|Gävleborg~X|Gotland~I|Halland~N|Jämtland~Z|Jönköping~F|Kalmar~H|Kronoberg~G|Norrbotten~BD|Örebro~T|Östergötland~E|Skåne~M|Södermanland~D|Stockholm~AB|Uppsala~C|Värmland~S|Västerbotten~AC|Västernorrland~Y|Västmanland~U|Västra Götaland~O"],["Switzerland","CH","Aargau~AG|Appenzell Ausserrhoden~AR|Appenzell Innerhoden~AI|Basel-Landschaft~BL|Basel-Stadt~BS|Bern~BE|Fribourg~FR|Genève~GE|Glarus~GL|Graubünden~GR|Jura~JU|Luzern~LU|Neuchâtel~NE|Nidwalden~NW|Obwalden~OW|Sankt Gallen~SG|Schaffhausen~SH|Schwyz~SZ|Solothurn~SO|Thurgau~TG|Ticino~TI|Uri~UR|Valais~VS|Vaud~VD|Zug~ZG|Zürich~ZH"],["Syrian Arab Republic","SY","Al Hasakah~HA|Al Ladhiqiyah~LA|Al Qunaytirah~QU|Ar Raqqah~RA|As Suwayda'~SU|Dar'a~DR|Dayr az Zawr~DY|Dimashq~DI|Halab~HL|Hamah~HM|Hims~HI|Idlib~ID|Rif Dimashq~RD|Tartus~TA"],["Taiwan","TW","Chang-hua~CHA|Chia-i~CYQ|Hsin-chu~HSQ|Hua-lien~HUA|Kao-hsiung~KHH|Keelung~KEE|Kinmen~KIN|Lienchiang~LIE|Miao-li~MIA|Nan-t'ou~NAN|P'eng-hu~PEN|New Taipei~NWT|P'ing-chung~PIF|T'ai-chung~TXG|T'ai-nan~TNN|T'ai-pei~TPE|T'ai-tung~TTT|T'ao-yuan~TAO|Yi-lan~ILA|Yun-lin~YUN"],["Tajikistan","TJ","Dushanbe~DU|Kŭhistoni Badakhshon~GB|Khatlon~KT|Sughd~SU"],["Tanzania, United Republic of","TZ","Arusha~01|Coast~19|Dar es Salaam~02|Dodoma~03|Iringa~04|Kagera~05|Kigoma~08|Kilimanjaro~09|Lindi~12|Manyara~26|Mara~13|Mbeya~14|Morogoro~16|Mtwara~17|Mwanza~18|Pemba North~06|Pemba South~10|Rukwa~20|Ruvuma~21|Shinyanga~22|Singida~23|Tabora~24|Tanga~25|Zanzibar North~07|Zanzibar Central/South~11|Zanzibar Urban/West~15"],["Thailand","TH","Amnat Charoen~37|Ang Thong~15|Bueng Kan~38|Buri Ram~31|Chachoengsao~24|Chai Nat~18|Chaiyaphum~36|Chanthaburi~22|Chiang Mai~50|Chiang Rai~57|Chon Buri~20|Chumphon~86|Kalasin~46|Kamphaeng Phet~62|Kanchanaburi~71|Khon Kaen~40|Krabi~81|Krung Thep Mahanakhon (Bangkok)~10|Lampang~52|Lamphun~51|Loei~42|Lop Buri~16|Mae Hong Son~58|Maha Sarakham~44|Mukdahan~49|Nakhon Nayok~26|Nakhon Phathom~73|Nakhon Phanom~48|Nakhon Ratchasima~30|Nakhon Sawan~60|Nakhon Si Thammarat~80|Nan~55|Narathiwat~96|Nong Bua Lam Phu~39|Nong Khai~43|Nonthaburi~12|Pathum Thani~13|Pattani~94|Phangnga~82|Phatthalung~93|Phayao~56|Phetchabun~76|Phetchaburi~76|Phichit~66|Phitsanulok~65|Phra Nakhon Si Ayutthaya~14|Phrae~54|Phuket~83|Prachin Buri~25|Prachuap Khiri Khan~77|Ranong~85|Ratchaburi~70|Rayong~21|Roi Et~45|Sa Kaeo~27|Sakon Nakhon~47|Samut Prakan~11|Samut Sakhon~74|Samut Songkhram~75|Saraburi~19|Satun~91|Sing Buri~17|Si Sa ket~33|Songkhla~90|Sukhothai~64|Suphan Buri~72|Surat Thani~84|Surin~32|Tak~63|Trang~92|Trat~23|Ubon Ratchathani~34|Udon Thani~41|Uthai Thani~61|Uttaradit~53|Yala~95|Yasothon~35"],["Timor-Leste","TL","Aileu~AL|Ainaro~AN|Baucau~BA|Bobonaro~BO|Cova Lima~CO|Dili~DI|Ermera~ER|Lautem~LA|Liquica~LI|Manatuto~MT|Manufahi~MF|Oecussi~OE|Viqueque~VI"],["Togo","TG","Centre~C|Kara~K|Maritime~M|Plateaux~P|Savannes~S"],["Tokelau","TK","Atafu~undefined|Fakaofo~undefined|Nukunonu~undefined"],["Tonga","TO","'Eua~01|Ha'apai~02|Niuas~03|Tongatapu~04|Vava'u~05"],["Trinidad and Tobago","TT","Arima~ARI|Chaguanas~CHA|Couva-Tabaquite-Talparo~CTT|Diefo Martin~DMN|Mayaro-Rio Claro~MRC|Penal-Debe~PED|Point Fortin~PTF|Port-of-Spain~POS|Princes Town~PRT|San Fernando~SFO|San Juan-Laventille~SJL|Sangre Grande~SGE|Siparia~SIP|Tobago~TOB|Tunapuna-Piarco~TUP"],["Tunisia","TN","Ariana~12|Beja~31|Ben Arous~13|Bizerte~23|Gabes~81|Gafsa~71|Jendouba~32|Kairouan~41|Kasserine~42|Kebili~73|Kef~33|Mahdia~53|Medenine~82|Monastir~52|Nabeul~21|Sfax~61|Sidi Bouzid~43|Siliana~34|Sousse~51|Tataouine~83|Tozeur~72|Tunis~11|Zaghouan~22"],["Turkey","TR","Adana~01|Adiyaman~02|Afyonkarahisar~03|Agri~04|Aksaray~68|Amasya~05|Ankara~06|Antalya~07|Ardahan~75|Artvin~08|Aydin~09|Balikesir~10|Bartin~74|Batman~72|Bayburt~69|Bilecik~11|Bingol~12|Bitlis~13|Bolu~14|Burdur~15|Bursa~16|Canakkale~17|Cankiri~18|Corum~19|Denizli~20|Diyarbakir~21|Duzce~81|Edirne~22|Elazig~23|Erzincan~24|Erzurum~25|Eskisehir~26|Gaziantep~27|Giresun~28|Gumushane~29|Hakkari~30|Hatay~31|Igdir~76|Isparta~32|Istanbul~34|Izmir~35|Kahramanmaras~46|Karabuk~78|Karaman~70|Kars~36|Kastamonu~37|Kayseri~38|Kilis~79|Kirikkale~71|Kirklareli~39|Kirsehir~40|Kocaeli~41|Konya~42|Kutahya~43|Malatya~44|Manisa~45|Mardin~47|Mersin~33|Mugla~48|Mus~49|Nevsehir~50|Nigde~51|Ordu~52|Osmaniye~80|Rize~53|Sakarya~54|Samsun~55|Sanliurfa~63|Siirt~56|Sinop~57|Sirnak~73|Sivas~58|Tekirdag~59|Tokat~60|Trabzon~61|Tunceli~62|Usak~64|Van~65|Yalova~77|Yozgat~66|Zonguldak~67"],["Turkmenistan","TM","Ahal~A|Asgabat~S|Balkan~B|Dashoguz~D|Lebap~L|Mary~M"],["Turks and Caicos Islands","TC","Turks and Caicos Islands~undefined"],["Tuvalu","TV","Funafuti~FUN|Nanumanga~NMG|Nanumea~NMA|Niutao~NIT|Nui~NUI|Nukufetau~NKF|Nukulaelae~NKL|Vaitupu~VAU"],["Uganda","UG","Abim~317|Adjumani~301|Amolatar~314|Amuria~216|Amuru~319|Apac~302|Arua~303|Budaka~217|Bududa~223|Bugiri~201|Bukedea~224|Bukwa~218|Buliisa~419|Bundibugyo~401|Bushenyi~402|Busia~202|Butaleja~219|Dokolo~318|Gulu~304|Hoima~403|Ibanda~416|Iganga~203|Isingiro~417|Jinja~204|Kaabong~315|Kabale~404|Kabarole~405|Kaberamaido~213|Kalangala~101|Kaliro~220|Kampala~102|Kamuli~205|Kamwenge~413|Kanungu~414|Kapchorwa~206|Kasese~406|Katakwi~207|Kayunga~112|Kibaale~407|Kiboga~103|Kiruhura~418|Kisoro~408|Kitgum~305|Koboko~316|Kotido~306|Kumi~208|Kyenjojo~415|Lira~307|Luwero~104|Lyantonde~116|Manafwa~221|Maracha~320|Masaka~105|Masindi~409|Mayuge~214|Mbale~209|Mbarara~410|Mityana~114|Moroto~308|Moyo~309|Mpigi~106|Mubende~107|Mukono~108|Nakapiripirit~311|Nakaseke~115|Nakasongola~109|Namutumba~222|Nebbi~310|Ntungamo~411|Oyam~321|Pader~312|Pallisa~210|Rakai~110|Rukungiri~412|Sembabule~111|Sironko~215|Soroti~211|Tororo~212|Wakiso~113|Yumbe~313"],["Ukraine","UA","Cherkasy~71|Chernihiv~74|Chernivtsi~77|Dnipropetrovsk~12|Donetsk~14|Ivano-Frankivsk~26|Kharkiv~63|Kherson~65|Khmelnytskyi~68|Kiev~32|Kirovohrad~35|Luhansk~09|Lviv~46|Mykolaiv~48|Odessa~51|Poltava~53|Rivne~56|Sumy~59|Ternopil~61|Vinnytsia~05|Volyn~07|Zakarpattia~21|Zaporizhia~23|Zhytomyr~18|Avtonomna Respublika Krym~43|Kyïv~30|Sevastopol~40"],["United Arab Emirates","AE","Abu Dhabi~AZ|Ajman~AJ|Dubai~DU|Fujairah~FU|Ras al Khaimah~RK|Sharjah~SH|Umm Al Quwain~UQ"],["United Kingdom","GB","Aberdeen City~ABE|Aberdeenshire~ABD|Angus~ANS|Antrim and Newtownabbey~ANN|Ards and North Down~AND|Argyll and Bute~AGB|Armagh, Banbridge and Craigavon~ABC|Barking and Dagenham~BDG|Barnet~BNE|Barnsley~BNS|Bath and North East Somerset~BAS|Bedford~BDF|Belfast~BFS|Bexley~BEX|Birmingham~BIR|Blackburn with Darwen~BBD|Blackpool~BPL|Blaenau Gwent~BGW|Bolton~BOL|Bournemouth~BMH|Bracknell Forest~BRC|Bradford~BRD|Brent~BEN|Bridgend~BGE|Brighton and Hove~BNH|Bristol, City of~BST|Bromley~BRY|Buckinghamshire~BKM|Bury~BUR|Caerphilly~CAY|Calderdale~CLD|Cambridgeshire~CAM|Camden~CMD|Cardiff~CRF|Carmarthenshire~CMN|Causeway Coast and Glens~CCG|Central Bedfordshire~CBF|Ceredigion~CGN|Cheshire East~CHE|Cheshire West and Chester~CHW|Clackmannanshire~CLK|Conwy~CWY|Cornwall~CON|Coventry~COV|Croydon~CRY|Cumbria~CMA|Darlington~DAL|Denbighshire~DEN|Derby~DER|Derbyshire~DBY|Derry and Strabane~DRS|Devon~DEV|Doncaster~DNC|Dorset~DOR|Dudley~DUD|Dumfries and Galloway~DGY|Dundee City~DND|Durham County~DUR|Ealing~EAL|East Ayrshire~EAY|East Dunbartonshire~EDU|East Lothian~ELN|East Renfrewshire~ERW|East Riding of Yorkshire~ERY|East Sussex~ESX|Edinburgh, City of~EDH|Eilean Siar~ELS|Enfield~ENF|Essex~ESS|Falkirk~FAL|Fermanagh and Omagh~FMO|Fife~FIF|Flintshire~FLN|Gateshead~GAT|Glasgow City~GLG|Gloucestershire~GLS|Greenwich~GRE|Gwynedd~GWN|Hackney~HCK|Halton~HAL|Hammersmith and Fulham~HMF|Hampshire~HAM|Haringey~HRY|Harrow~HRW|Hartlepool~HPL|Havering~HAV|Herefordshire~HEF|Hertfordshire~HRT|Highland~HLD|Hillingdon~HIL|Hounslow~HNS|Inverclyde~IVC|Isle of Anglesey~AGY|Isle of Wight~IOW|Isles of Scilly~IOS|Islington~ISL|Kensington and Chelsea~KEC|Kent~KEN|Kingston upon Hull~KHL|Kingston upon Thames~KTT|Kirklees~KIR|Knowsley~KWL|Lambeth~LBH|Lancashire~LAN|Leeds~LDS|Leicester~LCE|Leicestershire~LEC|Lewisham~LEW|Lincolnshire~LIN|Lisburn and Castlereagh~LBC|Liverpool~LIV|London, City of~LND|Luton~LUT|Manchester~MAN|Medway~MDW|Merthyr Tydfil~MTY|Merton~MRT|Mid and East Antrim~MEA|Mid Ulster~MUL|Middlesbrough~MDB|Midlothian~MLN|Milton Keynes~MIK|Monmouthshire~MON|Moray~MRY|Neath Port Talbot~NTL|Newcastle upon Tyne~NET|Newham~NWM|Newport~NWP|Newry, Mourne and Down~NMD|Norfolk~NFK|North Ayrshire~NAY|North East Lincolnshire~NEL|North Lanarkshire~NLK|North Lincolnshire~NLN|North Somerset~NSM|North Tyneside~NTY|North Yorkshire~NYK|Northamptonshire~NTH|Northumberland~NBL|Nottingham~NGM|Nottinghamshire~NTT|Oldham~OLD|Orkney Islands~ORK|Oxfordshire~OXF|Pembrokeshire~PEM|Perth and Kinross~PKN|Peterborough~PTE|Plymouth~PLY|Poole~POL|Portsmouth~POR|Powys~POW|Reading~RDG|Redbridge~RDB|Redcar and Cleveland~RCC|Renfrewshire~RFW|Rhondda, Cynon, Taff~RCT|Richmond upon Thames~RIC|Rochdale~RCH|Rotherham~ROT|Rutland~RUT|St. Helens~SHN|Salford~SLF|Sandwell~SAW|Scottish Borders, The~SCB|Sefton~SFT|Sheffield~SHF|Shetland Islands~ZET|Shropshire~SHR|Slough~SLG|Solihull~SOL|Somerset~SOM|South Ayrshire~SAY|South Gloucestershire~SGC|South Lanarkshire~SLK|South Tyneside~STY|Southampton~STH|Southend-on-Sea~SOS|Southwark~SWK|Staffordshire~STS|Stirling~STG|Stockport~SKP|Stockton-on-Tees~STT|Stoke-on-Trent~STE|Suffolk~SFK|Sunderland~SND|Surrey~SRY|Sutton~STN|Swansea~SWA|Swindon~SWD|Tameside~TAM|Telford and Wrekin~TFW|Thurrock~THR|Torbay~TOB|Torfaen~TOF|Tower Hamlets~TWH|Trafford~TRF|Vale of Glamorgan, The~VGL|Wakefield~WKF|Walsall~WLL|Waltham Forest~WFT|Wandsworth~WND|Warrington~WRT|Warwickshire~WAR|West Berkshire~WBK|West Dunbartonshire~WDU|West Lothian~WLN|West Sussex~WSX|Westminster~WSM|Wigan~WGN|Wiltshire~WIL|Windsor and Maidenhead~WNM|Wirral~WRL|Wokingham~WOK|Wolverhampton~WLV|Worcestershire~WOR|Wrexham~WRX|York~YOR"],["United States","US","Alabama~AL|Alaska~AK|American Samoa~AS|Arizona~AZ|Arkansas~AR|California~CA|Colorado~CO|Connecticut~CT|Delaware~DE|District of Columbia~DC|Micronesia~FM|Florida~FL|Georgia~GA|Guam~GU|Hawaii~HI|Idaho~ID|Illinois~IL|Indiana~IN|Iowa~IA|Kansas~KS|Kentucky~KY|Louisiana~LA|Maine~ME|Marshall Islands~MH|Maryland~MD|Massachusetts~MA|Michigan~MI|Minnesota~MN|Mississippi~MS|Missouri~MO|Montana~MT|Nebraska~NE|Nevada~NV|New Hampshire~NH|New Jersey~NJ|New Mexico~NM|New York~NY|North Carolina~NC|North Dakota~ND|Northern Mariana Islands~MP|Ohio~OH|Oklahoma~OK|Oregon~OR|Palau~PW|Pennsylvania~PA|Puerto Rico~PR|Rhode Island~RI|South Carolina~SC|South Dakota~SD|Tennessee~TN|Texas~TX|Utah~UT|Vermont~VT|Virgin Islands~VI|Virginia~VA|Washington~WA|West Virginia~WV|Wisconsin~WI|Wyoming~WY|Armed Forces Americas~AA|Armed Forces Europe, Canada, Africa and Middle East~AE|Armed Forces Pacific~AP"],["United States Minor Outlying Islands","UM","Baker Island~81|Howland Island~84|Jarvis Island~86|Johnston Atoll~67|Kingman Reef~89|Midway Islands~71|Navassa Island~76|Palmyra Atoll~95|Wake Island~79|Bajo Nuevo Bank~BN|Serranilla Bank~SB"],["Uruguay","UY","Artigas~AR|Canelones~CA|Cerro Largo~CL|Colonia~CO|Durazno~DU|Flores~FS|Florida~FD|Lavalleja~LA|Maldonado~MA|Montevideo~MO|Paysandú~PA|Río Negro~RN|Rivera~RV|Rocha~RO|Salto~SA|San José~SJ|Soriano~SO|Tacuarembó~TA|Treinta y Tres~TT"],["Uzbekistan","UZ","Toshkent shahri~TK|Andijon~AN|Buxoro~BU|Farg‘ona~FA|Jizzax~JI|Namangan~NG|Navoiy~NW|Qashqadaryo (Qarshi)~QA|Samarqand~SA|Sirdaryo (Guliston)~SI|Surxondaryo (Termiz)~SU|Toshkent wiloyati~TO|Xorazm (Urganch)~XO|Qoraqalpog‘iston Respublikasi (Nukus)~QR"],["Vanuatu","VU","Malampa~MAP|Pénama~PAM|Sanma~SAM|Shéfa~SEE|Taféa~TAE|Torba~TOB"],["Venezuela, Bolivarian Republic of","VE","Dependencias Federales~W|Distrito Federal~A|Amazonas~Z|Anzoátegui~B|Apure~C|Aragua~D|Barinas~E|Bolívar~F|Carabobo~G|Cojedes~H|Delta Amacuro~Y|Falcón~I|Guárico~J|Lara~K|Mérida~L|Miranda~M|Monagas~N|Nueva Esparta~O|Portuguesa~P|Sucre~R|Táchira~S|Trujillo~T|Vargas~X|Yaracuy~U|Zulia~V"],["Vietnam","VN","Đồng Nai~39|Đồng Tháp~45|Gia Lai~30|Hà Giang~03|Hà Nam~63|Hà Tây~15|Hà Tĩnh~23|Hải Dương~61|Hậu Giang~73|Hòa Bình~14|Hưng Yên~66|Khánh Hòa~34|Kiên Giang~47|Kon Tum~28|Lai Châu~01|Lâm Đồng~35|Lạng Sơn~09|Lào Cai~02|Long An~41|Nam Định~67|Nghệ An~22|Ninh Bình~18|Ninh Thuận~36|Phú Thọ~68|Phú Yên~32|Quảng Bình~24|Quảng Nam~27|Quảng Ngãi~29|Quảng Ninh~13|Quảng Trị~25|Sóc Trăng~52|Sơn La~05|Tây Ninh~37|Thái Bình~20|Thái Nguyên~69|Thanh Hóa~21|Thừa Thiên–Huế~26|Tiền Giang~46|Trà Vinh~51|Tuyên Quang~07|Vĩnh Long~49|Vĩnh Phúc~70|Yên Bái~06|Cần Thơ~CT|Đà Nẵng~DN|Hà Nội~HN|Hải Phòng~HP|Hồ Chí Minh (Sài Gòn)~SG"],["Virgin Islands, British","VG","Anegada~ANG|Jost Van Dyke~JVD|Tortola~TTA|Virgin Gorda~VGD"],["Virgin Islands, U.S.","VI","St. Thomas~STH|St. John~SJO|St. Croix~SCR"],["Wallis and Futuna","WF","Alo~ALO|Sigave~SIG|Wallis~WAL"],["Western Sahara","EH","Es Smara~ESM|Boujdour~BOD|Laâyoune~LAA|Aousserd~AOU|Oued ed Dahab~OUD"],["Yemen","YE","Abyān~AB|'Adan~AD|Aḑ Ḑāli'~DA|Al Bayḑā'~BA|Al Ḩudaydah~HU|Al Jawf~JA|Al Mahrah~MR|Al Maḩwīt~MW|'Amrān~AM|Dhamār~DH|Ḩaḑramawt~HD|Ḩajjah~HJ|Ibb~IB|Laḩij~LA|Ma'rib~MA|Raymah~RA|Şā‘dah~SD|Şan‘ā'~SN|Shabwah~SH|Tā‘izz~TA"],["Zambia","ZM","Central~02|Copperbelt~08|Eastern~03|Luapula~04|Lusaka~09|Northern~05|North-Western~06|Southern~07|Western~01"],["Zimbabwe","ZW","Bulawayo~BU|Harare~HA|Manicaland~MA|Mashonaland Central~MC|Mashonaland East~ME|Mashonaland West~MW|Masvingo~MV|Matabeleland North~MN|Matabeleland South~MS|Midlands~MI"]];
	
	var C = {
		DISPLAY_TYPE_FULL: 'full',
		DISPLAY_TYPE_SHORT: 'short',
		REGION_LIST_DELIMITER: '|',
		SINGLE_REGION_DELIMITER: '~'
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	// reduces the subset of countries depending on whether the user specified a white/blacklist, and lists priority
	// countries first
	var filterCountries = function filterCountries(countries, priorityCountries, whitelist, blacklist) {
		var countriesListedFirst = [];
		var filteredCountries = countries;
	
		if (whitelist.length > 0) {
			filteredCountries = countries.filter(function (_ref) {
				var _ref2 = slicedToArray(_ref, 2),
				    countrySlug = _ref2[1];
	
				return whitelist.indexOf(countrySlug) > -1;
			});
		} else if (blacklist.length > 0) {
			filteredCountries = countries.filter(function (_ref3) {
				var _ref4 = slicedToArray(_ref3, 2),
				    countrySlug = _ref4[1];
	
				return blacklist.indexOf(countrySlug) === -1;
			});
		}
	
		if (priorityCountries.length > 0) {
	
			// ensure the countries are added in the order in which they are specified by the user
			priorityCountries.forEach(function (slug) {
				var result = filteredCountries.find(function (_ref5) {
					var _ref6 = slicedToArray(_ref5, 2),
					    countrySlug = _ref6[1];
	
					return countrySlug === slug;
				});
				if (result) {
					countriesListedFirst.push(result);
				}
			});
	
			filteredCountries = filteredCountries.filter(function (_ref7) {
				var _ref8 = slicedToArray(_ref7, 2),
				    countrySlug = _ref8[1];
	
				return priorityCountries.indexOf(countrySlug) === -1;
			});
		}
	
		return countriesListedFirst.length ? [].concat(countriesListedFirst, toConsumableArray(filteredCountries)) : filteredCountries;
	};
	
	var CountryDropdown = function (_Component) {
		inherits(CountryDropdown, _Component);
	
		function CountryDropdown(props) {
			classCallCheck(this, CountryDropdown);
	
			var _this = possibleConstructorReturn(this, (CountryDropdown.__proto__ || Object.getPrototypeOf(CountryDropdown)).call(this, props));
	
			_this.state = {
				countries: filterCountries(CountryRegionData, props.priorityOptions, props.whitelist, props.blacklist)
			};
			return _this;
		}
	
		createClass(CountryDropdown, [{
			key: 'getCountries',
			value: function getCountries() {
				var _props = this.props,
				    valueType = _props.valueType,
				    labelType = _props.labelType;
	
	
				return this.state.countries.map(function (_ref) {
					var _ref2 = slicedToArray(_ref, 2),
					    countryName = _ref2[0],
					    countrySlug = _ref2[1];
	
					return React__default.createElement(
						'option',
						{ value: valueType === C.DISPLAY_TYPE_SHORT ? countrySlug : countryName, key: countrySlug },
						labelType === C.DISPLAY_TYPE_SHORT ? countrySlug : countryName
					);
				});
			}
		}, {
			key: 'getDefaultOption',
			value: function getDefaultOption() {
				var _props2 = this.props,
				    showDefaultOption = _props2.showDefaultOption,
				    defaultOptionLabel = _props2.defaultOptionLabel;
	
				if (!showDefaultOption) {
					return null;
				}
				return React__default.createElement(
					'option',
					{ value: '', key: 'default' },
					defaultOptionLabel
				);
			}
		}, {
			key: 'render',
			value: function render() {
				// unused properties deliberately added so arbitraryProps gets populated with anything else the user specifies
				var _props3 = this.props,
				    name = _props3.name,
				    id = _props3.id,
				    classes = _props3.classes,
				    value = _props3.value,
				    _onChange = _props3.onChange,
				    _onBlur = _props3.onBlur,
				    disabled = _props3.disabled,
				    showDefaultOption = _props3.showDefaultOption,
				    defaultOptionLabel = _props3.defaultOptionLabel,
				    labelType = _props3.labelType,
				    valueType = _props3.valueType,
				    whitelist = _props3.whitelist,
				    blacklist = _props3.blacklist,
				    customOptions = _props3.customOptions,
				    priorityOptions = _props3.priorityOptions,
				    arbitraryProps = objectWithoutProperties(_props3, ['name', 'id', 'classes', 'value', 'onChange', 'onBlur', 'disabled', 'showDefaultOption', 'defaultOptionLabel', 'labelType', 'valueType', 'whitelist', 'blacklist', 'customOptions', 'priorityOptions']);
	
	
				var attrs = _extends({}, arbitraryProps, {
					name: name,
					value: value,
					onChange: function onChange(e) {
						return _onChange(e.target.value, e);
					},
					onBlur: function onBlur(e) {
						return _onBlur(e);
					},
					disabled: disabled
				});
				if (id) {
					attrs.id = id;
				}
				if (classes) {
					attrs.className = classes;
				}
	
				return React__default.createElement(
					'select',
					attrs,
					this.getDefaultOption(),
					this.getCountries()
				);
			}
		}]);
		return CountryDropdown;
	}(React.Component);
	
	
	CountryDropdown.propTypes = {
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		name: PropTypes.string,
		id: PropTypes.string,
		classes: PropTypes.string,
		showDefaultOption: PropTypes.bool,
		defaultOptionLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		priorityOptions: PropTypes.array,
		onChange: PropTypes.func,
		onBlur: PropTypes.func,
		labelType: PropTypes.oneOf([C.DISPLAY_TYPE_FULL, C.DISPLAY_TYPE_SHORT]),
		valueType: PropTypes.oneOf([C.DISPLAY_TYPE_FULL, C.DISPLAY_TYPE_SHORT]),
		whitelist: PropTypes.array,
		blacklist: PropTypes.array,
		disabled: PropTypes.bool
	};
	CountryDropdown.defaultProps = {
		value: '',
		name: 'rcrs-country',
		id: '',
		classes: '',
		showDefaultOption: true,
		defaultOptionLabel: 'Select Country',
		priorityOptions: [],
		onChange: function onChange() {},
		onBlur: function onBlur() {},
		labelType: C.DISPLAY_TYPE_FULL,
		valueType: C.DISPLAY_TYPE_FULL,
		whitelist: [],
		blacklist: [],
		disabled: false
	};
	
	var RegionDropdown = function (_PureComponent) {
		inherits(RegionDropdown, _PureComponent);
	
		function RegionDropdown(props) {
			classCallCheck(this, RegionDropdown);
	
			var _this = possibleConstructorReturn(this, (RegionDropdown.__proto__ || Object.getPrototypeOf(RegionDropdown)).call(this, props));
	
			_this.state = {
				regions: _this.getRegions(props.country)
			};
			_this.getRegions = _this.getRegions.bind(_this);
			return _this;
		}
	
		createClass(RegionDropdown, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
				var country = this.props.country;
	
				if (country === prevProps.country) {
					return;
				}
	
				var defaultRegions = this.getRegions(country);
	
				this.setState({
					regions: [].concat(toConsumableArray(defaultRegions), toConsumableArray(this.getCustomOptions(defaultRegions)))
				});
			}
		}, {
			key: 'getCustomOptions',
			value: function getCustomOptions(regions) {
				var customOptions = this.props.customOptions;
	
	
				var duplicateRegions = this.getDuplicates(regions);
	
				if (duplicateRegions.length) {
					console.error('Error: Duplicate regions present: ' + duplicateRegions.toString() + '.\nThe above item(s) is/are already getting added to the region dropdown by the library.');
					return [];
				}
	
				return customOptions.map(function (option) {
					if (option) {
						return { regionName: option, regionShortCode: option };
					}
				});
			}
		}, {
			key: 'getDuplicates',
			value: function getDuplicates(regions) {
				var _props = this.props,
				    customOptions = _props.customOptions,
				    valueType = _props.valueType;
	
				var regionKey = valueType === C.DISPLAY_TYPE_FULL ? 'regionName' : 'regionShortCode';
	
				return regions.filter(function (region) {
					return customOptions.indexOf(region[regionKey]) !== -1;
				}).map(function (region) {
					return region[regionKey];
				});
			}
		}, {
			key: 'getRegions',
			value: function getRegions(country) {
				if (!country) {
					return [];
				}
	
				var countryValueType = this.props.countryValueType;
	
				var searchIndex = countryValueType === C.DISPLAY_TYPE_FULL ? 0 : 1;
				var regions = [];
				CountryRegionData.forEach(function (i) {
					if (i[searchIndex] === country) {
						regions = i;
					}
				});
	
				// this could happen if the user is managing the state of the region/country themselves and screws up passing
				// in a valid country
				if (!regions || regions.length === 0) {
					console.error('Error. Unknown country passed: ' + country + '. If you\'re passing a country shortcode, be sure to include countryValueType="short" on the RegionDropdown');
					return [];
				}
				return regions[2].split(C.REGION_LIST_DELIMITER).map(function (regionPair) {
					var _regionPair$split = regionPair.split(C.SINGLE_REGION_DELIMITER),
					    _regionPair$split2 = slicedToArray(_regionPair$split, 2),
					    regionName = _regionPair$split2[0],
					    _regionPair$split2$ = _regionPair$split2[1],
					    regionShortCode = _regionPair$split2$ === undefined ? null : _regionPair$split2$;
	
					return { regionName: regionName, regionShortCode: regionShortCode };
				});
			}
		}, {
			key: 'getRegionList',
			value: function getRegionList() {
				var _props2 = this.props,
				    labelType = _props2.labelType,
				    valueType = _props2.valueType;
	
				return this.state.regions.map(function (_ref) {
					var regionName = _ref.regionName,
					    regionShortCode = _ref.regionShortCode;
	
					var label = labelType === C.DISPLAY_TYPE_FULL ? regionName : regionShortCode;
					var value = valueType === C.DISPLAY_TYPE_FULL ? regionName : regionShortCode;
					return React__default.createElement(
						'option',
						{ value: value, key: regionName },
						label
					);
				});
			}
	
			// there are two default options. The "blank" option which shows up when the user hasn't selected a country yet, and
			// a "default" option which shows
	
		}, {
			key: 'getDefaultOption',
			value: function getDefaultOption() {
				var _props3 = this.props,
				    blankOptionLabel = _props3.blankOptionLabel,
				    showDefaultOption = _props3.showDefaultOption,
				    defaultOptionLabel = _props3.defaultOptionLabel,
				    country = _props3.country;
	
				if (!country) {
					return React__default.createElement(
						'option',
						{ value: '' },
						blankOptionLabel
					);
				}
				if (showDefaultOption) {
					return React__default.createElement(
						'option',
						{ value: '' },
						defaultOptionLabel
					);
				}
				return null;
			}
		}, {
			key: 'render',
			value: function render() {
				var _props4 = this.props,
				    value = _props4.value,
				    country = _props4.country,
				    _onChange = _props4.onChange,
				    _onBlur = _props4.onBlur,
				    id = _props4.id,
				    name = _props4.name,
				    classes = _props4.classes,
				    disabled = _props4.disabled,
				    blankOptionLabel = _props4.blankOptionLabel,
				    showDefaultOption = _props4.showDefaultOption,
				    defaultOptionLabel = _props4.defaultOptionLabel,
				    labelType = _props4.labelType,
				    valueType = _props4.valueType,
				    countryValueType = _props4.countryValueType,
				    disableWhenEmpty = _props4.disableWhenEmpty,
				    customOptions = _props4.customOptions,
				    arbitraryProps = objectWithoutProperties(_props4, ['value', 'country', 'onChange', 'onBlur', 'id', 'name', 'classes', 'disabled', 'blankOptionLabel', 'showDefaultOption', 'defaultOptionLabel', 'labelType', 'valueType', 'countryValueType', 'disableWhenEmpty', 'customOptions']);
	
	
				var isDisabled = disabled || disableWhenEmpty && country === '';
				var attrs = _extends({}, arbitraryProps, {
					name: name,
					value: value,
					onChange: function onChange(e) {
						return _onChange(e.target.value, e);
					},
					onBlur: function onBlur(e) {
						return _onBlur(e);
					},
					disabled: isDisabled
				});
				if (id) {
					attrs.id = id;
				}
				if (classes) {
					attrs.className = classes;
				}
	
				return React__default.createElement(
					'select',
					attrs,
					this.getDefaultOption(),
					this.getRegionList()
				);
			}
		}]);
		return RegionDropdown;
	}(React.PureComponent);
	
	
	RegionDropdown.propTypes = {
		country: PropTypes.string,
		countryValueType: PropTypes.oneOf([C.DISPLAY_TYPE_FULL, C.DISPLAY_TYPE_SHORT]),
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		name: PropTypes.string,
		id: PropTypes.string,
		classes: PropTypes.string,
		blankOptionLabel: PropTypes.string,
		showDefaultOption: PropTypes.bool,
		defaultOptionLabel: PropTypes.string,
		onChange: PropTypes.func,
		onBlur: PropTypes.func,
		labelType: PropTypes.string,
		valueType: PropTypes.string,
		disabled: PropTypes.bool,
		disableWhenEmpty: PropTypes.bool,
		customOptions: PropTypes.array
	};
	RegionDropdown.defaultProps = {
		country: '',
		value: '',
		name: 'rcrs-region',
		id: '',
		classes: '',
		blankOptionLabel: '-',
		showDefaultOption: true,
		defaultOptionLabel: 'Select Region',
		onChange: function onChange() {},
		onBlur: function onBlur() {},
		countryValueType: C.DISPLAY_TYPE_FULL,
		labelType: C.DISPLAY_TYPE_FULL,
		valueType: C.DISPLAY_TYPE_FULL,
		disabled: false,
		disableWhenEmpty: false,
		customOptions: []
	};
	
	exports.CountryDropdown = CountryDropdown;
	exports.RegionDropdown = RegionDropdown;
	exports.CountryRegionData = CountryRegionData;
	//# sourceMappingURL=rcrs.js.map


/***/ }),

/***/ 207:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ConnectComponent = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(207);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _sweetalert = __webpack_require__(78);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _axios = __webpack_require__(52);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactIntlTelInput = __webpack_require__(77);
	
	var _reactIntlTelInput2 = _interopRequireDefault(_reactIntlTelInput);
	
	__webpack_require__(76);
	
	__webpack_require__(75);
	
	var _regex = __webpack_require__(65);
	
	var _reactCountryRegionSelector = __webpack_require__(111);
	
	var _reactParallax = __webpack_require__(81);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	__webpack_require__(8);
	
	var _reactAnimateOnScroll = __webpack_require__(10);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	var _reactFacebookPixel = __webpack_require__(23);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _reaptcha = __webpack_require__(82);
	
	var _reaptcha2 = _interopRequireDefault(_reaptcha);
	
	var _formPopup = __webpack_require__(116);
	
	var _formPopup2 = _interopRequireDefault(_formPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var image1 = "https://winpeforum.com/assets/elements/HeroImg.jpg";
	var handler = function handler(status, value, countryData, number, id) {
	  // // console.log(status, value, countryData, number, id)
	};
	
	var genderOptions = ["Male", "Female", "Other"];
	
	var ConnectComponent = exports.ConnectComponent = function (_React$Component) {
	  _inherits(ConnectComponent, _React$Component);
	
	  function ConnectComponent(args) {
	    _classCallCheck(this, ConnectComponent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.handleChangeAndValidation = function (key, e) {
	      var _extends2;
	
	      var Error = _this.state.Error;
	
	      _this.setState({
	        values: _extends({}, _this.state.values, (_extends2 = {}, _extends2[key] = e.target.value.trim(), _extends2))
	      });
	      delete Error[key];
	    };
	
	    _this.verifyCallback = function () {
	      var Error = _this.state.Error;
	
	      Error["isVerify"] = false;
	      _this.setState({
	        isVerify: true,
	        Error: Error
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	
	      var _this$state = _this.state,
	          values = _this$state.values,
	          isVerify = _this$state.isVerify;
	
	      var isFlag = false;
	      var error = {};
	      _this.inputs.map(function (item, j) {
	        if (!values[item]) {
	          isFlag = true;
	          error[item] = true;
	        } else if (item === "email") {
	          error[item] = !(0, _regex.validationForEmail)(values[item]);
	          isFlag = isFlag === true ? true : error[item];
	        }
	      });
	      isFlag = isFlag ? true : !isVerify;
	      error["isVerify"] = !isVerify;
	      // console.log("values", values, error)
	
	      // isFlag = false;
	      if (isFlag) {
	        _this.setState({
	          Error: error
	        });
	      } else {
	        var firstName = values.firstName,
	            lastName = values.lastName,
	            designation = values.designation,
	            company = values.company,
	            email = values.email,
	            number = values.number,
	            wnumber = values.wnumber,
	            sector = values.sector,
	            country = values.country,
	            region = values.region,
	            gender = values.gender,
	            message = values.message;
	
	
	        var data = {
	          first_name: firstName,
	          last_name: lastName,
	          designation: designation,
	          company: company,
	          email: email,
	          mobile_number: number,
	          whatsapp_number: wnumber,
	          sector: sector,
	          country: country,
	          state_or_city: region,
	          // institution,
	          message: message,
	          gender: gender
	        };
	
	        console.log(data);
	        _reactFacebookPixel2.default.track("Contact");
	        _axios2.default.post("https://winpeforum.com/api/public/index.php/connect", data).then(function (response) {
	          _this.showFormPopup();
	          document.getElementById("reset").reset();
	          return response;
	        }).catch(function (e) {
	          var _e$response = e.response,
	              data = _e$response.data,
	              status = _e$response.status;
	
	
	          if (status === 409) {
	            _this.showFormPopup("This email address is already registered. Please use a different email address or contact info@winpeforum.com.");
	            document.getElementById("reset").reset();
	          } else {
	            _this.showFormPopup("Internal Server Error");
	          }
	        });
	      }
	    };
	
	    _this.onPopUpClose = function () {
	      _this.setState({
	        showPopup: false,
	        popupMessage: ""
	      });
	    };
	
	    _this.inputs = ["firstName", "lastName", "email", "company", "number", "gender"];
	    _this.state = {
	      Error: {},
	      values: {},
	      country: " ",
	      region: " ",
	      isChange: true,
	      isVerify: false,
	      showPopup: false,
	      popupMessage: ""
	    };
	    return _this;
	  }
	
	  ConnectComponent.prototype.componentDidMount = function componentDidMount() {
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	  };
	
	  ConnectComponent.prototype.selectCountry = function selectCountry(val) {
	    var _this2 = this;
	
	    this.setState({
	      values: _extends({}, this.state.values, {
	        country: val
	      }),
	      isChange: false
	    });
	    setTimeout(function () {
	      _this2.setState({
	        isChange: true
	      });
	    }, 1000);
	  };
	
	  ConnectComponent.prototype.selectRegion = function selectRegion(val) {
	    var _this3 = this;
	
	    this.setState({
	      values: _extends({}, this.state.values, {
	        region: val
	      }),
	      isChange: false
	    });
	    setTimeout(function () {
	      _this3.setState({
	        isChange: true
	      });
	    }, 1000);
	  };
	
	  ConnectComponent.prototype.showFormPopup = function showFormPopup() {
	    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	    this.setState({
	      showPopup: true,
	      popupMessage: text
	    });
	  };
	
	  ConnectComponent.prototype.render = function render() {
	    var _this4 = this;
	
	    var insideStyles = {
	      background: "white",
	      padding: 20,
	      position: "absolute",
	      top: "50%",
	      left: "50%",
	      transform: "translate(-50%,-50%)"
	    };
	    var _state = this.state,
	        Error = _state.Error,
	        values = _state.values,
	        isVerify = _state.isVerify,
	        showPopup = _state.showPopup,
	        popupMessage = _state.popupMessage;
	
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_formPopup2.default, {
	        show: showPopup,
	        text: popupMessage,
	        onPopupClose: this.onPopUpClose
	      }),
	      _react2.default.createElement(
	        _contentPage2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "section__content" },
	          _react2.default.createElement(
	            _reactParallax.Parallax,
	            { bgImage: image1, strength: 500 },
	            _react2.default.createElement(
	              "div",
	              { style: { height: "100%" }, className: "connect__wrapper" },
	              _react2.default.createElement(
	                "div",
	                { className: "connect__section" },
	                _react2.default.createElement(
	                  _reactAnimateOnScroll2.default,
	                  {
	                    delay: 0,
	                    duration: 2,
	                    animateIn: "slideInRight",
	                    offset: 600
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "connect_content" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "left_section" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "left_content" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "" },
	                          _react2.default.createElement(_Heading2.default, { title: "Connect" })
	                        ),
	                        _react2.default.createElement("div", { className: "low__heading" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "policy_new" },
	                          "Write to us at info@winpeforum.com"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "right_section" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "right_content" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "connect_form" },
	                          _react2.default.createElement(
	                            "form",
	                            { onSubmit: this.handleSubmit, id: "reset" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-4 col-lg-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "st" },
	                                    "FIRST NAME *"
	                                  ),
	                                  _react2.default.createElement("input", {
	                                    type: "text",
	                                    onChange: function onChange(e) {
	                                      return _this4.handleChangeAndValidation("firstName", e);
	                                    },
	                                    name: "firstName",
	                                    id: "firstName",
	                                    className: "form-control",
	                                    placeholder: "Enter First Name"
	                                  }),
	                                  Error.firstName ? _react2.default.createElement(
	                                    "span",
	                                    { className: "error" },
	                                    "Enter first name."
	                                  ) : " "
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-4 col-lg-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "st" },
	                                    "LAST NAME *"
	                                  ),
	                                  _react2.default.createElement("input", {
	                                    type: "text",
	                                    onChange: function onChange(e) {
	                                      return _this4.handleChangeAndValidation("lastName", e);
	                                    },
	                                    name: "lastName",
	                                    id: "lastName",
	                                    className: "form-control",
	                                    placeholder: "Enter Last Name"
	                                  }),
	                                  Error.lastName ? _react2.default.createElement(
	                                    "span",
	                                    { className: "error" },
	                                    "Enter last name."
	                                  ) : " "
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-4 col-lg-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "st" },
	                                    "GENDER *"
	                                  ),
	                                  _react2.default.createElement(
	                                    "select",
	                                    {
	                                      name: "gender",
	                                      id: "gender",
	                                      onChange: function onChange(e) {
	                                        return _this4.handleChangeAndValidation("gender", e);
	                                      },
	                                      className: "form-control"
	                                    },
	                                    _react2.default.createElement(
	                                      "option",
	                                      {
	                                        selected: true,
	                                        style: { display: "none" }
	                                      },
	                                      "--- SELECT GENDER ---"
	                                    ),
	                                    genderOptions.map(function (gender, i) {
	                                      return _react2.default.createElement(
	                                        "option",
	                                        { value: gender },
	                                        gender
	                                      );
	                                    })
	                                  ),
	                                  Error.gender ? _react2.default.createElement(
	                                    "span",
	                                    { className: "error" },
	                                    "Please select gender."
	                                  ) : " "
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-4 col-lg-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "st" },
	                                    "DESIGNATION"
	                                  ),
	                                  _react2.default.createElement("input", {
	                                    type: "text",
	                                    onChange: function onChange(e) {
	                                      return _this4.handleChangeAndValidation("designation", e);
	                                    },
	                                    name: "designation",
	                                    id: "designation",
	                                    className: "form-control",
	                                    placeholder: "Enter Position/ Title"
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-4 col-lg-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "st" },
	                                    "COMPANY *"
	                                  ),
	                                  _react2.default.createElement("input", {
	                                    type: "text",
	                                    onChange: function onChange(e) {
	                                      return _this4.handleChangeAndValidation("company", e);
	                                    },
	                                    name: "company",
	                                    id: "company",
	                                    className: "form-control",
	                                    placeholder: "Enter Company Name"
	                                  }),
	                                  Error.company ? _react2.default.createElement(
	                                    "span",
	                                    { className: "error" },
	                                    "Enter the name of your current organisation."
	                                  ) : " "
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-4 col-lg-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "st" },
	                                    "EMAIL ADDRESS *"
	                                  ),
	                                  _react2.default.createElement("input", {
	                                    type: "email",
	                                    onChange: function onChange(e) {
	                                      return _this4.handleChangeAndValidation("email", e);
	                                    },
	                                    name: "email",
	                                    id: "email",
	                                    className: "form-control",
	                                    placeholder: "Preferred Email ID"
	                                  }),
	                                  Error.email ? _react2.default.createElement(
	                                    "span",
	                                    { className: "error" },
	                                    "Enter a valid email address."
	                                  ) : " "
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-4 col-lg-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "st" },
	                                    "MOBILE NUMBER *"
	                                  ),
	                                  _react2.default.createElement(_reactIntlTelInput2.default, {
	                                    onPhoneNumberChange: function onPhoneNumberChange(status, value, countryData, number, id) {
	                                      return _this4.setState({
	                                        values: _extends({}, values, { number: number })
	                                      });
	                                    },
	                                    onPhoneNumberBlur: handler,
	                                    onChange: function onChange(e) {
	                                      return _this4.setState({
	                                        values: _extends({}, values, {
	                                          number: e.target.value
	                                        })
	                                      });
	                                    },
	                                    defaultCountry: "in",
	                                    Default: ["in"],
	                                    css: ["intl-tel-input", "form-control"],
	                                    utilsScript: "libphonenumber.js",
	                                    name: "number"
	                                  }),
	                                  Error.number ? _react2.default.createElement(
	                                    "span",
	                                    { className: "error" },
	                                    "Please enter number."
	                                  ) : " "
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-4 col-lg-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "st" },
	                                    "WHATSAPP NUMBER"
	                                  ),
	                                  _react2.default.createElement("input", {
	                                    type: "text",
	                                    onChange: function onChange(e) {
	                                      return _this4.handleChangeAndValidation("wnumber", e);
	                                    },
	                                    name: "wnumber",
	                                    id: "wnumber",
	                                    className: "form-control",
	                                    placeholder: "If Different From Mobile Number"
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-4 col-lg-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "st" },
	                                    "SECTOR/ AREAS OF EXPERTISE"
	                                  ),
	                                  _react2.default.createElement("input", {
	                                    type: "text",
	                                    onChange: function onChange(e) {
	                                      return _this4.handleChangeAndValidation("sector", e);
	                                    },
	                                    name: "sector",
	                                    id: "sector",
	                                    className: "form-control",
	                                    placeholder: "Enter Sector/ Areas Of Expertise"
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-4 col-lg-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "st" },
	                                    "COUNTRY"
	                                  ),
	                                  _react2.default.createElement(_reactCountryRegionSelector.CountryDropdown, {
	                                    className: "form-control",
	                                    value: this.state.values.country,
	                                    onChange: function onChange(val) {
	                                      return _this4.selectCountry(val);
	                                    },
	                                    name: "country"
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-4 col-lg-4" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "form-group" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "st" },
	                                    "STATE / CITY"
	                                  ),
	                                  _react2.default.createElement(_reactCountryRegionSelector.RegionDropdown, {
	                                    className: "form-control",
	                                    country: this.state.values.country,
	                                    value: this.state.values.region,
	                                    onChange: function onChange(val) {
	                                      return _this4.selectRegion(val);
	                                    },
	                                    name: "region"
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-10" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "msg" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "st" },
	                                    "MESSAGE (max. 250 words)",
	                                    " "
	                                  ),
	                                  _react2.default.createElement("textarea", {
	                                    name: "message",
	                                    onChange: function onChange(e) {
	                                      return _this4.handleChangeAndValidation("message", e);
	                                    },
	                                    id: "message",
	                                    className: "form-control",
	                                    rows: "3"
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-12" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    style: {
	                                      marginTop: "30px",
	                                      fontSize: "16px"
	                                    }
	                                  },
	                                  " ",
	                                  _react2.default.createElement("input", { type: "checkbox" }),
	                                  "\xA0\xA0I agree to receive email communications from Winpe, including news about our conferences, and access to exclusive invite-only events."
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "recap" },
	                                _react2.default.createElement(_reaptcha2.default, {
	                                  sitekey: "6LcHYQEVAAAAAOe3W16_zdQsnMszPeoLz2dSMcUO",
	                                  onVerify: this.verifyCallback
	                                }),
	                                Error.isVerify ? _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "error-msg",
	                                    style: { color: "#a94442" }
	                                  },
	                                  "Please Verify that you are not robot"
	                                ) : null
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-md-12" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "s_btn" },
	                                  _react2.default.createElement(
	                                    "button",
	                                    { onClick: this.handleSubmit },
	                                    "SUBMIT"
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "policy" },
	                            "By clicking 'Submit', you agree to the Privacy Policy regarding storage of this information in the Winpe database."
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ConnectComponent;
	}(_react2.default.Component);
	
	exports.default = ConnectComponent;

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Event = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(698);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _WinpeButton = __webpack_require__(401);
	
	var _WinpeButton2 = _interopRequireDefault(_WinpeButton);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Event = exports.Event = function (_React$Component) {
		_inherits(Event, _React$Component);
	
		function Event(args) {
			_classCallCheck(this, Event);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
			_this.toggleEventButton = function (activeIndex) {
				_this.setState({
					activeIndex: activeIndex
				});
			};
	
			_this.state = {
				activeIndex: 1
			};
			_this.eventDetails = {
				1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
				2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
				3: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
				4: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
				5: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
				6: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
			};
			return _this;
		}
	
		Event.prototype.componentDidMount = function componentDidMount() {};
	
		Event.prototype.render = function render() {
			var _this2 = this;
	
			var _props = this.props,
			    activeItem = _props.activeItem,
			    toggleEvent = _props.toggleEvent;
			var activeIndex = this.state.activeIndex;
	
			return _react2.default.createElement(
				"div",
				{ className: "event__wrapper" },
				_react2.default.createElement(
					"div",
					{ className: "event__content" },
					_react2.default.createElement(
						"div",
						{ className: "upper__part" },
						_react2.default.createElement(
							"div",
							{ className: "navigate" },
							_react2.default.createElement(
								"span",
								{ onClick: function onClick() {
										return toggleEvent(null);
									} },
								"\u2190"
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "" },
							_react2.default.createElement(_Heading2.default, { title: activeItem.title })
						),
						_react2.default.createElement(
							"div",
							{ className: "sub__body__text" },
							activeItem.desc
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "second__panel" },
						_react2.default.createElement(
							"div",
							{ className: "left-panel" },
							Object.keys(this.eventDetails).map(function (key) {
								// console.log("key", key, activeIndex)
								return _react2.default.createElement(
									"div",
									{ onClick: function onClick() {
											return _this2.toggleEventButton(key);
										}, id: key, className: "__item " + (activeIndex === key ? "active__item" : "") },
									_react2.default.createElement(
										"span",
										null,
										"Event ",
										key
									)
								);
							})
						),
						_react2.default.createElement(
							"div",
							{ className: "right-panel" },
							_react2.default.createElement(
								"div",
								{ className: "panel__desc" },
								"Event ",
								activeIndex,
								": ",
								this.eventDetails[activeIndex]
							),
							_react2.default.createElement(
								"div",
								{ className: "navigate_button" },
								_react2.default.createElement(_WinpeButton2.default, { title: "RSVP" }),
								_react2.default.createElement(_WinpeButton2.default, { title: "AGENDA" }),
								_react2.default.createElement(_WinpeButton2.default, { title: "sponsorship" })
							)
						)
					)
				)
			);
		};
	
		return Event;
	}(_react2.default.Component);
	
	Event.propTypes = {
		activeItem: _propTypes2.default.object,
		toggleEvent: _propTypes2.default.object
	};
	exports.default = Event;

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.HomeView = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(112);
	
	var _createStore = __webpack_require__(172);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	__webpack_require__(695);
	
	var _jquery = __webpack_require__(20);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	__webpack_require__(8);
	
	var _homeSection = __webpack_require__(404);
	
	var _homeSection2 = _interopRequireDefault(_homeSection);
	
	var _KeyInitiatives = __webpack_require__(394);
	
	var _KeyInitiatives2 = _interopRequireDefault(_KeyInitiatives);
	
	var _about = __webpack_require__(402);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _vision = __webpack_require__(412);
	
	var _vision2 = _interopRequireDefault(_vision);
	
	var _partners = __webpack_require__(409);
	
	var _partners2 = _interopRequireDefault(_partners);
	
	var _team = __webpack_require__(410);
	
	var _team2 = _interopRequireDefault(_team);
	
	var _ConnectComponent = __webpack_require__(154);
	
	var _ConnectComponent2 = _interopRequireDefault(_ConnectComponent);
	
	var _overView = __webpack_require__(408);
	
	var _overView2 = _interopRequireDefault(_overView);
	
	var _NewFooter = __webpack_require__(396);
	
	var _NewFooter2 = _interopRequireDefault(_NewFooter);
	
	var _ManifestoPoint = __webpack_require__(156);
	
	var _ManifestoPoint2 = _interopRequireDefault(_ManifestoPoint);
	
	var _reactFacebookPixel = __webpack_require__(23);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // You can also use <link> for styles
	
	
	var store = (0, _createStore2.default)();
	
	var HomeView = exports.HomeView = function (_React$Component) {
	  _inherits(HomeView, _React$Component);
	
	  function HomeView(args) {
	    _classCallCheck(this, HomeView);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.setFunc = function () {
	      // // console.log("setFunc", this.state.isAboutActive)
	      if (!_this.state.isAboutActive) {
	        _this.setState({
	          isAboutActive: true
	        });
	      }
	    };
	
	    _this.handleScroll = function (item) {};
	
	    _this.getActiveRoute = function (name) {
	      _this.setState({
	        activeRouteName: name
	      });
	    };
	
	    _this.state = {
	      isShowSidebar: false,
	      isAboutActive: false,
	      activeRouteName: "",
	      appLoader: false
	    };
	    return _this;
	  }
	
	  HomeView.prototype.componentDidMount = function componentDidMount() {
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	
	    var setFunc = this.setFunc;
	    var isAboutActive = this.state.isAboutActive;
	
	    var hash = window.location.hash;
	  };
	
	  HomeView.prototype.render = function render() {
	    var location = this.props.location;
	    var appLoader = this.state.appLoader;
	
	
	    var route = location.pathname.split("/")[1];
	    var activeRoute = location.hash;
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: store },
	      _react2.default.createElement(
	        _contentPage2.default,
	        null,
	        _react2.default.createElement(_meta2.default, {
	          title: "Winpe | Diversity is Now",
	          description: "Winpe is a pioneering platform founded in 2020 dedicated to creating a culture of growth and advancing gender diversity in private equity.",
	          image: "https://winpeforum.com/assets/elements/WinPE_Home_Page_link_image1.jpg",
	          keywords: "Winpe Development Forum,Winpe India,Winpe gender diversity,diversity and inclusion,Winpe private equity,Winpe venture capital,gender diversity India,gender diversity private equity,gender diversity venture capital,Nupur Garg Winpe,Winpe Diversity is Now,Diversity is Now,Glass Ceilings Finance,Women in private equity,gender diversity platform,gender balance private equity,gender balance investing ecosystem,gender diversity investing,women in investing,gender parity investing,gender parity finance,women capital allocators,women investors,investment capital women,diversity in boardrooms,engage empower enhance,resources women private equity,platform women venture capital,female talent investing,Winpe Founding Members,Winpe Partners ,Winpe Associate Partner,Winpe Knowledge Partners,Winpe Advisory Board,Anita George CDPQ,Renuka Ramnath Multiples Alternate Asset Management,Zia J. Mody AZB & Partners,Ester Martinez People Matters,Matangi Gowrishankar ,Shyamala Gopinath,Winpe Ignite,Winpe ProClub,Winpe Insights,Winpe Shine,Winpe Collegium,Winpe Parleys,Winpe Edge,training resources women private equity,networking resources women private equity,mentoring resources women private equity,mentoring resources gender diversity,mentoring platform investing",
	          location: location
	        }),
	        appLoader ? _react2.default.createElement("i", { className: "fa fa-spin fa-spinner" }) : _react2.default.createElement(
	          "div",
	          { className: "page-layout__viewport" },
	          _react2.default.createElement("div", { className: "page-layout__viewport__left_content" }),
	          _react2.default.createElement(
	            "div",
	            { className: "page-layout__viewport__middle_content" },
	            _react2.default.createElement(
	              "div",
	              { id: "fullscreen", className: "fullscreen" },
	              _react2.default.createElement(
	                "div",
	                { id: "#", className: "section main__wrapper" },
	                _react2.default.createElement(_homeSection2.default, null)
	              ),
	              _react2.default.createElement(
	                "div",
	                { id: "about" },
	                _react2.default.createElement(
	                  "div",
	                  { id: "overview", className: "section main__wrapper" },
	                  _react2.default.createElement(_overView2.default, null)
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { id: "", className: "section main__wrapper" },
	                  _react2.default.createElement(_about2.default, null)
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    ref: "#vision",
	                    id: "vision",
	                    className: "section main__wrapper"
	                  },
	                  _react2.default.createElement(_vision2.default, null)
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { id: "initiatives", className: "section main__wrapper" },
	                _react2.default.createElement(_KeyInitiatives2.default, null)
	              ),
	              _react2.default.createElement("div", { id: "/events" }),
	              _react2.default.createElement(
	                "div",
	                { id: "team", className: "section main__wrapper" },
	                _react2.default.createElement(_team2.default, null)
	              ),
	              _react2.default.createElement("div", { id: "/ambassadors" }),
	              _react2.default.createElement(
	                "div",
	                {
	                  ref: "#partners",
	                  id: "partners",
	                  className: "section main__wrapper"
	                },
	                _react2.default.createElement(_partners2.default, null)
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  ref: "#connect",
	                  id: "connect",
	                  className: "section main__wrapper sub_section",
	                  style: { width: "100%" }
	                },
	                _react2.default.createElement(_ConnectComponent2.default, null)
	              ),
	              _react2.default.createElement("div", { id: "/knowledge" }),
	              _react2.default.createElement("div", { id: "/connect" }),
	              _react2.default.createElement("div", { id: "/insights" })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return HomeView;
	}(_react2.default.Component);
	
	HomeView.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = HomeView;

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	__webpack_require__(700);
	
	var _reactParallax = __webpack_require__(81);
	
	var _EventComponent = __webpack_require__(391);
	
	var _EventComponent2 = _interopRequireDefault(_EventComponent);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(8);
	
	var _reactAnimateOnScroll = __webpack_require__(10);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Button from "../WinpeButton"
	
	
	var image1 = "https://winpeforum.com/assets/elements/HeroImg.jpg";
	
	var programs = [{
	  title: "Winpe Collegium",
	  desc: "Quarterly meetings with partner firms to discuss all matters diversity, exchange knowledge & experiences, identify challenges to attaining gender balance and brainstorm on solutions to address the same. The Collegium identifies action items for each year, along with corresponding annual KPIs, ranging from building diversity in hiring to pay parity and measurement and reporting of diversity. Winpe builds and provides resources needed to support action identified by the Collegium and tracks progress for the collective as well as individual firms.",
	  plink: "/maidenCollegium/"
	}, {
	  title: "Winpe Sheshines",
	  desc: "Evening mixers for women in PEVC and entrepreneurship across Mumbai, Bangalore and Delhi NCR with panel discussions, round tables and close networking.",
	  plink: "/SheShines/"
	}, {
	  title: "Winpe ProClub",
	  desc: "Mentorship has been acknowledged as one of the most powerful tools driving professional success. In the case of women, mentorship can be a key success factor as women deal with workplaces largely dominated by men. Winpe's ProClub Mentorship Program connects high performing women with industry leaders for 1:1 mentoring over a period of 12 months. Winpe believes that this initiative will create a deep pipeline of female leaders, facilitating a much-required gender balance in leadership positions and shaping the future course of the industry. Visit the ProClub website for details.",
	  plink: "https://proclub.winpeforum.com/home/"
	}];
	
	var programs1 = [{
	  title: "Winpe Ignite",
	  desc: "Winpe Ignite aims to nurture young female talent for the industry through quarterly events that include career bootcamps, AMA with industry leaders, dissemination of job opportunities, conversations with senior women, networking events and direct-at-campus engagements.",
	  plink: ""
	}, {
	  title: "Winpe WLSA",
	  desc: "An industry conference providing industry insights and connects to women investors and entrepreneurs. Followed by the Winpe Awards recognizing firms and individuals for their action on gender diversity.",
	  plink: "https://winpeleadershipsummit.winpeforum.com/home/"
	}];
	
	var index = function (_React$Component) {
	  _inherits(index, _React$Component);
	
	  function index(args) {
	    _classCallCheck(this, index);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.toggleEvent = function (item) {
	      console.log("activeItem", item);
	      window.scrollTo(0, _this.refs.test.offsetTop);
	      _this.setState({
	        activeItem: item
	      });
	    };
	
	    _this.state = {
	      activeItem: null,
	      isShow: false
	    };
	    _this.collegiumsText = [{
	      id: 1,
	      title: "Winpe partners will step up efforts for diversity in hiring by pushing for a diverse talent pipeline and incorporating a blind screening process (including redacted CVs removing names and other indications of gender, case studies). The diversity targets for inward talent pipeline will be set on a confidential basis to maintain merit and credibility in hiring."
	    }, {
	      id: 2,
	      title: "Winpe and its partners will support mid career women professionals from the industry through a structured mentorship program to be run by Winpe."
	    }, {
	      id: 3,
	      title: "Winpe partners will introduce a conversation on diversity within their firms and portfolio companies, enhancing awareness and sensitization within the ecosystem."
	    }, {
	      id: 4,
	      title: "Winpe partners will seek for their portfolio companies to measure appropriate diversity metrics and report annually."
	    }, {
	      id: 5,
	      title: "Winpe partners will ask for commitment and measurement on Equal Pay at KMP level in portfolio companies."
	    }, {
	      id: 6,
	      title: "Winpe partners will support outreach at campuses that are hiring grounds for the industry to champion awareness among female candidates."
	    }];
	    return _this;
	  }
	
	  index.prototype.render = function render() {
	    var insideStyles = {
	      background: "white",
	      padding: 20,
	      position: "absolute",
	      top: "50%",
	      left: "50%",
	      transform: "translate(-50%,-50%)"
	    };
	    var activeItem = this.state.activeItem;
	
	    return _react2.default.createElement(
	      "div",
	      { ref: "test", className: "section__content" },
	      _react2.default.createElement(
	        "div",
	        { className: "key__initiative__wrapper" },
	        _react2.default.createElement(
	          _reactParallax.Parallax,
	          { bgImage: image1, strength: 500 },
	          _react2.default.createElement(
	            "div",
	            { style: { height: "100%" } },
	            activeItem != null ? _react2.default.createElement(_EventComponent2.default, {
	              activeItem: activeItem,
	              toggleEvent: this.toggleEvent
	            }) : _react2.default.createElement(
	              "div",
	              { className: "key__initiative__content" },
	              _react2.default.createElement("div", { className: "low__heading" }),
	              _react2.default.createElement(
	                "div",
	                { className: "" },
	                _react2.default.createElement(_Heading2.default, { title: "Initiatives" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "sub__body__text", style: { textAlign: "center" } },
	                "Winpe has programs in multiple formats for engaging with different constituents of the investing industry including both firms and women."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "key__initiative__steps_new" },
	                _react2.default.createElement(
	                  _reactAnimateOnScroll2.default,
	                  {
	                    delay: 0,
	                    duration: 3,
	                    animateIn: "zoomIn",
	                    offset: 300
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    programs.map(function (item, i) {
	                      return _react2.default.createElement(
	                        "div",
	                        { className: "col-md-4 col-sm-6 col-lg-4", key: i },
	                        _react2.default.createElement(
	                          "a",
	                          { href: item.plink, target: "_blank" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "box__column_new" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "box__heading" },
	                              item.title,
	                              _react2.default.createElement("div", { className: "bottom__strip" })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "box__desc" },
	                              item.desc
	                            )
	                          )
	                        )
	                      );
	                    })
	                  ),
	                  " ",
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    " ",
	                    _react2.default.createElement("div", { className: "col-md-2   col-lg-2" }),
	                    programs1.map(function (item, i) {
	                      return _react2.default.createElement(
	                        "div",
	                        { className: "col-md-4 col-sm-6 col-lg-4", key: i },
	                        _react2.default.createElement(
	                          "a",
	                          { href: item.plink, target: "_blank" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "box__column_new" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "box__heading" },
	                              item.title,
	                              _react2.default.createElement("div", { className: "bottom__strip" })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "box__desc" },
	                              item.desc
	                            )
	                          )
	                        )
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "event_btn" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "events" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "event_text" },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: "/events/" },
	                      " View Upcoming Events"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return index;
	}(_react2.default.Component);
	
	exports.default = index;
	module.exports = exports["default"];

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ManifestoPoint = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(209);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	__webpack_require__(8);
	
	var _reactAnimateOnScroll = __webpack_require__(10);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ManifestoPoint = exports.ManifestoPoint = function (_React$Component) {
	  _inherits(ManifestoPoint, _React$Component);
	
	  function ManifestoPoint(args) {
	    _classCallCheck(this, ManifestoPoint);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.state = {};
	    _this.PointConstant = [{
	      id: 0,
	      pointText: "Winpe partners will step up efforts for diversity in hiring by pushing for a diverse talent pipeline and incorporating a blind screening process (including redacted CVs removing names and other indications of gender, case studies). The diversity targets for inward talent pipeline will be set on a confidential basis to maintain merit and credibility in hiring."
	    }, {
	      id: 1,
	      pointText: "Winpe and its partners will support mid career women professionals from the industry through a structured mentorship program to be run by WinPE."
	    }, {
	      id: 2,
	      pointText: "Winpe partners will introduce a conversation on diversity within their firms and portfolio companies, enhancing awareness and sensitization within the ecosystem."
	    }, {
	      id: 3,
	      pointText: "Winpe partners will seek for their portfolio companies to measure appropriate diversity metrics and report annually."
	    }, {
	      id: 4,
	      pointText: "Winpe partners will ask for commitment and measurement on Equal Pay at KMP level in portfolio companies."
	    }, {
	      id: 5,
	      pointText: "Winpe partners will support outreach at campuses that are hiring grounds for the industry to champion awareness among female candidates."
	    }];
	    return _this;
	  }
	
	  ManifestoPoint.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "section__content" },
	      _react2.default.createElement(
	        "div",
	        { className: "manifest__wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "manifest__section" },
	          _react2.default.createElement(
	            "div",
	            { className: "manifest_content" },
	            _react2.default.createElement("div", { className: "low__heading" }),
	            _react2.default.createElement(
	              "div",
	              { className: "" },
	              _react2.default.createElement(_Heading2.default, { title: "Winpe Member Manifesto" })
	            ),
	            _react2.default.createElement(
	              _reactAnimateOnScroll2.default,
	              {
	                delay: 0,
	                duration: 2,
	                animateIn: "slideInUp",
	                offset: 600
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "manifest_intro_text" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "intro_text" },
	                  "Winpe mission partners have collectively identified the following priorities for their joint action towards enhancing gender diversity within the investing ecosystem:"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "manifest_point_section" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "manifest_point_text" },
	                  _react2.default.createElement(
	                    "ol",
	                    null,
	                    this.PointConstant.map(function (item, i) {
	                      return _react2.default.createElement(
	                        "li",
	                        { key: i },
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          item.pointText
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ManifestoPoint;
	}(_react2.default.Component);
	
	exports.default = ManifestoPoint;

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ManifestoPoint = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(704);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ManifestoPoint = exports.ManifestoPoint = function (_React$Component) {
		_inherits(ManifestoPoint, _React$Component);
	
		function ManifestoPoint(args) {
			_classCallCheck(this, ManifestoPoint);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
			_this.state = {};
			return _this;
		}
	
		ManifestoPoint.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				{ className: "section__content" },
				_react2.default.createElement(
					"div",
					{ className: "newfooter__wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "newfooter__section" },
						_react2.default.createElement(
							"div",
							{ className: "" },
							_react2.default.createElement(_Heading2.default, { title: "Updates" })
						),
						_react2.default.createElement(
							"div",
							{ className: "newfooter_content" },
							_react2.default.createElement(
								"div",
								{ className: "row" },
								_react2.default.createElement(
									"div",
									{ className: "col-lg-4 col-md-4" },
									_react2.default.createElement(
										"div",
										{ className: "left_newfooter" },
										_react2.default.createElement(
											"div",
											{ className: "card_h" },
											_react2.default.createElement(
												_gatsbyLink2.default,
												{ to: "/insights/holdingmyown" },
												_react2.default.createElement(
													"div",
													{ className: "left_card" },
													_react2.default.createElement(
														"div",
														{ className: "left_img" },
														_react2.default.createElement("img", { src: "https://winpeforum.com/assets/elements/Nupur_Garg_profile_updated_section.jpg", alt: "", className: "img-responsive" })
													),
													_react2.default.createElement(
														"div",
														{ className: "left_heading" },
														"Being the Change"
													),
													_react2.default.createElement(
														"div",
														{ className: "left_sub_heading" },
														"Nupur Garg of Winpe"
													),
													_react2.default.createElement("div", { className: "left_type" }),
													_react2.default.createElement(
														"div",
														{ className: "left_date" },
														"Winpe Indights \u20226 OCTOBER 2020"
													)
												)
											)
										)
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "col-lg-4 col-md-4" },
									_react2.default.createElement(
										"div",
										{ className: "mid_newfooter" },
										_react2.default.createElement(
											"div",
											{ className: "card_h" },
											_react2.default.createElement(
												"div",
												{ className: "top_mid_section" },
												_react2.default.createElement(
													"div",
													{ className: "mid_heading" },
													"Upcoming Events"
												),
												_react2.default.createElement(
													"div",
													{ className: "top_event_sevtion" },
													_react2.default.createElement(
														"div",
														{ className: "row" },
														_react2.default.createElement(
															"div",
															{ className: "col-lg-8 col-md-8" },
															_react2.default.createElement(
																"div",
																{ className: "event_text" },
																"Winpe ProClub Mentorship Program: Launch"
															)
														),
														_react2.default.createElement(
															"div",
															{ className: "col-lg-4 col-md-4" },
															_react2.default.createElement(
																"div",
																{ className: "date" },
																"6 OCT 2020"
															)
														)
													)
												),
												_react2.default.createElement(
													"div",
													{ className: "top_event_sevtion" },
													_react2.default.createElement(
														"div",
														{ className: "row" },
														_react2.default.createElement(
															"div",
															{ className: "col-lg-8 col-md-8" },
															_react2.default.createElement(
																"div",
																{ className: "event_text" },
																"Winpe Collegium"
															)
														),
														_react2.default.createElement(
															"div",
															{ className: "col-lg-4 col-md-4" },
															_react2.default.createElement(
																"div",
																{ className: "date" },
																"30 SEP 2020"
															)
														)
													)
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "last_mid_section" },
												_react2.default.createElement(
													"div",
													{ className: "mid_heading" },
													"Resources"
												),
												_react2.default.createElement(
													"div",
													{ className: "last_event_sevtion" },
													_react2.default.createElement(
														"div",
														{ className: "event_text" },
														"Women in the Workplace"
													),
													_react2.default.createElement(
														"div",
														{ className: "event_subtext" },
														"McKinsey & Company"
													),
													_react2.default.createElement(
														"div",
														{ className: "date" },
														"September 2020 | Report "
													)
												),
												_react2.default.createElement(
													"div",
													{ className: "last_event_sevtion" },
													_react2.default.createElement(
														"div",
														{ className: "event_text" },
														"Project 3.0: Tracking Venture Capital, Private Equity and Private Debt with a Gender Lens"
													),
													_react2.default.createElement(
														"div",
														{ className: "event_subtext" },
														"Wharton Social Impact Initiative & Catalyst at Large"
													),
													_react2.default.createElement(
														"div",
														{ className: "date" },
														"July 2020 | Report"
													)
												)
											)
										)
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "col-lg-4 col-md-4" },
									_react2.default.createElement(
										"div",
										{ className: "right_newfooter" },
										_react2.default.createElement(
											"div",
											{ className: "card_h" },
											_react2.default.createElement(
												_gatsbyLink2.default,
												{ to: "/press" },
												_react2.default.createElement(
													"div",
													{ className: "right_card" },
													_react2.default.createElement(
														"div",
														{ className: "right_img" },
														_react2.default.createElement("img", { src: "https://winpeforum.com/assets/elements/WinpeProclub_press.jpg", alt: "", className: "img-responsive" })
													),
													_react2.default.createElement(
														"div",
														{ className: "right_heading" },
														"Business Standard"
													),
													_react2.default.createElement(
														"div",
														{ className: "right_sub_heading" },
														"Russell Reynolds Associates and Winpe launch pioneering mentorship program for women in investing"
													),
													_react2.default.createElement(
														"div",
														{ className: "right_date" },
														"October 2020 | Press Release"
													)
												)
											)
										)
									)
								)
							)
						)
					)
				)
			);
		};
	
		return ManifestoPoint;
	}(_react2.default.Component);
	
	exports.default = ManifestoPoint;

/***/ }),

/***/ 704:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(16);
	
	__webpack_require__(721);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WinpeBtn = function (_React$Component) {
		_inherits(WinpeBtn, _React$Component);
	
		function WinpeBtn() {
			_classCallCheck(this, WinpeBtn);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		WinpeBtn.prototype.render = function render() {
			var _props = this.props,
			    title = _props.title,
			    onClick = _props.onClick;
	
			return _react2.default.createElement(
				_reactBootstrap.Button,
				{ onClick: onClick, className: "btn btn-default winpe__btn" },
				title
			);
		};
	
		return WinpeBtn;
	}(_react2.default.Component);
	
	exports.default = WinpeBtn;
	
	
	WinpeBtn.propTypes = {
		title: _propTypes2.default.string,
		onClick: _propTypes2.default.string
	};
	module.exports = exports["default"];

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.About = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(707);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	__webpack_require__(8);
	
	var _reactAnimateOnScroll = __webpack_require__(10);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = exports.About = function (_React$Component) {
	  _inherits(About, _React$Component);
	
	  function About(args) {
	    _classCallCheck(this, About);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.state = {};
	    return _this;
	  }
	
	  About.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "section__content" },
	      _react2.default.createElement(
	        "div",
	        { className: "about__wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "about__section" },
	          _react2.default.createElement(
	            "div",
	            { className: "about_content" },
	            _react2.default.createElement(
	              "div",
	              { className: "" },
	              _react2.default.createElement(_Heading2.default, { title: "Overview" })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                { className: "left_section" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "left_content" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "left_text" },
	                    _react2.default.createElement(
	                      _reactAnimateOnScroll2.default,
	                      {
	                        delay: 0,
	                        duration: 2,
	                        animateIn: "zoomIn",
	                        offset: 300
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "winpe__quotes" },
	                        " ",
	                        "Private equity and venture capital lag other industries in diversity statistics",
	                        " "
	                      ),
	                      _react2.default.createElement("div", { className: "red_border" })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "left_video" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "left_video_section" },
	                        _react2.default.createElement("iframe", {
	                          className: "resp-iframe",
	                          style: { margin: "0 auto" },
	                          width: "100%",
	                          src: "https://www.youtube.com/embed/iu6jR-ANYls",
	                          frameBorder: "0",
	                          allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
	                          allowFullScreen: true
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "right_section" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "right_content" },
	                  _react2.default.createElement(
	                    _reactAnimateOnScroll2.default,
	                    {
	                      delay: 0,
	                      duration: 2,
	                      animateIn: "slideInRight",
	                      offset: 600
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "div",
	                          { className: "right_text" },
	                          "Winpe is a pioneering, not for profit platform to bring about transformation in the investing world in favour of gender diversity."
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "right_text" },
	                          "Winpe is the industry forum where stakeholders come together to set the diversity agenda and lead collective action to create gender balance in the investing ecosystem. Winpe is committed to catalysing action in increasing participation of women as investors, capital allocators and as recipients of investment capital, through a well-rounded and holistic approach that engages key stakeholders of the investing industry."
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "right_text" },
	                          "Although women make up roughly half of the available talent pool, they continue to be significantly underrepresented among the investment decision-makers at private equity and venture capital (PEVC) firms, as well as in the leadership of companies that receive this investment capital. Gender balance in investors is a powerful agent for driving diversity in boardrooms, in the c-suite, within the workplace and within business linkages. Gender and diversity is a top-down agenda and the dialogue has to start at the very top of the capital structure, where corporate ownership resides and where all key decisions originate."
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "section_divider1" },
	          _react2.default.createElement("img", {
	            src: "https://winpeforum.com/assets/elements/Section_divier_gray.png",
	            width: "100%",
	            alt: "Section_divier_gray",
	            className: "img-responsive"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "section_divider" },
	          _react2.default.createElement("img", {
	            src: "https://winpeforum.com/assets/elements/phone_section_divider.png",
	            width: "100%",
	            alt: "Section_divier_gray",
	            className: "img-responsive"
	          })
	        )
	      )
	    );
	  };
	
	  return About;
	}(_react2.default.Component);
	
	exports.default = About;

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.HomeSection = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(711);
	
	var _reactParallax = __webpack_require__(81);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(8);
	
	var _reactAnimateOnScroll = __webpack_require__(10);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import $ from "jquery"
	
	
	// const image1 =
	// "https://winpeforum.com/assets/elements/alicorn_hero_banner2.jpg";
	var image1 = "https://winpeforum.com/assets/elements/HeroImg.jpg";
	
	var HomeSection = exports.HomeSection = function (_React$Component) {
	  _inherits(HomeSection, _React$Component);
	
	  function HomeSection(args) {
	    _classCallCheck(this, HomeSection);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.state = {};
	    return _this;
	  }
	
	  HomeSection.prototype.componentDidMount = function componentDidMount() {
	    // $(document).ready(function(){
	    // 	$('.parallax').parallax();
	    // });
	  };
	
	  HomeSection.prototype.render = function render() {
	    var insideStyles = {
	      background: "white",
	      padding: 20,
	      position: "absolute",
	      top: "50%",
	      left: "50%",
	      transform: "translate(-50%,-50%)"
	    };
	    return _react2.default.createElement(
	      "div",
	      { className: "section__content" },
	      _react2.default.createElement(
	        "div",
	        { className: "homeSection__wrapper" },
	        _react2.default.createElement(
	          _reactParallax.Parallax,
	          { bgImage: image1, strength: 450 },
	          _react2.default.createElement(
	            "div",
	            { style: { height: "100%" }, className: "homeSection__section" },
	            _react2.default.createElement(
	              "div",
	              { className: "homeSection_content" },
	              _react2.default.createElement(
	                "div",
	                { className: "text_section" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "homeSection_text" },
	                  _react2.default.createElement(
	                    _reactAnimateOnScroll2.default,
	                    {
	                      delay: 0,
	                      duration: 2,
	                      animateIn: "slideInRight",
	                      offset: 600
	                    },
	                    "DIVERSITY IS NOW"
	                  )
	                ),
	                _react2.default.createElement("div", { className: "down_border" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "homeSection_text1" },
	                  _react2.default.createElement(
	                    _reactAnimateOnScroll2.default,
	                    {
	                      delay: 0,
	                      duration: 2,
	                      animateIn: "slideInLeft",
	                      offset: 600
	                    },
	                    "Women in Private Equity"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "home_btn_section" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "hone_btn" },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: "/events/" },
	                      _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                          delay: 0,
	                          duration: 1,
	                          animateIn: "zoomIn",
	                          offset: 100
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          null,
	                          "Upcoming Events"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "hone_btn" },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: "/connect/" },
	                      _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                          delay: 0,
	                          duration: 1,
	                          animateIn: "zoomIn",
	                          offset: 100
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          null,
	                          "Connect"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return HomeSection;
	}(_react2.default.Component);
	
	exports.default = HomeSection;

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.OverView = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(716);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OverView = exports.OverView = function (_React$Component) {
		_inherits(OverView, _React$Component);
	
		function OverView(args) {
			_classCallCheck(this, OverView);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
			_this.state = {};
			return _this;
		}
	
		OverView.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				{ className: "section__content", style: { display: "none" } },
				_react2.default.createElement(
					"div",
					{ className: "overview__wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "overview__section" },
						_react2.default.createElement(
							"div",
							{ className: "overview_content" },
							_react2.default.createElement(
								"div",
								{ className: "low__heading" },
								"Overview"
							),
							_react2.default.createElement(
								"div",
								{ className: "" },
								_react2.default.createElement(_Heading2.default, { title: "About Winpe" })
							),
							_react2.default.createElement(
								"div",
								{ className: "sub_text" },
								"Winpe is a not for profit, pioneering platform for the private equity (PE) industry, to bring about transformation of mindsets in favour of gender diversity, while helping to create more opportunities for women in PE."
							)
						)
					)
				)
			);
		};
	
		return OverView;
	}(_react2.default.Component);
	
	exports.default = OverView;

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Partners = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(717);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	__webpack_require__(8);
	
	var _reactAnimateOnScroll = __webpack_require__(10);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/P3.png";
	var icon3 = "https://winpeforum.com/assets/elements/cpdq-new.png";
	var icon4 = "https://winpeforum.com/assets/elements/P5.png";
	var icon5 = "https://winpeforum.com/assets/elements/P6.png";
	var icon6 = "https://winpeforum.com/assets/elements/P2.png";
	var icon7 = "https://winpeforum.com/assets/elements/P7.png";
	var icon8 = "https://winpeforum.com/assets/elements/P4.png";
	var icon9 = "https://winpeforum.com/assets/elements/Sequoia_edit_Logo.png";
	var icon10 = "https://winpeforum.com/assets/elements/sidbi_logo.png";
	var icon11 = "https://winpeforum.com/assets/elements/Multiples_Logo.png";
	var icon12 = "https://winpeforum.com/assets/elements/warburg_pincus_logo.png";
	var icon13 = "https://winpeforum.com/assets/elements/IVCA_Logo.png";
	var icon14 = "https://winpeforum.com/assets/elements/MegaDelta_Logo.png";
	var icon15 = "https://winpeforum.com/assets/elements/Truenorthlogo1.png";
	var icon16 = "https://winpeforum.com/assets/elements/GeneralAtlantic_logo.jpg";
	var icon17 = "https://winpeforum.com/assets/elements/kkr_logo1_250x250.png";
	var icon18 = "https://winpeforum.com/assets/elements/Apax_Logo.png";
	var icon19 = "https://winpeforum.com/assets/elements/postkalaari.png";
	var icon20 = "https://winpeforum.com/assets/elements/paragon.png";
	var icon21 = "https://winpeforum.com/assets/elements/RRA_Logo_Blue_RGB_PNG.png";
	var icon22 = "https://winpeforum.com/assets/elements/Arpwood_250x250.png";
	var icon23 = "https://winpeforum.com/assets/elements/UN_Women_logo.png";
	var icon24 = "https://winpeforum.com/assets/elements/CDC_logo.png";
	var icon25 = "https://winpeforum.com/assets/elements/Advent_International_Logo.png";
	var icon26 = "https://winpeforum.com/assets/elements/Investcorp-logo.png";
	
	var icon27 = "https://winpeforum.com/assets/elements/IronPillar_Logo-021.png";
	
	var icon28 = "https://winpeforum.com/assets/BX_BORDER_RGB-01.png";
	var icon29 = "https://winpeforum.com/assets/elements/ChrysCapital.png";
	var icon30 = "https://winpeforum.com/assets/elements/cppib.png";
	var icon31 = "https://winpeforum.com/assets/elements/SupplyChainLabs.png";
	var icon32 = "https://winpeforum.com/assets/elements/menterra.png";
	
	var icon33 = "https://winpeforum.com/assets/elements/trifecta.png";
	var icon34 = "https://winpeforum.com/assets/elements/fidelis.png";
	var icon35 = "https://winpeforum.com/assets/elements/niif.png";
	var icon36 = "https://winpeforum.com/assets/elements/aavishkarcapital.png";
	var icon37 = "https://winpeforum.com/assets/elements/tpglogo.png";
	var icon38 = "https://winpeforum.com/assets/elements/BII.png";
	var associatePartners = [{
	  imgUrl: icon13,
	  logoName: "partners logo",
	  url: "https://ivca.in/"
	}];
	
	var knowledgePartners = [{
	  imgUrl: icon21,
	  logoName: "partners logo",
	  url: "https://www.russellreynolds.com/"
	}, {
	  imgUrl: icon31,
	  logoName: "partners logo",
	  url: "https://supplychainlabs.in/"
	}, {
	  imgUrl: icon23,
	  logoName: "partners logo",
	  url: "https://www.unwomen.org/en"
	}];
	
	var foundingPartners = [{
	  imgUrl: icon36,
	  logoName: "partners logo",
	  url: "https://aavishkaarcapital.in/"
	}, {
	  imgUrl: icon25,
	  logoName: "partners logo",
	  url: "https://www.adventinternational.com/"
	}, {
	  imgUrl: icon18,
	  logoName: "partners logo",
	  url: "https://www.apax.com/"
	}, {
	  imgUrl: icon22,
	  logoName: "partners logo",
	  url: "https://arpwood-partners.com/"
	}, {
	  imgUrl: icon1,
	  logoName: "partners logo",
	  url: "https://www.azbpartners.com/"
	}, {
	  imgUrl: icon6,
	  logoName: "partners logo",
	  url: "https://www.a91partners.com/"
	}, {
	  imgUrl: icon38,
	  logoName: "partners logo",
	  url: "https://www.bii.co.uk/en/"
	}, {
	  imgUrl: icon28,
	  logoName: "partners logo",
	  url: "https://www.blackstone.com/"
	}, {
	  imgUrl: icon3,
	  logoName: "partners logo",
	  url: "https://www.cdpq.com/en"
	}, {
	  imgUrl: icon29,
	  logoName: "partners logo",
	  url: "http://www.chryscapital.com/"
	}, {
	  imgUrl: icon30,
	  logoName: "partners logo",
	  url: "https://www.cppinvestments.com/"
	}, {
	  imgUrl: icon8,
	  logoName: "partners logo",
	  url: "https://www.everstonecapital.com/"
	}, {
	  imgUrl: icon34,
	  logoName: "partners logo",
	  url: "https://https://www.fidelisworld.com/"
	}, {
	  imgUrl: icon4,
	  logoName: "partners logo",
	  url: "http://www.gajacapital.com/"
	}, {
	  imgUrl: icon16,
	  logoName: "partners logo",
	  url: "https://www.generalatlantic.com/"
	}, {
	  imgUrl: icon26,
	  logoName: "partners logo",
	  url: "https://www.investcorp.com/"
	}, {
	  imgUrl: icon27,
	  logoName: "Iron Pillar logo",
	  url: ""
	}, {
	  imgUrl: icon17,
	  logoName: "kkr logo",
	  url: "https://www.kkr.com/"
	}, {
	  imgUrl: icon5,
	  logoName: "partners logo",
	  url: "http://www.lhfunds.com/"
	}, {
	  imgUrl: icon14,
	  logoName: "partners logo",
	  url: "http://www.megadeltacapital.com/"
	}, {
	  imgUrl: icon32,
	  logoName: "partners logo",
	  url: "https://www.menterra.com/"
	}, {
	  imgUrl: icon11,
	  logoName: "partners logo",
	  url: "http://www.multiplesequity.com/"
	}, {
	  imgUrl: icon35,
	  logoName: "partners logo",
	  url: "https://www.niifindia.in/"
	}, {
	  imgUrl: icon20,
	  logoName: "partners logo",
	  url: "http://www.paragonpartners.in/"
	}, {
	  imgUrl: icon9,
	  logoName: "partners logo",
	  url: "https://www.sequoiacap.com/india/"
	}, {
	  imgUrl: icon33,
	  logoName: "partners logo",
	  url: "https://trifectacapital.in/"
	}, {
	  imgUrl: icon7,
	  logoName: "partners logo",
	  url: "https://www.trilegal.com/"
	}, {
	  imgUrl: icon37,
	  logoName: "partners logo",
	  url: "https://tpg.com/"
	}, {
	  imgUrl: icon15,
	  logoName: "partners logo",
	  url: "https://truenorth.co.in/"
	}, {
	  imgUrl: icon12,
	  logoName: "partners logo",
	  url: "https://www.warburgpincus.com/"
	}];
	
	var Partners = exports.Partners = function (_React$Component) {
	  _inherits(Partners, _React$Component);
	
	  function Partners(args) {
	    _classCallCheck(this, Partners);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.state = {};
	
	    _this.foundingPartners = [];
	
	    _this.Partners = [{
	      imgUrl: icon36,
	      logoName: "partners logo",
	      url: "https://aavishkaarcapital.in/"
	    }, {
	      imgUrl: icon25,
	      logoName: "partners logo",
	      url: "https://www.adventinternational.com/"
	    }, {
	      imgUrl: icon18,
	      logoName: "partners logo",
	      url: "https://www.apax.com/"
	    }, {
	      imgUrl: icon22,
	      logoName: "partners logo",
	      url: "https://arpwood-partners.com/"
	    }, {
	      imgUrl: icon1,
	      logoName: "partners logo",
	      url: "https://www.azbpartners.com/"
	    }, {
	      imgUrl: icon6,
	      logoName: "partners logo",
	      url: "https://www.a91partners.com/"
	    }, {
	      imgUrl: icon24,
	      logoName: "partners logo",
	      url: "https://www.cdcgroup.com/"
	    }, {
	      imgUrl: icon3,
	      logoName: "partners logo",
	      url: "https://www.cdpq.com/en"
	    }, {
	      imgUrl: icon8,
	      logoName: "partners logo",
	      url: "https://www.everstonecapital.com/"
	    }, {
	      imgUrl: icon4,
	      logoName: "partners logo",
	      url: "http://www.gajacapital.com/"
	    }, {
	      imgUrl: icon16,
	      logoName: "partners logo",
	      url: "https://www.generalatlantic.com/"
	    }, {
	      imgUrl: icon26,
	      logoName: "partners logo",
	      url: "https://www.investcorp.com/"
	    }, {
	      imgUrl: icon27,
	      logoName: "Iron Pillar logo",
	      url: "https://ironpillarfund.com/"
	    }, {
	      imgUrl: icon13,
	      logoName: "partners logo",
	      url: "https://ivca.in/"
	    }, {
	      imgUrl: icon19,
	      logoName: "partners logo",
	      url: "https://www.kalaari.com/"
	    }, {
	      imgUrl: icon17,
	      logoName: "kkr logo",
	      url: "https://www.kkr.com/"
	    }, {
	      imgUrl: icon5,
	      logoName: "partners logo",
	      url: "http://www.lhfunds.com/"
	    }, {
	      imgUrl: icon14,
	      logoName: "partners logo",
	      url: "http://www.megadeltacapital.com/"
	    }, {
	      imgUrl: icon32,
	      logoName: "partners logo",
	      url: "https://www.menterra.com/"
	    }, {
	      imgUrl: icon11,
	      logoName: "partners logo",
	      url: "http://www.multiplesequity.com/"
	    }, {
	      imgUrl: icon20,
	      logoName: "partners logo",
	      url: "http://www.paragonpartners.in/"
	    }, {
	      imgUrl: icon21,
	      logoName: "partners logo",
	      url: "https://www.russellreynolds.com/"
	    }, {
	      imgUrl: icon9,
	      logoName: "partners logo",
	      url: "https://www.sequoiacap.com/india/"
	    }, {
	      imgUrl: icon7,
	      logoName: "partners logo",
	      url: "https://www.trilegal.com/"
	    }, {
	      imgUrl: icon15,
	      logoName: "partners logo",
	      url: "https://truenorth.co.in/"
	    }, {
	      imgUrl: icon12,
	      logoName: "partners logo",
	      url: "https://www.warburgpincus.com/"
	    }];
	    return _this;
	  }
	
	  Partners.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "section__content" },
	      _react2.default.createElement(
	        "div",
	        { className: "partners__wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "partners__section" },
	          _react2.default.createElement(
	            "div",
	            { className: "partners_content" },
	            _react2.default.createElement("div", { className: "low__heading" }),
	            _react2.default.createElement(
	              "div",
	              { className: "" },
	              _react2.default.createElement(_Heading2.default, { title: "Partners in the cause" })
	            ),
	            _react2.default.createElement(
	              _reactAnimateOnScroll2.default,
	              {
	                delay: 0,
	                duration: 3,
	                animateIn: "zoomIn",
	                offset: 300
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "right_new_section" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "right_content_new" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "partners_logo_new" },
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "h3",
	                      { className: "partners-heading" },
	                      "Winpe Founding Members"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      foundingPartners.map(function (item, i) {
	
	                        if (i >= 0 && i < 28) {
	                          return _react2.default.createElement(
	                            "div",
	                            {
	                              className: " col-md-2 col-sm-12 col-xs-12 col-lg-2",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "p_card", style: { marginLeft: '0%' } },
	                              _react2.default.createElement(
	                                "a",
	                                {
	                                  href: item.url,
	                                  target: "__blank",
	                                  className: ""
	                                },
	                                _react2.default.createElement("img", {
	                                  src: item.imgUrl,
	                                  alt: item.logoName,
	                                  className: "img-responsive",
	                                  style: { width: '260px' }
	                                })
	                              )
	                            )
	                          );
	                        }
	                        if (i == 28) {
	                          return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "col-sm-12 col-xs-12 col-lg-2 col-md-2  ",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "p_card", style: { marginRight: '0%' } },
	                              _react2.default.createElement(
	                                "a",
	                                {
	                                  href: item.url,
	                                  target: "__blank",
	                                  className: ""
	                                },
	                                _react2.default.createElement("img", {
	                                  src: item.imgUrl,
	                                  alt: item.logoName,
	                                  className: "img-responsive"
	
	                                })
	                              )
	                            )
	                          );
	                        }
	
	                        return _react2.default.createElement(
	                          "div",
	                          {
	                            className: "col-md-2 col-sm-12 col-xs-12 col-lg-2",
	                            key: i
	                          },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "p_card" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                href: item.url,
	                                target: "__blank",
	                                className: ""
	                              },
	                              _react2.default.createElement("img", {
	                                src: item.imgUrl,
	                                alt: item.logoName,
	                                className: "img-responsive"
	                              })
	                            )
	                          )
	                        );
	                      })
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col col-12 col-lg-3" },
	                        _react2.default.createElement(
	                          "h3",
	                          { className: "partners-heading" },
	                          "Associate Partner"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          associatePartners.map(function (item, i) {
	                            return _react2.default.createElement(
	                              "div",
	                              { className: "col-12  ", key: i },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "p_card" },
	                                _react2.default.createElement(
	                                  "a",
	                                  {
	                                    href: item.url,
	                                    target: "__blank",
	                                    className: ""
	                                  },
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.logoName,
	                                    className: "img-responsive apartner-img", style: { maxWidth: '280px' }, npm: true
	                                  })
	                                )
	                              )
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col col-12 col-lg-9" },
	                        _react2.default.createElement(
	                          "h3",
	                          { className: "partners-heading" },
	                          "Knowledge Partners"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          knowledgePartners.map(function (item, i) {
	                            return _react2.default.createElement(
	                              "div",
	                              { className: "col-12 col-md-4", key: i },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "p_card" },
	                                _react2.default.createElement(
	                                  "a",
	                                  {
	                                    href: item.url,
	                                    target: "__blank",
	                                    className: ""
	                                  },
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.logoName,
	                                    className: "img-responsive kpartners-img", style: { maxWidth: '250px' }
	                                  })
	                                )
	                              )
	                            );
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "section_divider" },
	          _react2.default.createElement("img", {
	            src: "https://winpeforum.com/assets/elements/phone_section_divider.png",
	            width: "100%",
	            alt: "Section_divier_gray",
	            className: "img-responsive"
	          })
	        )
	      )
	    );
	  };
	
	  return Partners;
	}(_react2.default.Component);
	
	exports.default = Partners;

/***/ }),

/***/ 717:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Partners = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(718);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Modal = __webpack_require__(9);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(8);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _team_constants = __webpack_require__(157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide,
	      style: { margin: "0% auto 0px" }
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item_des" },
	          _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.post } })
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	var Partners = exports.Partners = function (_React$Component) {
	  _inherits(Partners, _React$Component);
	
	  function Partners(args) {
	    _classCallCheck(this, Partners);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      activeItem: {},
	      isShow: false
	    };
	    return _this;
	  }
	
	  Partners.prototype.render = function render() {
	    var _this2 = this;
	
	    var isShow = this.state.isShow;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "section__content" },
	      _react2.default.createElement(
	        "div",
	        { className: "team__wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "team__section" },
	          _react2.default.createElement(
	            "div",
	            { className: "team_content" },
	            _react2.default.createElement("div", { className: "low__heading" }),
	            _react2.default.createElement(
	              "div",
	              { className: "" },
	              _react2.default.createElement(_Heading2.default, { title: "Leading from the front" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "team_member" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _team_constants.team_constants.map(function (item, i) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "tcard col-lg-3 col-md-4 col-sm-6", key: i },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "mem_card" },
	                      _react2.default.createElement(
	                        "div",
	                        { onClick: function onClick() {
	                            return _this2.togglePopUp(item);
	                          } },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "t_img" },
	                          _react2.default.createElement("img", { src: item.imgUrl, alt: item.name })
	                        ),
	                        _react2.default.createElement("div", { className: "t_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "t_name" },
	                          item.name
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "t_post" },
	                          _react2.default.createElement("div", {
	                            dangerouslySetInnerHTML: { __html: item.post }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "social_link" },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              rel: "noopener noreferrer",
	                              href: item.link,
	                              target: "_blank",
	                              className: ""
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-linkedin" })
	                          )
	                        )
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "volunteer_section" },
	              _react2.default.createElement(
	                "div",
	                { className: "volunteer_text" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "volunteer_link" },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: "/ambassadors/" },
	                    "Winpe Ambassadors"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(TeamModal, {
	          show: isShow,
	          onHide: this.togglePopUp,
	          activeItem: this.state.activeItem
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "section_divider1" },
	          _react2.default.createElement("img", {
	            src: "https://winpeforum.com/assets/elements/Section_divier_gray.png",
	            width: "100%",
	            alt: "section_divider",
	            className: "img-responsive"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "section_divider" },
	          _react2.default.createElement("img", {
	            src: "https://winpeforum.com/assets/elements/phone_section_divider.png",
	            width: "100%",
	            alt: "section_divider",
	            className: "img-responsive"
	          })
	        )
	      )
	    );
	  };
	
	  return Partners;
	}(_react2.default.Component);
	
	exports.default = Partners;

/***/ }),

/***/ 718:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Vision = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(720);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	__webpack_require__(8);
	
	var _reactAnimateOnScroll = __webpack_require__(10);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/vision3.png";
	var icon2 = "https://winpeforum.com/assets/elements/vision1.png";
	var icon3 = "https://winpeforum.com/assets/elements/vision2.png";
	
	var Vision = exports.Vision = function (_React$Component) {
	  _inherits(Vision, _React$Component);
	
	  function Vision(args) {
	    _classCallCheck(this, Vision);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.state = {};
	    _this.Partners = [{
	      imgUrl: icon1,
	      text: "#Engage",
	      subText: "Engage with firms within the investing ecosystem and their decision makers in a constructive and open dialogue on the opportunities of gender diversity with an intent to drive collective action on a mutual agenda."
	    }, {
	      imgUrl: icon2,
	      text: "#Empower",
	      subText: "Empower the women who are part of the investing industry with a set of training, networking and mentoring resources designed to help them thrive and succeed."
	    }, {
	      imgUrl: icon3,
	      text: "#Enhance",
	      subText: "Enhance the participation of female talent in the investing ecosystem, foster an environment and working practices make it an attractive career option for women."
	    }];
	    return _this;
	  }
	
	  Vision.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "section__content" },
	      _react2.default.createElement(
	        "div",
	        { className: "vision__wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "vision__section" },
	          _react2.default.createElement(
	            "div",
	            { className: "vision_content" },
	            _react2.default.createElement(
	              "div",
	              { className: "left_section" },
	              _react2.default.createElement(
	                "div",
	                { className: "left_content" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "left_text" },
	                  _react2.default.createElement(
	                    _reactAnimateOnScroll2.default,
	                    {
	                      delay: 0,
	                      duration: 2,
	                      animateIn: "zoomIn",
	                      offset: 300
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "winpe__quotes" },
	                      _react2.default.createElement(
	                        "span",
	                        { className: "" },
	                        _react2.default.createElement("i", {
	                          className: "fa fa-quote-left",
	                          "aria-hidden": "true"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        " ",
	                        "Gender diversity within the investing ecosystem is within the influence of each constituent of this ecosystem and the change that Winpe aims to catalyse is best led by these constituents.",
	                        " "
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        { style: { Verticalalign: "top" } },
	                        _react2.default.createElement("i", {
	                          className: "fa fa-quote-right",
	                          "aria-hidden": "true"
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement("div", { className: "left_subtext" })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "right_section" },
	              _react2.default.createElement(
	                _reactAnimateOnScroll2.default,
	                {
	                  delay: 0,
	                  duration: 2,
	                  animateIn: "slideInRight",
	                  offset: 600
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "right_content" },
	                  _react2.default.createElement("div", { className: "low__heading" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "" },
	                    _react2.default.createElement(_Heading2.default, { title: "The Winpe Vision" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "right_text" },
	                    "Winpe believes change can only be witnessed when we combine dialogue with action. Based on this philosophy, Winpe engages with the leaders and influencers to drive culture change, while providing a suite of powerful resources to support women who are part of this industry or who aspire to be."
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "rightPoint_secton" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      this.Partners.map(function (item, i) {
	                        return _react2.default.createElement(
	                          "div",
	                          { className: "point_box", key: i },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "point_text" },
	                            item.text
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "subText" },
	                            item.subText
	                          )
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "vision__buttons" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "/winpecharter/",
	                      className: "vision__buttons__button"
	                    },
	                    "Winpe Charter"
	                  ),
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "vision__buttons__button",
	                      href: "/membermanifesto/"
	                    },
	                    "Winpe Member Manifesto"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "section_divider1" },
	          _react2.default.createElement("img", {
	            src: "https://winpeforum.com/assets/elements/Section_divier_gray.png",
	            width: "100%",
	            alt: "",
	            className: "img-responsive"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "section_divider" },
	          _react2.default.createElement("img", {
	            src: "https://winpeforum.com/assets/elements/phone_section_divider.png",
	            width: "100%",
	            alt: "",
	            className: "img-responsive"
	          })
	        )
	      )
	    );
	  };
	
	  return Vision;
	}(_react2.default.Component);
	
	exports.default = Vision;

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var icon1 = "https://winpeforum.com/assets/elements/Nupur_Garg_profile_piC 300X292.jpg";
	var icon2 = "https://winpeforum.com/assets/elements/ZiaMody_edit.jpg";
	var icon4 = "https://winpeforum.com/assets/elements/Renuka-Ramnath.png";
	var icon3 = "https://winpeforum.com/assets/elements/CDPQ_mem1.jpg";
	var icon5 = "https://winpeforum.com/assets/elements/esterNew.jpg";
	var icon6 = "https://winpeforum.com/assets/elements/matangi.jpg";
	var icon7 = "https://winpeforum.com/assets/elements/shyamala.jpg";
	var iconamb1 = "https://winpeforum.com/assets/elements/winpe_v_team1.png";
	var iconamb2 = "https://winpeforum.com/assets/elements/winpe_v_team2.png";
	var iconamb3 = "https://winpeforum.com/assets/elements/winpe_v_team3.png";
	var iconamb4 = "https://winpeforum.com/assets/elements/Chandni.jpg";
	var iconamb5 = "https://winpeforum.com/assets/elements/Krunali_1.JPG";
	var iconamb6 = "https://winpeforum.com/assets/ambassadors/vidhi_jain_amb.jpg";
	
	var iconamb7 = "https://winpeforum.com/assets/ambassadors/Aparna_Jain_amb.jpg";
	
	var iconamb8 = "https://winpeforum.com/assets/ambassadors/priyanka_chandak_amb.jpg";
	var iconamb9 = "https://winpeforum.com/assets/ambassadors/Sanchi_Khurana_amb.jpg";
	var iconamb10 = "https://winpeforum.com/assets/ambassadors/Pooja_Parmar_amb.jpg";
	
	var iconamb11 = "https://winpeforum.com/assets/ambassadors/Pooja_Sharoff_amb.jpg";
	
	var iconamb12 = "https://winpeforum.com/assets/ambassadors/Ishita_Suri_amb.jpg";
	
	var iconamb13 = "https://winpeforum.com/assets/ambassadors/Shikha_Pareek_amb.jpg";
	
	var iconamb14 = "https://winpeforum.com/assets/ambassadors/Vidhi_Dosh_amb.jpg";
	
	var iconamb15 = "https://winpeforum.com/assets/ambassadors/Swati_Bhartia_amb.jpg";
	
	var iconamb16 = "https://winpeforum.com/assets/ambassadors/shivani_tannu_amb.jpg";
	var iconamb17 = "https://winpeforum.com/assets/ambassadors/akanksha_gupta_amb.jpeg";
	var iconamb18 = "https://winpeforum.com/assets/ambassadors/anshul_jain_amb.jpg";
	
	var iconamb19 = "https://winpeforum.com/assets/ambassadors/shriya_basul_amb.jpeg";
	var iconamb20 = "https://winpeforum.com/assets/ambassadors/AditiKumar.jpg";
	var iconamb21 = "https://winpeforum.com/assets/ambassadors/KiranSharma.jpg";
	var iconamb22 = "https://winpeforum.com/assets/ambassadors/PrachiChavda.jpg";
	var iconamb23 = "https://winpeforum.com/assets/ambassadors/PrachiMalpani.jpg";
	var iconamb24 = "https://winpeforum.com/assets/ambassadors/SaakshiGera.jpg";
	
	var team_constants = [{
	  imgUrl: icon1,
	  // into:"Nupur Garg is a leading investor in private equity and venture capital and an expert advisor to large institutional investors. Nupur’s experience spans private equity investing, operations and finance in leading global organizations like IFC – an arm of the World Bank Group, Discovery Networks and PwC.",
	  desc: "<div> Nupur Garg is a leading investor in private equity and venture capital and an expert advisor to large institutional investors. She is the founder of Winpe, a not-for-profit initiative to enhance gender diversity in the investing ecosystem.<br/><br/> Nupur serves as Chairperson of the board of Kids Clinic India Limited and an independent director on the boards of companies including Indigo Paints Limited, Kerala Infrastructure Fund Management Limited and SIDBI, the Indian development finance institution. She is an independent member of the investment committee at the Fund of Funds managed by the National Investment and Infrastructure Fund (NIIF), the quasi sovereign wealth fund sponsored by the government of India, and an advisor to and a member of the investment committee for the Dutch Good Growth Fund (DGGF) investment funds mandate given by the Dutch government for investments in SMEs in frontier markets across 75 countries. She has served as an external expert on the investment committee for the INR 10,000 crore Fund of Fund for Start-ups for investing in the Indian start-up ecosystem. Nupur advises select fund managers on a confidential basis on matters related to institutionalization, best practices and governance. She also mentors female entrepreneurs across various platforms. <br/><br/>\n        \n    Nupur was listed in the BW VC World Most Influential Women 2022, Forbes W-Power list of Self Made Women 2020, among India's top 100 Women Leaders in Finance (AIWMI 2019), awarded the Women Empowerment Entrepreneur Award 2019-20 and the Business Excellence and Innovative Best Practices - Academia Award 2019. <br/><br/>\nIn her last and most recent full time role, Nupur led the private equity and venture capital funds business in the region for IFC and is widely credited with establishing IFC's brand and credibility as one of the most respected institutional investors in this space. Under her stewardship, the portfolio doubled in size and returns, moving from a negative IRR to delivering gains for the first time in its history. <br/><br/>Nupur is a CA and an MBA from MIT Sloan School of Management, with executive education from Harvard Business School. Nupur loves to spend time with her mother, husband and 6 year-old son, travel to new places, read and do 1000-piece puzzles.\n\t\t\t\t</div>",
	  name: "Nupur Garg",
	  post: "<div>Founder, Winpe <br /> Investor & Independent Director</div>",
	  link: "https://www.linkedin.com/in/nupurgarg/"
	}, {
	  imgUrl: icon3,
	  // into:"Anita M. George is Executive Vice-President and Deputy Head of CDPQ Global. She fills a key role in developing CDPQ’s activities in its three priority international areas: the United States/Latin America, Europe and Asia Pacific. She actively participates in positioning CDPQ internationally, as well as developing and executing its globalization strategy.",
	  desc: "<div>Anita M. George is Executive Vice-President and Deputy Head of CDPQ Global. She fills a key role in developing CDPQ\u2019s activities in its three priority international areas: the United States/Latin America, Europe and Asia Pacific. She actively participates in positioning CDPQ internationally, as well as developing and executing its globalization strategy. In addition to her role managing the international offices, Ms. George contributes to diversifying the portfolio by taking a holistic view in approaching the various markets. She sits on CDPQ\u2019s Investment-Risk Committee.\n\t\t\t\t<br />\n\t\t\t\t<br />\n\t\t\t\tMs. George joined CDPQ in April 2016 as Managing Director, South Asia. She was then appointed as Executive Vice-President, Growth Markets and prior to her current role was Executive Vice-President and Head of Strategic Partnerships, Growth Markets. She has extensive knowledge of several of these markets, in addition to possessing a strong ability to develop and strengthen enduring and quality partnerships.\n\t\t\t\t<br />\n\t\t\t\t<br />\n\t\t\t\tShe has a strong track record in managing infrastructure investment portfolios on a global scale. Prior to joining CDPQ, she was Senior Director of the World Bank\u2019s Energy and Extractive Industries Global Practice. She also held the positions of Director, Infrastructure and Natural Resources of the International Finance Corporation, a member of the World Bank Group, and Head of Siemens Financial Services in India. Her various roles have led her to work in several regions of the world, including Europe, Asia, the Middle East, Africa and Latin America.\n\t\t\t\t<br />\n\t\t\t\t<br />\n\t\t\t\tMs. George holds a BA in Economics and Spanish from Smith College, in Massachusetts, and a Masters in Economics and an MBA in Finance from Boston University.\n\t\t\t\t</div>",
	  name: "Anita George",
	  post: "<div>Member, Advisory Board, Winpe <br /> Executive Vice-President & Deputy Head, CDPQ Global</div>",
	  link: "https://www.linkedin.com/in/anita-george-255778133/"
	}, {
	  imgUrl: icon4,
	  // into:"Renuka Ramnath is the Founder, Managing Director and CEO of Multiples Alternate Asset Management, a private equity manager and advisor to funds of ~ USD 1.5 bn. She has over 30 years of experience in the Indian financial sector across private equity, investment banking and structured finance.",
	  desc: "<div>Renuka Ramnath is the Founder, Managing Director and CEO of Multiples Alternate Asset Management, a private equity manager and advisor to funds of ~ USD 1.5 bn. She has over 30 years of experience in the Indian financial sector across private equity, investment banking and structured finance. \n\t\t<br />\n\t\t<br />\n\t\tFor close to three decades in financial services, Renuka successfully built several businesses in the ICICI Group including Investment Banking, e-commerce and private equity. As the MD & CEO of ICICI Venture for close to a decade, she led that firm to become one of the largest private equity funds in India.\n\t\t<br />\n\t\t<br />\n\t\tShe is a Board member of EMPEA, the global industry association for private capital in emerging markets. She is also the Chairperson of the Executive Committee of  Indian Venture Capital Association.  Renuka has been featured in many prestigious listings, including the Top 25 Most Powerful Women in Business (Business Today, India); India's most Powerful CEO's (Economic Times), the Top 25 Non Bank Women in Finance (US Banker's global list), Asia's Women in the Mix: The Year's Top 50 for Achievement in Business (Forbes), Top 25 women in Asian asset management (Asian Investor) and most recently has been awarded the AVCJ Special Achievement Award, 2019.\n\t\t</div>",
	  name: "Renuka Ramnath",
	  post: "<div>Member, Advisory Board, Winpe <br /> Founder, MD & CEO, Multiples Alternate Asset Management</div>",
	  link: "https://www.linkedin.com/in/renukaramnath/"
	}, {
	  imgUrl: icon2,
	  // into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
	  name: "Zia J. Mody",
	  desc: "<div>Zia J. Mody, Co\u2013Founder and Managing Partner of AZB & Partners, is one of India\u2019s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India\u2019s \u2018India\u2019s 50 Most Powerful Women in Business\u2019 list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011. \n\t\t<br />\n\t\t<br />\n\t\tZia has held and continues to hold several prestigious positions at global and national levels. She currently serves as a Member, Governing Board \u2013 International Council for Commercial Arbitration (ICCA) and Member \u2013 CII National Council. She was the Vice President & Member \u2013 London Court of International Arbitration (LCIA) and Member \u2013 World Bank Administrative Tribunal, Washington D.C.. In addition, Zia has served in various capacities on several committees and panels set up by Indian regulatory bodies including SEBI, RBI, Law Commission of India and Ministry of Corporate Affairs.\n\t\t<br />\n\t\t<br />\n\t\tZia has been a recipient of numerous awards recognizing her individual and professional achievements as a legal practitioner and leader. She completed her masters in law from the Harvard Law School and is a member of the New York State Bar Association. Zia\u2019s practice areas include Mergers & Acquisitions, Private Equity, Restructuring and General Corporate, Compliance & Investigation, Dispute Resolution, and Regulatory & Securities Law.\n\t\t</div>",
	  post: "<div>Member, Advisory Board, Winpe <br /> Co\u2013Founder & Managing Partner, AZB & Partners</div>",
	  link: "https://www.linkedin.com/in/ziamody"
	}, {
	  imgUrl: icon5,
	  // into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
	  name: "Ester Martinez",
	  desc: "<div>Ms. Ester Martinez is the CEO & Editor-in-Chief at People Matters, the fastest-growing community for CHROs and business leaders committed to the advancement of talent & work practices for sustainable business impact.\n\t\t<br />\n\t\t<br />\n\t\tIn 2009, upon sensing the need for a platform to deliberate on talent management, leadership and hold critical insights on people & future of work for C-suite audience, Ms. Martinez founded People Matters and rapidly grew it to become one of the few successes in independent publishing and a brand synonymous to knowledge and digital innovation in people and work-tech space. And today the brand is a name to reckon with not just in India, but also globally, with a special focus on Southeast Asia.\n\t\t<br />\n\t\t<br />\n\t\tA people\u2019s person at heart, Ms. Martinez holds a Postgraduate degree in Human Resources Management from EADA (Spain) and a Master of Business Administration from Indian School of Business (ISB), Hyderabad.\n\t\t<br />\n\t\t<br />\n\t\tWith more than 15 years of experience in human resources, Ms. Martinez has a wealth of knowledge in the areas of talent, learning & development and work-tech. Until 2008, she worked as a professional manager with a host of blue chip companies such as Hewlett Packard and Tata Consultancy Services, both in India and the UK.\n\t\t<br />\n\t\t<br />\n\t\tA much sought-after speaker on leadership and future of work, Ms. Martinez was recognized as a top influencer on employee engagement by The Employee Engagement Awards, and top influencer in HR Technology by Recruiting Daily. Ms. Martinez was also featured in the 2016 & 2018 LinkedIn Top Voices List, which ranks the top writers on LinkedIn for the year. She is also a renowned TEDx speaker and was nominated for the Global Employee Engagement Influencers 2017.\n\t\t</div>",
	  post: "<div>Member, Advisory Board, Winpe Proclub <br /> CEO & Editor-in-Chief, People Matters</div>",
	  link: "https://www.linkedin.com/in/estermartinez"
	}, {
	  imgUrl: icon6,
	  // into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
	  name: "Matangi Gowrishankar",
	  desc: "<div>Ms. Matangi Gowrishankar brings more than three decades of experience as a business, Human Resources and Change Management specialist. Passionate about leadership and organization development she has a track record in organization transformation and talent management both in India and overseas.\n\t\t<br />\n\t\t<br />\n\t\tShe has worked with several large multinational organizations like Standard Chartered Bank, Reebok, GE, Cummins Inc and most recently, with the British Oil Major BP plc where her last assignment was Global Head of Capability Development and Director of the Leadership Academy. She has extensive, diverse experience having lived and worked in the UK and Singapore with a broad geographical remit across several countries.\n\t\t<br />\n\t\t<br />\n\t\tMs. Gowrishankar has a BA in Sociology and a Post Graduate qualification in Human Resources from XLRI, a premier educational institution in India. She is a certified coach from the Neuroleadership Group (previously Results Coaching) Australia. Ms. Gowrishankar also holds certifications from SHL (Saville & Holdsworth) for designing and conduct of Assessment Centres, Instructional Design and Facilitation Skills from Skill Base UK.\n\t\t<br />\n\t\t<br />\n\t\tToday, with an independent organization development practice, Ms. Gowrishankar continues to work with BP and other organizations coaching, guiding and facilitating leaders to transform self and the organization to meet the challenges of doing business in a highly volatile and dynamic environment. She has experience in leading several D&I initiatives including highly successful development offers for women both in India and overseas. Her credo is to make a positive difference to individuals and organizations. She believes in enduring partnerships built on trust and mutual respect. She is committed to leveraging diversity of thought and the human spirit for achieving the best outcomes.\n\t\t<br />\n\t\t<br />\n\t\tMs. Gowrishankar also holds Non - Executive Independent Directorships with 8 companies in India across diverse industries.\n\t\t<br />\n\t\t<br />\n\t\tShe has been a regular speaker at Indian and global conferences and has contributed to several case study commentaries in Indian business magazines.\n\t\t<br />\n\t\t<br />\n\t\tMs. Gowrishankar and her mother live in Pune, India. Her son, an event management specialist lives in Melbourne, Australia.\n\t\t</div>",
	  post: "<div>Member, Advisory Board, Winpe Proclub <br /> Independent Director, Strategic Advisor & Certified Coach</div>",
	  link: "https://www.linkedin.com/in/matangi-gowrishankar-0814a74/"
	}, {
	  imgUrl: icon7,
	  // into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
	  name: "Shyamala Gopinath",
	  desc: "<div>Ms. Shyamala Gopinath has 41 years of rich experience in financial sector policy formulation in different capacities at Reserve Bank of India (RBI). At RBI, she held key positions and guided & influenced national policies in diverse areas of financial sector regulation and supervision, the development and regulation of financial markets, capital account management, management of government borrowings, foreign exchange reserve management and payment and settlement systems.\n\t\t<br />\n\t\t<br />\n\t\tShe has served on several committees while with RBI. During 2001 to 2003, she was deputed as Senior Financial Expert at the International Monetary Fund. Ms. Gopinath retired as Deputy Governor of RBI, a position that she held for nearly 7 years. She served as Chairperson Advisory Board on Bank, Commercial and Financial Frauds for two years from 2012 to 2014.\n\t\t<br />\n\t\t<br />\n\t\tMs. Gopinath was also the Chairperson of the Board of Corporate Bonds and Securitisation Advisory Committee of SEBI.\n\t\t<br />\n\t\t<br />\n\t\tSince 2012, Ms. Gopinath has held several Board positions in large corporates and public sector undertakings such as Clearing Corporation of India, Indian Oil Corporation Limited, GAIL and Ernst & Young (Global Governance Council). Presently, Ms. Gopinath serves as Independent Director on the Boards of other renowned companies. She is a part-time Non-Executive Chairperson of HDFC Bank Ltd. and Chairperson of the Board of Governors of Indian Institute of Management, Raipur.\n\t\t</div>",
	  post: "<div>Member, Advisory Board, Winpe Proclub <br /> Non-Executive Chairperson, HDFC Bank Ltd</div>",
	  link: "https://www.linkedin.com/in/shyamala-gopinath-21b41578/"
	}];
	
	var ambassadors_team_current = [{
	  imgUrl: iconamb20,
	  name: "Aditi Kumar",
	  desc: "<div>\n    Aditi Kumar is an Asst. Vice President at HDFC's Venture Investment's arm. Prior to HDFC, she was part of the core M&A team at Delhivery, and also helped the company file for IPO. She has also worked as Investment Associate with Orios Venture Partners, as an Investment Analyst with NEA (New Enterprise Associates), and was a Consultant with the Guggenheim. Aditi earned her Economics and Mathematics degrees at New York University (NYU), minoring in Computer Science. Her thesis was an intersection of her majors and focused on, \u201Cgauging market sentiment with regards to commodity fluctuation\u201D. She was also awarded the President's Service Award, based on her contributions to the NYU community during her time at NYU.\n\t\t</div>",
	  post: "AVP, Venture Investments, HDFC",
	  designation: "AVP, Venture Investments",
	  company: "HDFC",
	  link: "https://www.linkedin.com/in/aditinkumar/"
	}, {
	  imgUrl: iconamb18,
	  name: "Anshul Jain",
	
	  desc: "<div>\n    Anshul is the co-head of Investments at Lighthouse Funds and has led firm\u2019s investments in Nykaa, Duroflex Mattress and Aqualite Footwear. Prior to joining Lighthouse Funds, Anshul has worked as an investment banker, advising clients on IPO, M&A and PE fundraising at ICICI Securities and ABN-Amro. Anshul holds a Master\u2019s degree in Business Administration from IIM Indore.\n\t\t</div>",
	  post: "Managing Director, Lighthouse Advisors",
	  designation: "Managing Director",
	  company: "Lighthouse Advisors",
	  link: "https://www.linkedin.com/in/anshul-jain-3584321/"
	}, {
	  imgUrl: iconamb7,
	  name: "Aparna Jain",
	
	  desc: "<div>\n    Aparna Jain is a Manager in the Portfolio Management function at Multiples since 2020. In\nher immediate previous role, she worked with Deloitte and EY in their Forensic Diligence\npractice for more than 4 years. Prior to Forensics, she was with CRISIL in their Global Ratings\nteam for Structured Finance instruments. She is a Chartered Accountant and completed her\narticles with PwC from 2011 to 2014. She graduated from H.R. College, Mumbai during the\nsame period.\n\t\t</div>",
	  post: "Manager - Portfolio Management, Multiples Alternate Asset Management",
	  designation: "Manager - Portfolio Management",
	  company: "Multiples Alternate Asset Management",
	  link: "https://www.linkedin.com/in/aparna-jain-38813180/"
	}, {
	  imgUrl: iconamb21,
	  name: "Kiran Sharma",
	
	  desc: "<div>\n    International investment professional, with about 7 years of experience investing in frontier and emerging markets along with deep experience in financial modelling, valuations, and investor relations. Responsible for building investment pipeline, evaluation of investment opportunities, investment due diligence of companies at start-up stage and growth stage. Play a key role in portfolio management for Indian companies.<br/><Br/>\nPreviously worked with Deloitte in financial advisory services in valuations and financial modelling practice. Have actively led marquee valuation engagements including publicly listed companies and fortune 500 companies. I have played an instrumental role in setting up the investor relations department and conceptualizing the investor relations strategy at Gati Limited (Leading Logistics Company in India).I hold an Executive MBA from Narsee Monjee Institute of Management Studies and B Com from M S University Vadodara\n\n\t\t</div>",
	  post: "Impact Investments, Accion",
	  designation: "Impact Investments",
	  company: "Accion",
	  link: "https://www.linkedin.com/in/kiran-sharma-she-her-822a4956/"
	}, {
	  imgUrl: iconamb10,
	  name: "Pooja Parmar",
	  desc: "<div>\n    Pooja is Senior Associate at Equanimity. She has been working at Equanimity for more than 5 years. Prior to Equanimity she has worked with Housing.com as a finance business partner to the product, tech and design teams. She has done her articleship with PwC in the financial services group. Pooja is a Chartered Accountant and a commerce graduate from Narsee Monjee College.\n\n    </div>",
	  post: "Senior Associate, Equanimity Investments",
	  designation: "Senior Associate",
	  company: "Equanimity Investments",
	
	  link: "https://www.linkedin.com/in/pooja-parmar-69712789/"
	}, {
	  imgUrl: iconamb22,
	  name: "Prachi Chavda",
	  desc: "<div>\n    Prachi Chavda, an alumna of IIT Bombay, class of 2017, is part of the investment team at Jackdaw Capital. She previously worked at IIM-Ahmedabad\u2019s incubator, CIIE.CO, in sector research for blockchain, biotech, InsurTech & other sectors. Prior to this, she worked with RBL Bank (India) across payments, fintech-bank partnerships, and digital banking products.\n\n    </div>",
	  post: "VC Investments, Jackdaw Capital",
	  designation: "VC Investments",
	  company: "Jackdaw Capital",
	
	  link: "https://www.linkedin.com/in/prachi-chavda-77713781/"
	}, {
	  imgUrl: iconamb23,
	  name: "Prachi Malpani",
	  desc: "<div>\n    Prachi is an investment analyst currently helping with sourcing deals across deep tech B2B space. She has expertise in market research.\n\n\n    </div>",
	  post: "Investment Analyst, Mela Ventures",
	  designation: "Investment Analyst",
	  company: "Mela Ventures",
	
	  link: "https://www.linkedin.com/in/prachi-malpani-a9709758/"
	}, {
	  imgUrl: iconamb2,
	  name: "Rochelle D'Souza",
	  desc: "<div>Rochelle D'Souza is Managing Director at Lighthouse Advisors. Prior to Lighthouse Advisors, she was a Manager at SBI Capital Markets, Investment Banking Division, where she focused on equity capital market transactions.\n\t\t<br />\n\t\t<br />\n\t\tRochelle earned a Bachelor of Engineering in Electronics & Communication from Rashtreeya Vidyalaya College of Engineering (RVCE) and an MBA from S.P. Jain Institute of Management & Research. She is also a CFA Level III candidate.\n\t\t</div>",
	  post: "Managing Director, Lighthouse Advisors",
	  designation: "Managing Director",
	  company: "Lighthouse Advisors",
	  link: "https://in.linkedin.com/in/rochelle-dsouza-448169b"
	}, {
	  imgUrl: iconamb24,
	  name: "Saakshi Gera",
	  desc: "<div>\n    Saakshi joined Kedaara Capital in November 2020 and has 11 years of experience in investing / investment banking. Prior to joining Kedaara Capital, Saakshi served as an Executive Director at Goldman Sachs, Principal Investing Arm (India office), where she focused on investments in financial services, IT services and energy sector. Some of the investments she worked on include Max Financial, ReNew Power, Noveltech Feeds, and BPL Medical. Previously, she was part of the investment team at Providence Equity Partners and GTI Capital. She started her career with investment banking at Nomura. Saakshi has completed all levels of the CFA program (USA). She has done BA Economics from Delhi University, where she was a rank holder. \n    </div>",
	  post: " Principal, Kedaara Capital",
	  designation: "Principal",
	  company: "Kedaara Capital",
	  link: "https://www.linkedin.com/in/saakshi-gera-424aa639/"
	}, {
	  imgUrl: iconamb9,
	  name: "Sanchi Khurana",
	  desc: "<div>\n    Sanchi is part of the Ventures Team at Recharge Capital, an asset management firm based out of New York with USD 6B in AUM. At Recharge, Sanchi looks at global fintech investments at the Seed/Series-A stage. Prior to Recharge, Sanchi was part of the Investments Team at Kalaari Capital, a leading early-stage tech VC fund based out of India with USD 1Bn+ in AUM. Sanchi holds an undergraduate degree from Shri Ram College of Commerce (B.Com Hons).\n\n    </div>",
	  post: "Investment Professional",
	  designation: "",
	  company: " Investment Professional",
	  link: "https://www.linkedin.com/in/sanchi-khurana-a365b0b8/"
	}, {
	  imgUrl: iconamb13,
	  name: "Shikha Pareek",
	  desc: "<div>\n    Shikha is an Investment Professional with the Credit and Special Situations team at KKR India. Previously, she was part of the India investment banking team at Bank of America and UBS respectively and has worked across sectors including consumer retail, health-care and technology. She is a Chartered Accountant by training\n    </div>",
	  post: "Investment Professional, KKR & Co. India",
	  designation: "Investment Professional",
	  company: "KKR & Co. India",
	  link: "https://www.linkedin.com/in/shikha-pareek/"
	}, {
	  imgUrl: iconamb6,
	  name: "Vidhi Jain",
	  desc: "<div>Vidhi is an Investment Professional at HDFC. Prior to this, she worked as an Associate with the Edelwiess Investment Banking team aligned to the FIG Sector. Started her professional career with Deloitte in their Financial Due Diligence Team. She completed her Masters in Finance from Cranfield University, UK and has a Bachelors in Commerce and Business Administration.\n\t\t</div>",
	  post: "Investment Professional, HDFC",
	  designation: "Investment Professional",
	  company: "HDFC",
	  link: "https://www.linkedin.com/in/vidhi-jain-8168bb99"
	}];
	
	var ambassadors_team_previous = [{
	  imgUrl: iconamb17,
	  name: "Akanksha Gupta",
	
	  desc: "<div>\n    Akanksha Gupta is an investment professional with 5+ years of experience working across diverse sectors (consumers, mid-caps and financial services). She is currently working with a large US bank. Prior to that she worked with HSBC. She holds PGDM in Finance from IIM Ranchi and B.E from PEC-UT. She is FRM charterholder and CFA Level 3 candidate. \n  \t</div>",
	  // post: "Associate, JP Morgan Chase",
	  post: "Equity Research Analyst",
	  designation: "Equity Research Analyst",
	  company: "",
	  // company: "JP Morgan Chase",
	  link: "https://www.linkedin.com/in/akanksha-gupta-frm-75532476/"
	}, {
	  imgUrl: iconamb4,
	  name: "Chandni Chetani",
	  desc: "<div>Chandni is an Investment Professional at SSG Advisors. Before joining SSG, she was an Analyst at Moelis & Company, where she focused on M&A deals across sectors. Prior to that, she worked with JP Morgan\u2019s Investment Banking Team. She is a CA, CS and a CFA Level III candidate.\n\t\t</div>",
	  post: "Investment Professional, SSG Advisors",
	  designation: "Investment Professional",
	  company: "SSG Advisors",
	  link: "https://www.linkedin.com/in/chandni-chetani-3a6b32105/"
	}, {
	  imgUrl: iconamb5,
	  name: "Krunali Shah",
	  desc: "<div>Krunali Shah is an Investment Associate at A91 Partners. She did her summer internship with Multiples in 2019 and was at Boston Consulting Group as an Associate in 2018. Prior to that, she completed her three years of articleship from Baker Tilly DHC in the valuations division. Krunali graduated from Narsee Monjee College, Mumbai in 2016 and completed her MBA from IIM Ahmedabad in 2020 where she earned a gold medal for all round performance. She is also a rankholder Chartered Accountant.\n\t\t</div>",
	  post: "Investment Associate, A91 Partners",
	  designation: "Investment Associate",
	  company: "A91 Partners",
	  link: "https://www.linkedin.com/in/krunali-shah-397a52a6/"
	}, {
	  imgUrl: iconamb12,
	  name: "Ishita Suri",
	  desc: "<div>\n    Prior to joining Amicus Capital in 2020, Ishita worked at J.P. Morgan for over three years with the Financial Institutions Group as an investment banking analyst. During this tenure, Ishita was involved in Mergers & Acquisitions and Capital market transactions for companies across Banking, Insurance and other financial services.\n    <br/><br/>\nIshita holds a Bachelor of Engineering in Electronics and Communication from PEC University of Technology, Chandigarh and has cleared the CFA Level II examination.\n\n    </div>",
	  post: "Analyst, Amicus Capital",
	  designation: "Analyst",
	  company: "Amicus Capital",
	  link: "https://www.linkedin.com/in/ishitasuri/"
	}, {
	  imgUrl: iconamb1,
	  desc: "Nitya Khemlani is the Head of Investor Relations at Lighthouse. Previously Nitya worked as a Conference Producer for PEI Media (Hong Kong), organizing conferences and investor round tables across the private equity, private real estate and infrastructure asset classes in Asia. Nitya was also earlier a Research Associate for Linneman Associates, where she focused on researching and analyzing economic trends with a focus on the U.S. housing sector.\n\t\t<br />\n\t\t<br />\n\t\tNitya earned a Bachelor of Science in International Business Management and Economics (magna cum laude) from the University of Tampa and a Masters in Economics from the University of Warwick.\n\t\t</div>",
	  name: "Nitya Khemlani",
	  post: "Head of Investor Relations, Lighthouse Advisors",
	  designation: "Head of Investor Relations",
	  company: "Lighthouse Advisors",
	  link: "https://in.linkedin.com/in/nitya-khemlani-461b49ab/de"
	}, {
	  imgUrl: iconamb11,
	  name: "Pooja Sharoff",
	  desc: "<div>\n    Pooja Sharoff is an Associate in the SSG team at KPMG India. Previously, she has worked at EY focusing on M&A Advisory in the Financial Services sector; and at Tata Strategic Management Group. She completed her MBA from Indian School of Business and her Masters in Commerce from Mumbai University. She is also a CFA Level III Candidate.\n    </div>",
	  post: "Senior Associate - SSG Team, KPMG India",
	  designation: "Senior Associate - SSG Team",
	  company: "KPMG India",
	  link: "https://www.linkedin.com/in/pooja-sharoff-9555192b/"
	}, {
	  imgUrl: iconamb8,
	  name: "Priyanka Chandak",
	  desc: "<div>\n    Priyanka Chandak is a Venture Capital Fellow at Kalaari Capital and has previously worked at Hindustan Unilever Ltd. supporting the sales function as a finance business partner. She completed her Bachelor\u2019s in Commerce from St. Xavier\u2019s College, Kolkata in 2017 and qualified as a Chartered Accountant in 2019. As an active advocate of equities investing, she is passionate about discussing personal finance. In her leisure time, she engages in meeting new people, reading and refining her public speking skills. \n    </div>",
	  post: "Venture Capital Fellow, Kalaari Capital",
	  designation: "Venture Capital Fellow",
	  company: "Kalaari Capital",
	  link: "https://www.linkedin.com/in/priyankachandak/"
	}, {
	  imgUrl: iconamb2,
	  name: "Rochelle D'Souza",
	  desc: "<div>Rochelle D'Souza is a Principal at Lighthouse Advisors. Prior to Lighthouse Advisors, she was a Manager at SBI Capital Markets, Investment Banking Division, where she focused on equity capital market transactions.\n\t\t<br />\n\t\t<br />\n\t\tRochelle earned a Bachelor of Engineering in Electronics & Communication from Rashtreeya Vidyalaya College of Engineering (RVCE) and an MBA from S.P. Jain Institute of Management & Research. She is also a CFA Level III candidate.\n\t\t</div>",
	  post: "Principal, Lighthouse Advisors",
	  designation: "Principal",
	  company: "Lighthouse Advisors",
	  link: "https://in.linkedin.com/in/rochelle-dsouza-448169b"
	}, {
	  imgUrl: iconamb16,
	  name: "Shivani Tannu",
	  desc: "<div>\n    Shivani Tannu is an Investment Banking Associate at Avendus Capital, Mumbai. Prior to this, she earned her Master of Business Administration (MBA) at the Indian Institute of Management (IIM), Bangalore. \n    She has completed all levels of the Chartered Accountancy course in 2015. She was selected as part of \u2018Goldman Sachs\u2019 Women Emerging in Finance\u2019 cohort of 2020 and was also awarded the \u2018Women in Banking\u2019 Scholarship by Citi Bank, NA. \n    During her free time she likes to read books and keep up with the Indian startup ecosystem.\n    </div>",
	  post: "Investment Banking Associate, Avendus Capital",
	  designation: "Investment Banking Associate",
	  company: "Avendus Capital",
	  link: "https://www.linkedin.com/in/shivanitannu/"
	}, {
	  imgUrl: iconamb19,
	  name: "Shriya Bahul",
	  desc: "<div>With a background in development economics and finance, Shriya has always been passionate\n    about working in the impact space. Her current work entails focusing on investments that\n    promote access to finance, clean and green energy and women owned businesses. She strongly\n    believes that investing in women can have a multiplier effect on the economy by not only\n    encouraging other younger women but also enabling investors to generate additional revenue\n    streams. At Winpe she hopes to collaborate closely with Women Entrepreneurs to help them\n    scale businesses and facilitate them in the fundraising processes.</div>",
	  post: "Investment Analyst, IFC",
	  designation: "Investment Analyst",
	  company: "IFC",
	  link: "https://www.linkedin.com/in/shriya-bahul-8512517a/"
	}, {
	  imgUrl: iconamb3,
	  name: "Sreeja Vasantham",
	  desc: "<div>Sreeja is an Investment Professional at General Atlantic and focuses on firm\u2019s investments in India and Asia Pacific. Before joining General Atlantic, she was an Analyst at Moelis & Company, where she worked across sectors. Prior to that, she worked in Citi India\u2019s investment banking arm. She graduated from IIT Bombay in 2016 with a Bachelors in Electrical Engineering.\n\t\t</div>",
	  post: "Investment Professional, General Atlantic",
	  designation: "Investment Professional",
	  company: "General Atlantic",
	  link: "https://in.linkedin.com/in/sreeja-vasantham-ba449974"
	}, {
	  imgUrl: iconamb15,
	  name: "Swati Bhartia",
	  desc: "<div>Swati is a Vice President at Tata Capital Healthcare Fund. She has over 15 years of experience in private equity investments and equity research domain. Before joining Tata Capital she was working with Oman India Joint Investment Fund (OIJIF), where she was involved in deal evaluation, execution and monitoring investments in diverse sectors such as healthcare, machine tools, auto ancillaries, specialty chemicals and pharmaceuticals. Prior to that, Swati worked with Eredene Capital, an AIM listed USD 100 Mn PE fundShe started her career with Crisil as equity Research Analyst in 2005, covering European mid & large-cap Biotech companies. Swati is a 37th rank-holder Chartered Accountant and a CFA charter-holder.\n\t\t</div>",
	  post: "Vice President - Healthcare Fund, Tata Capital Limited",
	  designation: "Vice President - Healthcare Fund",
	  company: "Tata Capital Limited",
	  link: "https://www.linkedin.com/in/swati-bhartia-24a8418/"
	}, {
	  imgUrl: iconamb14,
	  name: "Vidhi Doshi",
	  desc: "<div>Vidhi has over 4+ years of experience in the investment space, where she helped identify, support, and scale businesses across angel syndicate and private equity firms. She has closed 30+ deals, including Innov8 and Purple Style Labs, across various sectors during her career. Originally from Kolkata, she has lived and worked in Mumbai, Bangalore and Gurugram.</div>",
	  post: "Investment Analyst, Eximius Ventures",
	  designation: "Investment Analyst",
	  company: "Eximius Ventures",
	  link: "https://www.linkedin.com/in/vidhi-doshi-118965134/"
	}];
	
	exports.team_constants = team_constants;
	exports.ambassadors_team_current = ambassadors_team_current;
	exports.ambassadors_team_previous = ambassadors_team_previous;

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _HomeView = __webpack_require__(393);
	
	var _HomeView2 = _interopRequireDefault(_HomeView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HomeView2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(236);
	
	var reducer = function reducer(state, action) {
		// console.info("--------------------")
		// console.info("\x1b[36m", "prev state -> ", state)
		// console.info("\x1b[36m", "action", action)
		if (action.type === "INCREMENT") {
			state = _extends({}, state, {
				count: state.count + action.index
			});
			// return state
		}
		if (action.type === "FETCHED_PRODUCT_LIST") {
			var list = action.list;
	
			var listItemById = {};
			var infoListItemById = {};
			var wholeMasalas = [];
			var blendedMasalas = [];
			var specialities = [];
			var pujaMaterials = [];
			list.map(function (item) {
				var _extends2;
	
				infoListItemById = _extends({}, infoListItemById, (_extends2 = {}, _extends2[item.info_id] = item, _extends2));
				if (listItemById[item.id] === undefined || listItemById[item.id] === null) {
					listItemById[item.id] = [];
				}
				if (item.ingredients === "1" && item.type_id === "Spices") {
					wholeMasalas.push(item);
				} else if (item.type_id === "Spices") {
					blendedMasalas.push(item);
				}
				if (item.type_id === "Misc") {
					specialities.push(item);
				} else if (item.type_id === "Dhoop") {
					pujaMaterials.push(item);
				}
				listItemById[item.id].push(item);
			});
			state = _extends({}, state, {
				products: _extends({}, state.products, {
					list: list,
					listItemById: listItemById,
					infoListItemById: infoListItemById,
					wholeMasalas: wholeMasalas,
					blendedMasalas: blendedMasalas,
					specialities: specialities,
					pujaMaterials: pujaMaterials,
					meta: {
						isFetching: false
					}
				})
			});
			// return state
		}
		if (action.type === "ADD_TO_CART") {
			var _list = action.list;
	
			state = _extends({}, state, {
				products: _extends({}, state.products, {
					cart: _list,
					cartChange: !state.products.isCartChange
				})
			});
		}
		// console.info("\x1b[36m", "next state -> ", state)
		// console.info("--------------------")
		// state = { ...stateObj }
		return state;
	};
	
	var initialState = { count: 0, products: { list: [], meta: { isFetching: true }, cart: {}, cartChange: false } };
	
	var createStore = function createStore() {
		return (0, _redux.createStore)(reducer, initialState);
	};
	exports.default = createStore;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-home-index-js-63a3387bf77c9fa3861d.js